<template>
  <div class="header">
    <div class="navmenu w1400" v-if="!isMobile">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt="" />
      </div>
      <div class="menu">
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="rgb(168,0,0)"
          text-color="#FEE8C4"
          active-text-color="#b50000"
          :router="true"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu
            :index="'/partybuildinggarden' + index"
            @click.native="changeSubmenu(index, 0)"
            v-for="(item, index) in menuList"
            :key="index"
            :class="{ showIcon: !item.children }"
          >
            <template slot="title">{{ item.menuName }}</template>
            <div v-if="item.children && item.children.length > 0">
              <el-menu-item
                :index="
                  index === 3
                    ? '/subsidiaryCompanies?from=' + index + '&id=' + k
                    : '/publicpage?from=' + index + '&id=' + k
                "
                v-for="(j, k) in item.children"
                :key="k"
                >{{ j.menuName }}</el-menu-item
              >
            </div>
          </el-submenu>
          
        </el-menu>
      </div>
    </div>
    <div v-if="isMobile">
      <div class="mobile_header">
        <img src="../../assets/images/shanxijk.jpg" alt="" />
        <div class="navbar_header">
          <div class="nav_title" @click="$router.push('/')">网站首页</div>
          <div class="nav_right">
            <i
              class="el-icon-s-fold"
              v-if="!drawer"
              @click="drawer = !drawer"
            ></i>
            <i
              class="el-icon-s-unfold"
              v-if="drawer"
              @click="drawer = !drawer"
            ></i>
          </div>
        </div>
      </div>
      <el-drawer
        title=""
        :visible.sync="drawer"
        direction="ttb"
        size="40%"
        style="width: 100vw; height: 100vh"
        :show-close="false"
        :withHeader="false"
        :modal-append-to-body="false"
      >
        <div
          class="menu_name"
          @click="changeSubmenu(index, 0)"
          v-for="(item, index) in menuList"
          :key="index"
        >
          {{ item.menuName }}
        </div>
      </el-drawer>
      <el-drawer
        title=""
        :visible.sync="drawer_right"
        direction="rtl"
        size="40%"
        style="width: 100vw; height: 100vh"
        :show-close="false"
        :withHeader="false"
      >
        <div class="menu_name" @click="goIndex">首页</div>
        <div
          class="menu_name"
          @click="changeSubmenu($route.query.from, index)"
          v-for="(item, index) in rightList"
          :key="index"
        >
          {{ item.menuName }}
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunityHeader",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "/",
      menuList: [],
      silderList: [],
      rightList: [],
      isMobile: true,
      drawer: false,
      drawer_right: false,
      title: "山西万家寨水控水资源有限公司",
      path: "",
    };
  },
  created() {
    this.HomePageData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    changeSubmenu(from, index) {
      if (from === 2) {
        this.$router.push({
          path: `/publicpage?from=${from}&id=${index}`,
        });
      } else if (from === 5) {
        this.$router.push({
          path: `/informationdisclosure?from=5&id=0`,
        });
      } else {
        (this.activeIndex2 = "/publicpage?from=" + from + "&id=" + index),
          this.$router.push({
            path: `/publicpage?from=${from}&id=${index}`,
          });
      }
      this.drawer = false;
      this.drawer_right = false;
    },
    async HomePageData() {
      this.loading = true;
      const res = {
        msg: "操作成功",
        code: 200,
        data: {
          menuList: [
            {
              createBy: null,
              createTime: "2023-03-16 17:54:18",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2001,
              menuName: "公司概况",
              parentName: null,
              parentId: 2000,
              orderNum: 1,
              path: "aboutus",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "druid",
              children: [
                {
                  createBy: null,
                  createTime: "2023-03-20 11:48:10",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2002,
                  menuName: "集团概况",
                  parentName: null,
                  parentId: 2001,
                  orderNum: 1,
                  path: "synopsis",
                  component: "website/page/index",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:synopsis:query",
                  icon: "clipboard",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-03-11 11:14:41",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2009,
                  menuName: "高层寄语",
                  parentName: null,
                  parentId: 2001,
                  orderNum: 2,
                  path: "blessing",
                  component: "website/page/index",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:blessing:query",
                  icon: "star",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2023-12-05 17:02:40",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2004,
                  menuName: "集团领导",
                  parentName: null,
                  parentId: 2001,
                  orderNum: 3,
                  path: "leader",
                  component: "website/article/leaderIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:leader:list",
                  icon: "peoples",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-02 11:08:19",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2010,
                  menuName: "集团战略",
                  parentName: null,
                  parentId: 2001,
                  orderNum: 4,
                  path: "strategy",
                  component: "website/page/index",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:strategy:query",
                  icon: "guide",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2023-03-27 16:11:33",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2003,
                  menuName: "组织架构",
                  parentName: null,
                  parentId: 2001,
                  orderNum: 6,
                  path: "idea",
                  component: "website/page/index",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:idea:query",
                  icon: "nested",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-03 15:56:24",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2016,
              menuName: "新闻中心",
              parentName: null,
              parentId: 2000,
              orderNum: 2,
              path: "news",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "documentation",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-03 17:21:11",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2017,
                  menuName: "公司新闻",
                  parentName: null,
                  parentId: 2016,
                  orderNum: 1,
                  path: "news",
                  component: "website/article/newsIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:news:list",
                  icon: "documentation",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-07 10:03:21",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2022,
                  menuName: "公司公告",
                  parentName: null,
                  parentId: 2016,
                  orderNum: 2,
                  path: "notice",
                  component: "website/article/newsIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:news:list",
                  icon: "row",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-07 10:20:55",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2027,
                  menuName: "子公司动态",
                  parentName: null,
                  parentId: 2016,
                  orderNum: 3,
                  path: "dynamic",
                  component: null,
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "M",
                  visible: "0",
                  status: "0",
                  perms: "",
                  icon: "nested",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-11 16:29:17",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2148,
                  menuName: "重大事项",
                  parentName: null,
                  parentId: 2016,
                  orderNum: 4,
                  path: "matter",
                  component: "website/article/newsIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:news:list",
                  icon: "clipboard",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-11 16:56:30",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2153,
                  menuName: "脱贫攻坚",
                  parentName: null,
                  parentId: 2016,
                  orderNum: 5,
                  path: "poverty",
                  component: "website/article/newsIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:news:list",
                  icon: "rate",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-15 09:26:09",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2158,
              menuName: "党群工作",
              parentName: null,
              parentId: 2000,
              orderNum: 3,
              path: "party",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "guide",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-15 09:30:55",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2159,
                  menuName: "党建工作",
                  parentName: null,
                  parentId: 2158,
                  orderNum: 1,
                  path: "party",
                  component: "website/article/partyIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:party:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-15 09:54:21",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2164,
                  menuName: "纪检监察",
                  parentName: null,
                  parentId: 2158,
                  orderNum: 2,
                  path: "monitor",
                  component: null,
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "M",
                  visible: "0",
                  status: "0",
                  perms: "",
                  icon: "edit",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-15 10:31:25",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2175,
                  menuName: "群团工作",
                  parentName: null,
                  parentId: 2158,
                  orderNum: 3,
                  path: "alliance",
                  component: "website/article/partyIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:party:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-15 10:40:33",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2180,
                  menuName: "精神文明建设",
                  parentName: null,
                  parentId: 2158,
                  orderNum: 4,
                  path: "civilization",
                  component: "website/article/partyIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:party:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-28 16:13:09",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2228,
                  menuName: "视频《榜样》",
                  parentName: null,
                  parentId: 2158,
                  orderNum: 5,
                  path: "video",
                  component: null,
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "",
                  icon: "#",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-15 10:50:23",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2185,
              menuName: "旗下公司",
              parentName: null,
              parentId: 2000,
              orderNum: 4,
              path: "company",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "cascader",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-15 10:53:58",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2186,
                  menuName: "全资公司",
                  parentName: null,
                  parentId: 2185,
                  orderNum: 1,
                  path: "whollyOwned",
                  component: "website/article/companyIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:company:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-28 10:22:12",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2191,
                  menuName: "控股公司",
                  parentName: null,
                  parentId: 2185,
                  orderNum: 2,
                  path: "holding",
                  component: "website/article/companyIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:company:list",
                  icon: "rate",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-28 14:21:03",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2201,
              menuName: "业务领域",
              parentName: null,
              parentId: 2000,
              orderNum: 5,
              path: "business",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "component",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-28 14:23:43",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2202,
                  menuName: "金融类",
                  parentName: null,
                  parentId: 2201,
                  orderNum: 1,
                  path: "finance",
                  component: "website/article/businessIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:business:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-28 14:27:08",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2207,
                  menuName: "类金融类",
                  parentName: null,
                  parentId: 2201,
                  orderNum: 2,
                  path: "quasiFinance",
                  component: "website/article/businessIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:business:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-28 14:28:22",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2212,
                  menuName: "基金类",
                  parentName: null,
                  parentId: 2201,
                  orderNum: 3,
                  path: "fund",
                  component: "website/article/businessIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:business:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-28 14:29:25",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2217,
                  menuName: "投资类",
                  parentName: null,
                  parentId: 2201,
                  orderNum: 4,
                  path: "invest",
                  component: "website/article/businessIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:business:list",
                  icon: "rate",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-28 14:47:20",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2222,
              menuName: "信息披露",
              parentName: null,
              parentId: 2000,
              orderNum: 6,
              path: "disclosure",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "list",
              children: null,
            },
            {
              createBy: null,
              createTime: "2024-04-30 10:21:08",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2354,
              menuName: "政策法规",
              parentName: null,
              parentId: 2000,
              orderNum: 7,
              path: "regulation",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "clipboard",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-30 10:25:05",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2355,
                  menuName: "基础类法规",
                  parentName: null,
                  parentId: 2354,
                  orderNum: 1,
                  path: "jclRegulation",
                  component: "website/article/regulationIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:regulation:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-30 11:00:42",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2360,
                  menuName: "金融类法规",
                  parentName: null,
                  parentId: 2354,
                  orderNum: 2,
                  path: "jrlRegulation",
                  component: "website/article/regulationIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:regulation:list",
                  icon: "rate",
                  children: [],
                },
              ],
            },
            {
              createBy: null,
              createTime: "2024-04-30 11:10:30",
              updateBy: null,
              updateTime: null,
              remark: null,
              menuId: 2365,
              menuName: "联系我们",
              parentName: null,
              parentId: 2000,
              orderNum: 8,
              path: "contact",
              component: null,
              query: null,
              isFrame: "1",
              isCache: "0",
              menuType: "M",
              visible: "0",
              status: "0",
              perms: "",
              icon: "phone",
              children: [
                {
                  createBy: null,
                  createTime: "2024-04-30 11:12:18",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2366,
                  menuName: "联系方式",
                  parentName: null,
                  parentId: 2365,
                  orderNum: 1,
                  path: "contactInfo",
                  component: null,
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-04-30 11:14:45",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2367,
                  menuName: "人才招聘",
                  parentName: null,
                  parentId: 2365,
                  orderNum: 2,
                  path: "recruit",
                  component: "website/article/recruitIndex",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:recruit:list",
                  icon: "rate",
                  children: [],
                },
                {
                  createBy: null,
                  createTime: "2024-05-07 11:10:51",
                  updateBy: null,
                  updateTime: null,
                  remark: null,
                  menuId: 2372,
                  menuName: "意见征集",
                  parentName: null,
                  parentId: 2365,
                  orderNum: 3,
                  path: "feedback",
                  component: "website/feedback/index",
                  query: null,
                  isFrame: "1",
                  isCache: "0",
                  menuType: "C",
                  visible: "0",
                  status: "0",
                  perms: "website:feedback:list",
                  icon: "rate",
                  children: [],
                },
              ],
            },
          ],
          disclosureList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-28 16:01:28",
              remark: null,
              id: 5303,
              menuId: 2309,
              title:
                "中合盛资本管理有限公司2025年第一季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：中合盛资本管理有限公司 （二）英文名称：Zhong He Sheng Capital Management Co.Ltd （三）法定代表人：李 明 （四）股东名称：山西国信投资集团有限公司、深圳前海亚鑫科智管理公司、山西省交易集团股份有限公司 （五）注册地址：上海市杨浦区国泰路11号704-5室 （六）经营范围：股权投资，股权投资管理，资产管理，投资管理。（依法须经批准的项目，经相关部门批准后方可开展经营活动） （七）办公地址及邮政编码：太原市杏花岭区府西街69号（山西国际贸易中心西塔楼1506），030002 （八）电子信箱: kangshiyu@zhscapital.com.cn （九）简介：中合盛资本管理有限公司于2014年12月在上海自贸区注册成立，2017年迁至上海市杨浦区，注册资金1亿元，是山西金控集团旗下从事私募股权投资和政府投资基金管理的专业机构，也是我省主要的政府投资基金管理机构之一。公司自成立以来，不断优化治理结构，持续完善内控体系，扎实做好政府投资基金管理，大力拓展市场化股权投资业务，较好地完成了所承担各项经营任务。 二、主要财务数据、财务指标、财务会计报告摘要(合并) （一）报告期主要财务数据 单位：万元 项目 2025年一季度 营业收入 773.27 管理费用 663.62 利润总额 109.28 净利润 81.69 （二）报告期主要补充财务数据 单位：万元 项目 2025年3月末 资产 25599.71 负债 2858.05 所有者权益 22741.66 应收款项 400.84 应付款项 0 固定资产净值 39.51 应交税费 793.53 （三）报告期内所有者权益情况 单位：万元 项目 2025年3月末 股本 10000 资本公积 953.32 盈余公积 3393.70 一般风险准备 0 其他综合收益 0 未分配利润 8394.64 归属于母公司股东权益合计 22741.66 少数股东权益 0 所有者权益合计 22741.66 三、环境保护情况 中合盛资本紧密围绕我省产业政策导向，持续布局新能源、新材料、精细化工、储能、生物科技产业，在环境保护问题方面严格按照国家有关法律法规有关规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zhs",
              inputTime: "2025-04-30 10:07:09",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-30 09:58:24",
              remark: null,
              id: 5312,
              menuId: 2284,
              title:
                "山西太行产业投资基金管理有限公司2025年一季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：山西太行产业投资基金管理有限公司 （二）英文名称：Shanxi Taihang Industrial Investment Fund Management Co.,Ltd. （三）法定代表人：谢宏伟 （四）股东名称：山西金融投资控股集团有限公司 （五）注册地址：山西综改示范区太原学府园区长治路308号同昌创业园B座25层 （六）经营范围：管理或受托管理股权类投资并从事相关咨询服务业务（不含国家法律法规、国务院决定限制和禁止的项目；不得以任何方式公开募集和发行基金）（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）。（依法须经批准的项目，经相关部门批准后方可开展经营活动） （七）办公地址及邮政编码：山西综改示范区太原学府园区长治路308号同昌创业园B座25层，030024 （八）电子信箱: sxthcyjj@163.com （九）简介：山西太行产业投资基金管理有限公司（以下简称“太行产业基金公司”）是按照省委省政府战略决策部署，经省政府常务会议决定通过，由山西金融投资控股集团有限公司独资设立的政府产业投资基金管理公司，主要从事政府投资基金的设立与管理，并根据省委省政府安排，落实相关重大经济决策。太行产业基金公司旨在通过不断发展逐步完善政府引导基金管理体系，全面支持山西省创新驱动、转型升级战略，衔接好实体经济和金融资本，成为具有山西特色的基金管理公司，为山西经济社会发展提供更大支撑。 二、主要财务数据、财务指标、财务会计报告摘要 （一）报告期主要财务数据（合并口径） 单位：人民币万元 项目 2025年一季度 营业收入 1111.08 业务及管理费用 734.47 利润总额 359.82 净利润 252.56 （二）报告期主要补充财务数据（合并口径） 单位：人民币万元 项目 2025年3月末 资产 36252.21 负债 1192.02 所有者权益 35060.19 应收款项 5650.51 固定资产净值 33.38 应交税费 162.12 （三）报告期内所有者权益变动情况（合并口径） 单位：人民币万元 项目 2025年一季度 实收资本 20000 资本公积 9940.78 盈余公积 2101.74 一般风险准备 4167.02 未分配利润 -1149.36 归属于母公司股东权益合计 35060.19 少数股东权益 0 所有者权益合计 35060.19 三、环境保护情况 太行产业基金公司高度重视环境保护，积极支持节能环保型企业和节能环保项目。节能降耗、矿山绿化、“三废”治理、环保设施、污染物排放等环境保护问题严格按照国家有关法律法规和有关规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "thjj",
              inputTime: "2025-04-30 09:20:19",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-29 18:22:56",
              remark: null,
              id: 5311,
              menuId: 2344,
              title:
                "山西金控资本管理有限公司2025年第一季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：山西金控资本管理有限公司 （二）英文名称：Shanxi Jinkong Capital Management Co.,Ltd （三）法定代表人：刘鹏飞 （四）股东名称：山西金融投资控股集团有限公司 （五）注册地址：山西转型综合改革示范区学府产业园东渠路西二巷6号一幢C座13层 （六）经营范围：以自有资金对外投资；资产管理（金融类和国家限制的除外）；与不良资产经营相关的权益类、物资类资产管理服务；投资咨询（不含证券、期货、金融咨询及国家法律、行政法规限制内的其他业务）；与投资相关的各类服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动） （七）办公地址及邮政编码：山西转型综合改革示范区学府产业园东渠路西二巷6号一幢C座13层，030000 （八）电子信箱:sxjkzb@shanxifhc.com （九）简介：山西金控资本管理有限公司（简称“金控资本”）成立于2020年03月，注册资本30亿元，是隶属于山西金控集团的国有全资子公司，立足“切实履行引导资金管理平台职责，提升省级政府基金引导效用；发挥平台综合优势，协助推进集团基金板块发展；丰富自有资金投资布局，提升盈利能力”战略定位和使命，充分依托集团公司全牌照金融平台优势，通过私募基金、股权及债权等方式投资推动我省新兴产业集聚发展和重大项目转型升级，重点聚焦能源革命、重点产业链发展、专业镇建设以及国资国企改革等领域，业务范围涵盖半导体、新材料、新能源、先进制造、信息技术应用创新等多个产业项目。 二、主要财务数据、财务指标 （一）报告期主要财务数据 单位：万元　 项目 2025年1-3月 营业收入 540.88 营业支出 236.21 利润总额 304.66 净利润 228.43 （二）报告期主要补充财务数据 　 单位：万元 项目 2025年3月末 资产 223,595.34 负债 3,499.57 所有者权益 220,095.77 固定资产净额 39.33 应交税费 -401.05 （三）报告期内所有者权益变动情况 单位：万元 项目 2025年3月末 股本 190,000.00 盈余公积 1,492.17 未分配利润 8,204.03 少数股东权益 20,370.16 所有者权益合计 220,095.77 三、环境保护情况 山西金控资本管理有限公司在节能降耗、矿山绿化、“三废”治理、环保设施、污染物排放等环境保护问题方面严格按照国家有关法律法规有关规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "jkzb",
              inputTime: "2025-04-29 18:06:30",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-30 10:36:21",
              remark: null,
              id: 5306,
              menuId: 2324,
              title:
                "山西国信医疗健康投资管理有限公司2025年第一季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：山西国信医疗健康投资管理有限公司 （二）英文名称：Shanxi Guoxin Medical&Health Investment co.,Ltd （三）法定代表人：路素军 （四）股东名称：山西国信投资集团有限公司 （五）注册地址：山西省太原市小店区南中环街265号国信嘉园小区1号楼1002号商铺3001室 （六）经营范围：以自有资金对医疗、养老行业投资及资产委托管理（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）；医疗服务；医药咨询服务；企业管理咨询服务；商务咨询服务；会议及展览服务；医疗器械经营：医疗器械批发零售；煤炭批发零售、铁矿石批发 （七）办公地址及邮政编码：山西省太原市小店区南中环街265号国信嘉园小区1号楼1002号商铺3001室030006 （八）电子信箱：598542062@qq.com （九）简介：医投公司成立于2016年10月，注册资本1亿元。作为一家专门投资医疗、健康产业的国有投资机构，致力于构建涵盖医疗供应链、医疗服务、健康管理等为一体的全产业链，服务我省的医疗体制改革，优化医疗资源配置。 二、主要财务数据、财务指标、财务会计报告摘要 （一）报告期主要财务数据 单位：人民币万元 项目 2025年一季度 营业收入 -317.58 业务及管理费用 105.83 利润总额 -423.4 净利润 -423.4 （二）报告期主要补充财务数据 单位：人民币万元 项目 2025年一季度 资产 1425.79 负债 28982.1 所有者权益 -27556.31 存货 0.65 应收账款 600 其他应收款 2.12 固定资产净值 5.42 应交税费 -16.28 应付账款 2.12 其他应付款 28710.87 （三）报告期内所有者权益变动情况 单位：人民币万元 2025年一季度 未分配利润 -26527.36 少数股东权益 -11709.03 所有者权益合计 -27556.31 三、环境保护情况 医投公司所涉行业不涉及节能降耗、矿山绿化、“三废”治理、环保设施、污染物排放等环境保护问题。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "gxyt",
              inputTime: "2025-04-28 09:30:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-30 10:35:54",
              remark: null,
              id: 5304,
              menuId: 2289,
              title:
                "山西省国贸投资集团有限公司2025年第一季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：山西省国贸投资集团有限公司 （二）英文名称：SHANXI GOMO Investment Group Co. Ltd. （三）法定代表人：董菊山 （四）股东名称：山西金融投资控股集团有限公司 （五）注册地址：太原市杏花岭区府西街69号（山西国际贸易中心西塔楼） （六）经营范围：对非上市公司的股权、上市公司非公开发行的股权等非公开交易的股权投资以及相关的咨询服务；自有房屋的租赁；房地产经纪服务；物业服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动） （七）办公地址及邮政编码：太原市杏花岭区府西街69号（山西国际贸易中心西塔楼），030002 （八）网址: www.shanxigomo.com （九）电子信箱:shanxigomo@163.com （十）简介：山西国贸的前身为成立于2002年1月的山西国际贸易中心有限公司，2018年8月14日更名为山西省国贸投资集团有限公司，系山西金融投资控股集团有限公司的全资子公司，注册资本金为36000万元，是一家下辖四个子公司，业务涵盖写字楼综合运营、商业综合管理服务、住宿餐饮、股权投资等多个领域的重要省属企业。 二、主要财务数据、财务指标、财务会计报告摘要 （一）报告期主要财务数据 单位：万元 项目 2025年一季度 营业收入 3857.78 管理费用 1566.37 利润总额 -658.86 净利润 -704.96 （二）报告期主要补充财务数据 单位：万元 项目 2025年3月末 资产 80526.32 负债 37927.08 所有者权益 42599.24 应收款项 2015.48 应付款项 7680.21 固定资产净值 46482.81 应交税费 142.78 （三）报告期内所有者权益变动情况 单位：万元 项目 2025年一季度 股本 36000 资本公积 15842.81 盈余公积 1967.76 未分配利润 -12524.72 归属于母公司 股东权益合计 41285.85 少数股东权益 1313.38 所有者权益合计 42599.23 三、环境保护情况 山西国贸节能降耗、环保设施、污染物排放等环境保护问题严格按照国家有关法律法规有关规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxgm",
              inputTime: "2025-04-25 10:04:04",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-02-19 14:36:08",
              remark: null,
              id: 5242,
              menuId: 2319,
              title:
                "山西省国有投融资管理有限公司 2024年三季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "一、企业基本情况 （一）中文名称：山西省国有投融资管理有限公司 （二）英文名称：Shanxi State-owned Investment and Financing Management Co.,Ltd. （三）法定代表人：郝俊伟 （四）股东名称：山西国信投资集团有限公司 （五）注册地址：山西示范区南中环街529号清控创新基地D座16层7B-10号 （六）经营范围：国有资本运营及资产管理；供应链管理服务；投资管理及相关咨询服务（不含证券、期货投资咨询）；国内外贸易（法律禁止的除外）。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。 （七）办公地址及邮政编码：山西示范区南中环街529号清控创新基地D座16层7B-10号，030006 （八）电子信箱: sxgxtr@163.com （九）简介：山西省国有投融资管理有限公司（以下简称“投融资公司”）成立于2016年9月，注册资本金1亿元。是山西国信旗下的全资控股子公司。 二、主要财务数据、财务指标、财务会计报告摘要 （一）报告期主要财务数据 三、环境保护情况 投融资公司节能降耗等环境保护问题严格按照国家有关法律法规相关规定执行。",
              picture:
                "/profile/upload/image/2024/10/10/0c1b1d3e-ca2c-47d5-b49c-9b2c1d4edd52.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "trz",
              inputTime: "2024-10-31 16:58:59",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2024-10-31 15:22:28",
              remark: null,
              id: 5241,
              menuId: 2284,
              title:
                "山西太行产业投资基金管理有限公司2024年三季度财务等重大信息公开报告",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "太行产业基金",
              content:
                "一、企业基本情况 （一）中文名称：山西太行产业投资基金管理有限公司 （二）英文名称：Shanxi Taihang Industrial Investment Fund Management Co.,Ltd. （三）法定代表人：谢宏伟 （四）股东名称：山西金融投资控股集团有限公司 （五）注册地址：山西综改示范区太原学府园区长治路308号同昌创业园B座25层 （六）经营范围：管理或受托管理股权类投资并从事相关咨询服务业务（不含国家法律法规、国务院决定限制和禁止的项目；不得以任何方式公开募集和发行基金）（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）。（依法须经批准的项目，经相关部门批准后方可开展经营活动） （七）办公地址及邮政编码：山西综改示范区太原学府园区长治路308号同昌创业园B座25层，030024 （八）电子信箱: sxthcyjj@163.com （九）简介：山西太行产业投资基金管理有限公司（以下简称“太行产业基金公司”）是按照省委省政府战略决策部署，经省政府常务会议决定通过，由山西金融投资控股集团有限公司独资设立的山西省省级政府产业引导基金管理公司，主要从事省级政府投资基金的设立与管理，并根据省委省政府安排，落实相关重大经济决策。太行产业基金公司旨在通过不断发展逐步完善政府引导基金管理体系，全面支持山西省创新驱动、转型升级战略，衔接好实体经济和金融资本，成为具有山西特色的基金管理公司，为山西经济社会发展提供更大支撑。 二、主要财务数据、财务指标、财务会计报告摘要 （一）报告期主要财务数据（合并口径） 单位：人民币万元 项目 2024年1-9月 营业收入 4472.55 业务及管理费用 2273.46 利润总额 2143.31 净利润 1908.09 （二）报告期主要补充财务数据（合并口径） 单位：人民币万元 项目 2024年9月末 资产 34998.75 负债 728.07 所有者权益 34270.68 应收款项 7429.26 固定资产净值 47.27 应交税费 -23.33 （三）报告期内所有者权益变动情况（合并口径） 单位：人民币万元 项目 2024年9月末 实收资本 20000 资本公积 9940.78 盈余公积 1976.12 一般风险准备 3582.81 未分配利润 -1229.04 归属于母公司股东权益合计 34270.68 少数股东权益 0 所有者权益合计 34270.68 （四）报告期财务报告摘要（合并口径） 截至2024年9月30日，太行产业基金公司总资产34998.75万元，较年初下降0.09%；净资产34270.68万元，较年初增长2.28%。截至2024年9月30日，太行产业基金公司实现营业收入4472.55万元，较去年同期下降7.22%；实现净利润1908.09万元，较去年同期增长30.18%。 三、预算指标执行情况 单位：人民币万元 项 目 年度预算 9月末完成数 预算完成情况 总资产 36333 34998.75 96.33% 净资产 34663 34270.68 98.87% 净利润 2300 1908.09 82.96% 四、环境保护情况 太行产业基金公司高度重视环境保护，积极支持节能环保型企业和节能环保项目。节能降耗、矿山绿化、“三废”治理、环保设施、污染物排放等环境保护问题严格按照国家有关法律法规和有关规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "thjj",
              inputTime: "2024-10-31 15:16:47",
              menuParentId: null,
              searchContent: null,
            },
          ],
          holdingList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:38",
              remark: null,
              id: 5273,
              menuId: 2191,
              title: "山西征信",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "山西省征信有限公司是全省唯一获得备案的企业征信机构。始终坚持积极响应国家构建信用社会、推进普惠金融的号召，紧扣“五篇大文章”，立足“政府+市场”的建设模式，内抓管理，外抓成效，在深化完善平台建设，积极盘活数据资源的基础上，不断强化“平台+产品+服务”三大业务板块，逐步建立起较为完善的企业征信产业生态。",
              picture:
                "/profile/upload/2025/02/10/2ecd8dcf0c6b00f0e644cdde40b22a5_20250210102403A017.jpg",
              officialUrl: "https://www.tyqyzx.cn/",
              homePageUrl: "www.tyqyzx.cn/",
              homePagePicture:
                "/profile/upload/2025/02/07/59eefece932d5_20250207164706A007.jpg",
              companyName: "山西省征信有限公司",
              sort: 8,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2025-02-07 16:49:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:10:57",
              remark: null,
              id: 4313,
              menuId: 2191,
              title: "中合盛",
              subtitle: null,
              keywords: "",
              description:
                "中合盛资本管理有限公司是山西国信投资集团有限公司旗下从事政府投资基金管理和私募股权投资的专业机构。公司于2014年12月在上海自贸区注册成立，注册资本1亿元人民币，2015年3月在中国证券投资基金业协会取得私募基金管理人登记证明，登记编号为P1008848。中合盛资本拥有一支专业的投研团队，核心成员来自政府、投行、证券、信托、担保、管理咨询、私募基金等相关机构，熟悉资本市场运作，投资经验丰富、实务操作熟练、行业资源广...",
              copyFrom: null,
              content:
                "中合盛资本管理有限公司是山西国信投资集团有限公司旗下从事政府投资基金管理和私募股权投资的专业机构。公司于2014年12月在上海自贸区注册成立，注册资本1亿元人民币，2015年3月在中国证券投资基金业协会取得私募基金管理人登记证明，登记编号为P1008848。中合盛资本拥有一支专业的投研团队，核心成员来自政府、投行、证券、信托、担保、管理咨询、私募基金等相关机构，熟悉资本市场运作，投资经验丰富、实务操作熟练、行业资源广泛。公司致力于有效对接实体经济与社会资本，为客户提供投资咨询、资产重组、私募融资、市值管理、产业延伸等多元化金融服务，助力企业实现跨越发展。 中合盛资本目前承担总规模近百亿元的山西省政府投资基金管理职能；同时从事市场化私募股权投资基金管理。通过直投、并购、定增、夹层基金等方式，聚焦新能源、现代煤化工、高端装备制造、TMT、文旅、医疗大健康等重点领域。2016年以来，中合盛资本运用所管理的山西省政府产业基金先后运作了潞安集团180万吨煤制油，山西大运新能源汽车，山西国耀新能源生物质发电，反腐倡廉电视剧《于成龙》，山西综改示范区太原移动能源产业园，海南易乐物联等一系列重点项目，基金管理规模达到43.5亿元；此外，成功运作和参与了新疆熙菱信息创业板iPo，亚宝药业定增、山西七一华富生物质发电、无锡新洁能半导体preipo等市场化项目，其中部分项目已成功退出。 中合盛资本秉承“凝聚智慧、创造价值”的创业理念，坚持“专业务实、追求卓越”的谋事作风，努力打造山西本土私募股权投资行业的优质品牌，并且已经逐步成长为山西省政府投资基金管理行业的主力军和排头兵。 公司经营范围 中合盛资本管理有限公司业务类别为投资类，经营范围主要包括股权投资，股权投资管理，资产管理，投资管理。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。",
              picture: "/profile/upload/content/2023/02/63f70d263580f.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6920e090da.jpg",
              companyName: "中合盛资本管理有限公司",
              sort: 17,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:36:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:50",
              remark: null,
              id: 4309,
              menuId: 2191,
              title: "中煤保险",
              subtitle: null,
              keywords: "",
              description:
                "中煤财产保险股份有限公司成立于2008 年10 月，注册地山西省太原市，是国内唯一一家具有煤炭行业背景的保险公司，也是首家总部设在山西省的全国性保险公司，经营范围涵盖车险、财产险、责任险、农业保险等各类财产保险业务。目前在山西、河北、山东、河南、四川、陕西设有分公司，山西省内机构覆盖11个地市和70个县市。中煤保险股东实力雄厚，山西金融投资控股集团是集银行、证券、保险、信托、股权、资产、产权、再担保、基金以及...",
              copyFrom: null,
              content:
                "中煤财产保险股份有限公司成立于2008 年10 月，注册地山西省太原市，是国内唯一一家具有煤炭行业背景的保险公司，也是首家总部设在山西省的全国性保险公司，经营范围涵盖车险、财产险、责任险、农业保险等各类财产保险业务。目前在山西、河北、山东、河南、四川、陕西设有分公司，山西省内机构覆盖11个地市和70个县市。 中煤保险股东实力雄厚，山西金融投资控股集团是集银行、证券、保险、信托、股权、资产、产权、再担保、基金以及投资等于一体的全牌照金融控股集团，中煤集团、晋煤集团、山西焦煤、潞安集团、同煤集团、阳煤集团等股东资产规模逾万亿，业务遍布主要煤炭大省和国外。 中煤保险以“管理高危风险，保障和谐社会”为使命，以成为“客户身边的高风险管理专家”为愿景，紧紧围绕“专业、责任、创新、价值”这一核心价值观，秉持“诚信守法、突出特色、驾驭风险、追求效益”的经营理念，以煤炭等高危保险为核心，传统领域优质业务为重点，新型保险业务为突破，全力打造识别、防范、化解煤炭等高危行业风险的技术体系，大胆探索符合高危客户风险管理需要的特色产品和服务模式，专注高危，精益运营，诚信服务，稳健发展，努力为高危企业、高危行业职业人群提供周全、完善、全面的风险保障，不断提升高危行业风险管理水平，为客户、股东、员工、社会公众和利益相关者创造价值，为促进经济发展与和谐社会建设做出应有的贡献。 经过几年发展，中煤保险业务遍布全国13个省、自治区、直辖市和9个大型煤炭基地及部分海外国家，为780个煤炭客户、1200座煤矿、200座非煤矿山、40万煤炭及高危行业职工提供保险服务，累计保险保障超过600亿元。在专注煤炭安全生产的同时，还为“蛟龙号”深海探测器7000米海试、澳大利亚、土耳其等海外能源项目、索契冬奥会滑雪运动员提供风险保障。 “做客户身边的高风险管理专家”，“忠于承诺，管理未来”，是中煤保险人的郑重承诺，也是中煤保险践行社会责任的卓越追求！",
              picture: "/profile/upload/content/2017/12/5a2a2bceb92e9.jpg",
              officialUrl: "http://www.chinacoal-ins.com/",
              homePageUrl: "www.chinacoal-ins.com",
              homePagePicture:
                "/profile/upload/content/2017/10/59eeff7c9c03b.jpg",
              companyName: "中煤财产保险股份有限公司",
              sort: 5,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:53:19",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:21:33",
              remark: null,
              id: 4311,
              menuId: 2191,
              title: "山西股权",
              subtitle: null,
              keywords: "",
              description:
                "山西股权交易中心有限公司（以下简称“山西股权交易中心”）是经山西省人民政府批准设立的省内唯一的区域性股权市场，是为我省中小微企业证券非公开发行、转让及相关活动提供设施与服务的场所，是我省中小微企业的私募股权市场，是地方人民政府扶持中小微企业政策措施的综合运用平台。控股股东为山西金融投资控股集团有限公司，太原高新区和山西证券股份有限公司为参股股东，注册资本金为1亿元。多层次资本市场结构图 业务范围：为...",
              copyFrom: null,
              content:
                "山西股权交易中心有限公司（以下简称“山西股权交易中心”）是经山西省人民政府批准设立的省内唯一的区域性股权市场，是为我省中小微企业证券非公开发行、转让及相关活动提供设施与服务的场所，是我省中小微企业的私募股权市场，是地方人民政府扶持中小微企业政策措施的综合运用平台。控股股东为山西金融投资控股集团有限公司，太原高新区和山西证券股份有限公司为参股股东，注册资本金为1亿元。 多层次资本市场结构图 业务范围： 为非上市股份公司股权的挂牌、登记、托管、转让提供服务； 为中小微企业改制、重组并购、上市、投资提供业务咨询服务； 提供与上述经营范围相关产品的信息发布及培训服务。 我们的使命： 　　为企业提供多元化、专业化、个性化融资融智平台； 　　为投资者提供多样化投资平台； 　　为会员单位提供新业务创新平台； 　　为山西综改试验区建设经济转型升级提供综合服务平台。",
              picture: "/profile/upload/content/2017/12/5a2a2c1278701.jpg",
              officialUrl: "http://www.sxgq.net/",
              homePageUrl: "www.sxgq.net",
              homePagePicture:
                "/profile/upload/content/2017/10/59eeff1dcf1a3.jpg",
              companyName: "山西股权交易中心有限公司",
              sort: 9,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:51:44",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:00",
              remark: null,
              id: 4310,
              menuId: 2191,
              title: "山西交易集团",
              subtitle: null,
              keywords: "",
              description:
                "山西省交易集团股份有限公司（以下简称“山西交易集团”）注册资本2.78亿元，是山西金控集团为贯彻落实中共中央、国务院关于深化要素交易市场化改革精神设立的山西省首家大型国有交易集团，是山西省唯一的大型全牌照金融控股集团——山西金融投资控股集团有限公司的重要子公司。山西交易集团负责运营和管理各类要素交易平台以及提供相关交易配套服务，围绕十三个业务板块，在深耕传统资产交易的基础上，拓宽业务边界，积极聚焦战略...",
              copyFrom: null,
              content:
                "山西省交易集团股份有限公司（以下简称“山西交易集团”）注册资本2.78亿元，是山西金控集团为贯彻落实中共中央、国务院关于深化要素交易市场化改革精神设立的山西省首家大型国有交易集团，是山西省唯一的大型全牌照金融控股集团——山西金融投资控股集团有限公司的重要子公司。山西交易集团负责运营和管理各类要素交易平台以及提供相关交易配套服务，围绕十三个业务板块，在深耕传统资产交易的基础上，拓宽业务边界，积极聚焦战略性新兴产业，充分发挥“信息集散、发现价值、资本进退、规范流动、优化资源配置”五大功能。 山西交易集团始终秉持“让天下没有难交易的资产”的企业愿景与“交易创造价值”的企业使命，恪守“阳光透明，合规合法”经营原则，坚持以习近平新时代中国特色社会主义思想为指导，全面贯彻党的二十大精神，不断推进旗下各要素交易平台市场化、信息化发展，致力于成为国内一流的基础性、权益性资本市场平台，并不断向全要素全资源综合性非标市场平台发展迈进，为我省实体经济提供优质服务，助力全国统一大市场的形成与高标准市场体系的建设，为山西省全方位推进高质量发展注入力量。",
              picture: "/profile/upload/content/2022/12/63a1362aacca1.jpg",
              officialUrl: "http://sxexgrp.cn/",
              homePageUrl: "www.sxexgrp.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefef68286d.jpg",
              companyName: "山西省交易集团股份有限公司",
              sort: 8,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:51:05",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:59",
              remark: null,
              id: 4308,
              menuId: 2191,
              title: "山西信托",
              subtitle: null,
              keywords: "",
              description:
                "山西信托是由山西省信托投资公司改制而成，于2002年4月1日正式获准重新登记，是经中国人民银行和山西省人民政府批准保留的山西唯一一家信托机构。公司注册资本金人民币13.57亿元，其中美元2414万元。2013年4月公司经中国银行业监督管理委员会批准，名称由“山西信托有限责任公司”变更为“山西信托股份有限公司”。目前，公司由3家股东单位组成，分别为：山西金融投资控股集团有限公司、太原市海信资产管理有限公司、山西国际电力集...",
              copyFrom: null,
              content:
                "山西信托是由山西省信托投资公司改制而成，于2002年4月1日正式获准重新登记，是经中国人民银行和山西省人民政府批准保留的山西唯一一家信托机构。公司注册资本金人民币13.57亿元，其中美元2414万元。2013年4月公司经中国银行业监督管理委员会批准，名称由“山西信托有限责任公司”变更为“山西信托股份有限公司”。目前，公司由3家股东单位组成，分别为：山西金融投资控股集团有限公司、太原市海信资产管理有限公司、山西国际电力集团有限公司。 为了适应不断变化的市场环境，保持公司的良好发展态势，公司将坚持以科学发展观统领公司发展全过程，紧紧围绕公司战略发展目标，规范经营，稳健发展，执着追求，勇于创新，努力提高核心竞争力，加快业务调整步伐，实现合理盈利模式，构建学习型、效益型、和谐型公司，充分实现股东权益、社会效益和员工利益的最大化，逐步将公司发展成为全国一流的信托机构，成为具有一定影响力的专业理财机构。",
              picture: "/profile/upload/content/2017/12/5a2a2c5b1cffa.jpg",
              officialUrl: "http://www.sxxt.net/",
              homePageUrl: "www.sxxt.net",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefece932d5.jpg",
              companyName: "山西信托股份有限公司",
              sort: 4,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:50:24",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:20:26",
              remark: null,
              id: 4307,
              menuId: 2191,
              title: "山西证券",
              subtitle: null,
              keywords: "",
              description:
                "山西证券股份有限公司最早成立于1988年7月，是全国首批证券公司之一，属国有控股性质。经过二十多年的发展，已成为作风稳健、经营稳定、管理规范、业绩良好的创新类证券公司。2010年9月，公司上市首发申请获中国证监会发审委审核通过，11月15日正式在深圳证券交易所挂牌上市，股票代码002500，注册资本28.2873亿元。公司股东资金实力雄厚，经营风格稳健，资产质量优良，盈利能力良好，其构成集中体现了多种优质资源、多家优势企业的...",
              copyFrom: null,
              content:
                "山西证券股份有限公司最早成立于1988年7月，是全国首批证券公司之一，属国有控股性质。经过二十多年的发展，已成为作风稳健、经营稳定、管理规范、业绩良好的创新类证券公司。2010年9月，公司上市首发申请获中国证监会发审委审核通过，11月15日正式在深圳证券交易所挂牌上市，股票代码002500，注册资本28.2873亿元。 公司股东资金实力雄厚，经营风格稳健，资产质量优良，盈利能力良好，其构成集中体现了多种优质资源、多家优势企业的强强联合。公司控股股东为山西金融投资控股集团有限公司。 经过近三十年的发展，山西证券的经营范围基本涵盖了所有的证券领域，分布于财富管理、资产管理、投资管理、投融资、研究、期货、国际业务等板块，具体包括：证券经纪；证券自营；证券资产管理；证券投资咨询；与证券交易、证券投资活动有关的财务顾问；证券投资基金代销；为期货公司提供中间介绍业务;融资融券；代销金融产品等。同时，公司具备公开募集证券投资基金管理业务资格，并获批开展债券质押式报价回购交易、股票质押式回购交易、约定购回式证券交易、转融通、上市公司股权激励行权融资、直接投资、柜台市场等业务。 公司控股中德证券有限责任公司，从事股票和债券的承销与保荐；全资控股格林大华期货有限公司，从事商品期货经纪、金融期货及期货投资咨询业务；全资控股山证国际金融控股有限公司，从事全面优质的经纪及零售证券、期货、投资理财、财富管理、投资移民等金融产品及服务；全资子公司龙华启富投资有限责任公司，从事投资管理、项目投资、财务顾问、经纪信息咨询等直接投资与管理业务。 公司设有分公司14家（管辖63家证券营业部），直辖营业部15家，2017年3月又获19家营业部的筹建批复，期货营业网点27家。以上网点分布于山西各地市、主要县区及北京、上海、天津、深圳、重庆、西安、宁波、大连、济南、福州等地，形成了以国内主要城市为前沿，重点城市为中心，覆盖山西、面向全国的业务发展框架，为近120万客户提供全面、优质的综合金融专业服务。 近年来，公司先后获得山西省政府颁发的“优秀中介机构”、深交所颁发的“中小企业板优秀保荐机构”、中国证监会颁发的“账户规范先进集体”等荣誉，并连续多年荣获山西省人民政府授予的“支持山西地方经济发展贡献奖”。2012年，公司荣获“第五届中国机构投资者年会暨金蝉奖——最稳健证券公司奖”、“中国最具特色证券经纪商”和“最佳投顾服务品牌”；2013年，公司荣获山西证监局颁发的“投资者回报优秀单位”、“投资者关系管理优秀单位”及“社会责任优秀单位”，在行业内评选中荣获“行业年度贡献奖”、“最佳研究实力奖”、“2013年中国券商‘金方向’奖—最佳创新证券公司”等殊荣；2014年，公司荣获山西省总工会颁发的“山西省金融系统优质服务先进单位”奖，在行业内评选中获得“中国上市公司风险管理金盾奖”、“2014年中国最具成长性证券经纪商”、“中国最佳区域证券经纪商”、“中国最佳融资融券商”；2015年，公司获得山西省金融办、山西证监局颁发的“2015年度新三板优秀主办券商”的称号，在中国最佳财富管理机构评选活动中获得“中国最佳区域证券经纪商”和“中国最佳投资顾问品牌”等荣誉。 未来的山西证券将秉承“诚信、稳健、规范、创新、高效”的经营理念，“以义制利、协作包容、追求卓越”的核心价值观，以“专业服务创造价值”为使命，坚持“让投资更明白”的服务理念，培育务实高效、恪尽职守的工作作风，营造和谐宽松、风清气正的公司氛围，坚定公司发展过程中差异化、专业化、市场化、集约化的战略原则，打造公司与客户共同发展的平台，努力把公司建设成为有特色、有品牌、有竞争力的一流券商。",
              picture: "/profile/upload/content/2017/12/5a2a2c6e20d7d.jpg",
              officialUrl: "http://www.i618.com.cn/",
              homePageUrl: "www.i618.com.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefe9fb0081.jpg",
              companyName: "山西证券股份有限公司",
              sort: 3,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:49:37",
              menuParentId: null,
              searchContent: null,
            },
          ],
          povertyList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-08-10 10:28:52",
              remark: null,
              id: 3859,
              menuId: 2153,
              title:
                "山西金控•乡村振兴 山西金控驻村帮扶工作队工作动态 2021年第4期（总第4期）",
              subtitle: "",
              keywords: "",
              description:
                "山西金控集团驻枣圪垯村工作队联合帮扶村党支部组织开展庆祝中国共产党成立100周年系列活动重温百年历史，感悟思想伟力。为庆祝中国共产党成立100周年，6月25日-7月2日，山西金控集团驻枣圪垯工作队联合帮扶村党支部开展了一系列内容丰富、意义深远的庆祝活动，希望以扎实的活动凝聚力量，激发基层党员爱党爱国情怀，助力乡村振兴，为建党百年华诞献礼。6月25日，枣圪垯村党支部开展了“学党史、讲党课”宣讲活动，三交镇政府包片领...",
              copyFrom: "",
              content:
                "山西金控集团驻枣圪垯村工作队联合帮扶村党支部 组织开展庆祝中国共产党成立100周年系列活动 重温百年历史，感悟思想伟力。为庆祝中国共产党成立100周年，6月25日-7月2日，山西金控集团驻枣圪垯工作队联合帮扶村党支部开展了一系列内容丰富、意义深远的庆祝活动，希望以扎实的活动凝聚力量，激发基层党员爱党爱国情怀，助力乡村振兴，为建党百年华诞献礼。 6月25日，枣圪垯村党支部开展了“学党史、讲党课”宣讲活动，三交镇政府包片领导秦宇亮以《伟大领袖毛泽东革命历程》为题为全体党员干部上了一堂生动的党课。党课通过大量历史事件，回顾党团结带领中国人民不懈奋斗的光辉历程和做出的伟大历史贡献，活动中大家围绕正在开展的党史学习教育，结合各自工作实际和学习体会，畅谈认识、交流心得，为更高质量推进枣圪垯村各项工作积极建言献策。 授勋，是礼遇，意在树立榜样，建立良好导向。6月29日，枣圪垯村党支部组织在家党员集中观看“七一勋章”颁授仪式，现场大家纷纷表示，要学习“七一勋章”获得者的精神风范，学习他们共产党人坚定信念、践行宗旨、拼搏奉献、廉洁奉公的高尚品质和崇高精神。 “五十年的党龄、五十年的光荣”。为进一步增强老党员的荣誉感，继续保持经久不变的共产党人本色。6月30日，山西金控集团驻村工作队开展慰问50年以上党龄的老党员活动，为他们带去党的关怀和组织的温暖。走访慰问中，工作队长李晋中同志与老党员们进行了亲切的交谈，详细了解了他们的思想、生活和健康状况，褒扬他们为党的事业做出的贡献。老党员们对组织的关心与牵挂深表感激，纷纷表示不忘初心，永远跟党走，为乡村振兴一如既往贡献自己的力量。 7月2日，枣圪垯村党支部举行庆祝建党100周年纪念大会。首先组织全体党员观看了庆祝中国共产党建党100周年大会现场实况，认真聆听了习近平总书记在大会上的重要讲话。大家纷纷表示，这次收看大会实况是一次生动的党课教育，深深地感到作为一名共产党员的崇高荣誉感，进一步激发党员干部蓬勃的爱党热情，把对党的赤诚和忠贞融入全心全意为人民服务的伟大事业中。同时，此次纪念大会还严格按照党员发展程序，通过会议讨论、无记名投票方式公平、公正推选了3名入党积极分子和1名发展对象，为党组织注入了新鲜血液，壮大了党员队伍。 庆祝中国共产党成立100周年系列活动的开展，使广大党员干部深刻了解了中国共产党百年岁月的辉煌历程，了解了可歌可泣的英雄故事，增强了民族自尊心、自信心、自豪感，夯实了基层党员听党话、跟党走的坚定信念。山西金控集团驻枣圪垯村工作队将以庆祝建党100周年和开展党史学习教育为新的起点，学党史、悟思想、办实事、开新局，以永不懈怠的精神状态和一往无前的奋斗姿态，努力在新征程中有新作为，奋力谱写出乡村振兴更加出彩的绚丽篇章。",
              picture: "/profile/upload/content/2021/08/6111e37bad840.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-08-10 10:28:52",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-08-10 10:15:54",
              remark: null,
              id: 3858,
              menuId: 2153,
              title:
                "山西金控•乡村振兴 山西金控驻村帮扶工作队工作动态 2021年第3期（总第3期）",
              subtitle: "",
              keywords: "",
              description:
                "山西金控集团驻临县工作队邀请罗家山村“能人”座谈2021年5月27日，山西金控集团驻临县工作队邀请全国农村创新创业优秀带头人、临县罗家山红枣专业合作社理事长、山西罗家山农林牧集团创始人张福荣和山西罗家山食品科技有限公司总经理薛青对队员授课。会上，张福荣分享了创办临县罗家山红枣专业合作社的经过，讲述了在罗家山就“基础设施建设、环境卫生整治、村民素养提升、农业融合发展”等乡村振兴战略实施方面的具体行动举措，介...",
              copyFrom: "",
              content:
                "山西金控集团驻临县工作队邀请罗家山村“能人”座谈 2021年5月27日，山西金控集团驻临县工作队邀请全国农村创新创业优秀带头人、临县罗家山红枣专业合作社理事长、山西罗家山农林牧集团创始人张福荣和山西罗家山食品科技有限公司总经理薛青对队员授课。 会上，张福荣分享了创办临县罗家山红枣专业合作社的经过，讲述了在罗家山就“基础设施建设、环境卫生整治、村民素养提升、农业融合发展”等乡村振兴战略实施方面的具体行动举措，介绍了罗家山正在推进的罗家山功能食品产业区、养殖产业区、饺子加工、有机肥生产等项目情况。薛青为大家讲解了中国红枣的起源与发展，客观对比了新疆红枣与山西红枣的特点，分享了吕梁红枣产业的发展现状、存在问题及对策。张福荣表示希望能与山西金控集团进行更深入的对接，不断加强与集团各子公司的合作交流，吸引更多的国家级、省市级金融机构来罗家山投资，为临县经济发展做出更大的贡献。 最后，包村工作队长李晋中同志对张福荣的先进事迹作了高度评价，希望与张福荣、薛青等优秀乡村创业代表建立常态化交流机制，工作队要充分利用山西金控集团多金融牌照优势，立足当地资源禀赋，与当地政府相关部门以及乡村“能人”同心协力，积极探索乡村振兴新路径，在巩固拓展脱贫成果、全面推进乡村振兴的新征程中做出贡献，以优异成绩迎接建党100周年。",
              picture: "/profile/upload/content/2021/08/6111e1307becb.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-08-10 10:15:54",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-08-10 10:02:28",
              remark: null,
              id: 3857,
              menuId: 2153,
              title:
                "山西金控•乡村振兴 山西金控驻村帮扶工作队工作动态  2021年第2期（总第2期）",
              subtitle: "",
              keywords: "",
              description:
                "山西金控集团下属中合盛资本赴集团帮扶村开展“坚定信念学党史扶贫助学办实事”六一扶贫助学活动“六一”国际儿童节到来之际，为进一步助力乡村振兴，加大对贫困山区儿童的关心关爱力度，5月31日-6月1日，山西金控集团下属中合盛资本赴集团帮扶村双塔村、枣圪垯村开展“坚定信念学党史，扶贫助学办实事”六一扶贫助学活动。集团驻村工作队全体成员，中合盛资本党员、团员代表及三交镇双塔小学、枣圪垯寄宿制小学师生等400余人参加了...",
              copyFrom: "",
              content:
                "山西金控集团下属中合盛资本赴集团帮扶村开展“坚定信念学党史 扶贫助学办实事”六一扶贫 助学活动 “六一”国际儿童节到来之际，为进一步助力乡村振兴，加大对贫困山区儿童的关心关爱力度，5月31日-6月1日，山西金控集团下属中合盛资本赴集团帮扶村双塔村、枣圪垯村开展“坚定信念学党史，扶贫助学办实事”六一扶贫助学活动。集团驻村工作队全体成员，中合盛资本党员、团员代表及三交镇双塔小学、枣圪垯寄宿制小学师生等400余人参加了活动。 中合盛资本向两所学校各捐赠1套多媒体教学设备，合计人民币4万元。枣圪垯寄宿制小学、双塔小学校长代表全校师生对中合盛资本扶贫助学举措表示感谢，并回赠锦旗。 中合盛资本董事长赵春明与两所小学校长及村干部就学校目前情况、未来发展进行了详细了解，并走进教室就捐赠的多媒体设备安装、使用、售后等提出了建议。 学好党史，励志前行。6月1日，中合盛资本党员及团员青年代表前往集团帮扶村双塔村中央后委旧址及毛泽东同志路居参观学习。 大家心怀敬仰之情，认真聆听讲解，了解了中央后委在为推动解放战争和中国革命胜利建树的丰功伟绩，深刻感受到共产党人胸怀全局、无私奉献的革命精神，并表示将在今后的工作中赓续革命优良传统，不畏艰难险阻，勇于担当作为。 爱心暖童心，金控传温情。此次“六一”扶贫助学活动，不仅是助力乡村振兴战略、扩大帮扶济困范围的持续体现；更是彰显国企担当、践行社会使命的重要标志。山西金控集团携旗下子公司将一如既往发挥省属金融国企力量，持续致力于支持乡村教育发展、关爱贫困儿童成长等活动，同社会各界一起为孩子们营造和谐、友爱、幸福的社会大家园。",
              picture: "/profile/upload/content/2021/08/6111ddde7becb.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-08-10 10:02:28",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-08-10 09:44:16",
              remark: null,
              id: 3856,
              menuId: 2153,
              title:
                "山西金控•乡村振兴 山西金控驻村帮扶工作队工作动态 2021年第1期（总第1期）",
              subtitle: "",
              keywords: "",
              description:
                "山西金控集团党委书记、董事长张炯玮一行深入临县三交镇就驻村帮扶工作进行调研指导为切实做好脱贫攻坚与乡村振兴的有序衔接，勇担社会责任、彰显国企担当。5月26日，山西金控集团党委书记、董事长张炯玮一行赴临县三交镇就驻村帮扶工作进行调研指导。在枣圪垯村委会，张炯玮董事长一行与原驻村帮扶扶贫干部和新选派的驻村第一书记及工作队员进行新老队员座谈会。会上张炯玮董事长与大家亲切交流，充分肯定了奋战在脱贫攻坚一线队员...",
              copyFrom: "",
              content:
                "山西金控集团党委书记、董事长张炯玮一行深入临县三交镇就驻村帮扶工作 进行调研指导 为切实做好脱贫攻坚与乡村振兴的有序衔接，勇担社会责任、彰显国企担当。5月26日，山西金控集团党委书记、董事长张炯玮一行赴临县三交镇就驻村帮扶工作进行调研指导。 在枣圪垯村委会，张炯玮董事长一行与原驻村帮扶扶贫干部和新选派的驻村第一书记及工作队员进行新老队员座谈会。会上张炯玮董事长与大家亲切交流，充分肯定了奋战在脱贫攻坚一线队员作出的突出成绩，点赞全体新老队员舍小家、顾大家，不辱使命；希望大家能够把这段难忘的经历及收获赋予今后的工作中，在各自岗位上再创佳绩。上任队长任冻同志、新任队长李晋中同志发言中一致表示感谢集团党委、各部门的大力支持和无微关怀，将严格落实驻村帮扶工作交接相关要求，确保做到驻村帮扶无缝衔接。 座谈会后，张炯玮董事长与大家步行前往枣圪垯村蔬菜大棚种殖基地，与合作社负责人及工人进行亲切的交流，同时强调大家要助力发展乡村产业，促进农业高质高效、乡村宜居宜业、农民富裕富足。 在工作队驻地，详细了解、现场察看了大家的工作和生活环境并叮嘱大家要以热血赴使命，以行动践诺言，发扬钉钉子精神，坚持一张蓝图干到底，让广大群众在发展产业中有更多的获得感和幸福感。 在孙家沟村，村支部书记就村庄目前发展和未来规划进行了全面、系统阐述，大家边走边看边了解，张炯玮董事长要求大家一定要深度挖掘红色资源，融合特色文化、灵活采取多种方式，多举措全方面落实党史学习教育重大任务，精心打造当地党性教育基地，传承红色记忆，汲取红色力量。 调研中，张炯玮董事长强调大家要以赶考的心态、奋斗者的姿态，重点在三个方面下功夫。一是要用心做事。乡村振兴是国家战略，全体队员要深入学习贯彻党中央及省委工作部署，深刻认识肩负的责任重大、使命光荣，切实把驻村工作做细做好。二是要用情做事。用真情和老百姓相处，用真情取得老百姓的信任，用真情诠释对老百姓的大爱。三是要用行动做事。尽快选好乡村振兴的路径，做好帮扶项目的规划，真干实干，撸起袖子去干，激发驻村资源要素活力，积极推动重点任务落实。",
              picture: "/profile/upload/content/2021/08/6111d9b30f392.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-08-10 09:44:16",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-02-10 10:50:08",
              remark: null,
              id: 3855,
              menuId: 2153,
              title:
                "山西金控•脱贫攻坚 山西金控驻村帮扶工作队工作动态 （第1期）",
              subtitle: "",
              keywords: "",
              description:
                "寒冬扬春意，慰问暖人心。值此春回大地、新春佳节到来之际，为了让两个帮扶村300余户脱贫群众持续感受到集团的温暖，确保大家度过一个快乐祥和的新春佳节。2021年2月4日-5日，山西金控集团在两个帮扶村开展了春节“送温暖”慰问活动，将党和政府的温暖与关爱及时送到了广大群众当中。山西金控集团董事、包村工作队队长任冻同志代表集团向到场群众表示亲切问候并致以美好的新春祝福，亲手将一份份春节慰问品油、肉、排骨等传递到群众...",
              copyFrom: "党委工作部",
              content:
                "山西金控集团开展2021年春节“送温暖”慰问活动 寒冬扬春意，慰问暖人心。值此春回大地、新春佳节到来之际，为了让两个帮扶村300余户脱贫群众持续感受到集团的温暖，确保大家度过一个快乐祥和的新春佳节。2021年2月4日-5日，山西金控集团在两个帮扶村开展了春节“送温暖”慰问活动，将党和政府的温暖与关爱及时送到了广大群众当中。 山西金控集团董事、包村工作队队长任冻同志代表集团向到场群众表示亲切问候并致以美好的新春祝福，亲手将一份份春节慰问品油、肉、排骨等传递到群众手中。希望广大群众在新的一年里，生活蒸蒸日上、越过越红火，真正抓牢打赢脱贫攻坚战和实施乡村振兴战略的政策机遇，脚踏实地、辛勤劳动，在增收致富路上行稳致远。 在送上新年祝福和问候的同时，驻村工作队积极、广泛宣传了疫情防控及返乡创业等相关政策。专项宣传了春节期间“新冠”疫情防控要求，并了解村民群众过节物资准备情况。所到之处，群众无不感谢党的好政策，纷纷表示要继续撸起袖子加油干，早日实现幸福小康生活目标。 2021年，站在驻村帮扶工作的崭新历史节点，山西金控集团将秉持中央、省、市、县“摘帽不摘责任、摘帽不摘政策、摘帽不摘帮扶、摘帽不摘监管”的帮扶原则，加强对脱贫不稳定户、边缘易致贫户的监测，持续巩固脱贫攻坚成果、全面提升驻村帮扶成效，扎实推进脱贫攻坚向乡村振兴的有序衔接，在“三农”工作新发展阶段继续贡献山西金控力量。",
              picture: "/profile/upload/content/2021/02/602349d385de9.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-02-10 10:50:08",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-02-10 09:02:55",
              remark: null,
              id: 3854,
              menuId: 2153,
              title:
                "山西金控•脱贫攻坚 山西金控驻村帮扶工作队工作动态 （第96期） ",
              subtitle: "",
              keywords: "",
              description:
                "吕梁市委常委、组织部长张欣宁深入我集团帮扶村调研指导脱贫攻坚工作2020年11月26日，吕梁市委常委、组织部长张欣宁深入我集团帮扶村调研指导脱贫攻坚工作。临县县委副书记、县长李双会、三交镇党委书记贺向亮、集团驻村帮扶包村工作队长任冻及县、镇相关部门同志陪同调研。在驻村工作队驻地，张欣宁同志实地查看并详细了解了驻村工作人员的办公、生活和工作情况，听取了驻村工作队驻村帮扶工作汇报。张欣宁同志对山西金控集团四年...",
              copyFrom: "党委工作部",
              content:
                "吕梁市委常委、组织部长张欣宁深入我集团帮扶村 调研指导脱贫攻坚工作 2020年11月26日，吕梁市委常委、组织部长张欣宁深入我集团帮扶村调研指导脱贫攻坚工作。临县县委副书记、县长李双会、三交镇党委书记贺向亮、集团驻村帮扶包村工作队长任冻及县、镇相关部门同志陪同调研。 在驻村工作队驻地，张欣宁同志实地查看并详细了解了驻村工作人员的办公、生活和工作情况，听取了驻村工作队驻村帮扶工作汇报。张欣宁同志对山西金控集团四年来的脱贫攻坚驻村帮扶工作给予了充分肯定，并就工作中遇到的具体问题提出了宝贵的指导意见，要求驻村工作队全体要做到基本情况清楚、基本政策清楚、基本措施清楚、基本成效清楚；要把扶贫责任落实到位，发挥桥梁纽带作用，确保扶贫政策落实、项目落地、制度抓实；要用心用情用力帮扶，一户一策帮助他们发展生产，提高经济收入，进一步巩固和扩大脱贫攻坚成果。 在兴隆湾社区脱贫攻坚爱心超市，张欣宁同志认真查看超市积分兑换台帐，全面了解了超市的建设运行、货品筹备及运营管理等情况。调研中指出，大家要进一步加强对脱贫攻坚爱心超市的宣传，呼吁更多人加入到扶贫献爱心队伍中来，积极参与爱心扶贫，发挥好扶贫爱心超市扶贫扶志的作用，不断激励贫困户主动发展、勤劳致富的内生动力，凝聚起更强大的脱贫攻坚力量。 在兴隆湾社区便民服务中心，张欣宁同志翻阅社区工作档案，询问社区服务功能布局、居民服务需求等，察看党员活动中心、图书阅览室、红白理事厅等运行状况。他指出，社区治理与百姓生活息息相关，要依托社区单元，通过党建统领，建立一套综合便民服务体系。配套完善托儿托教、养老服务、医疗卫生、便民服务、综合性文化等便民服务，广度拓展其他特色服务于一体的新型集聚区，真正打造成满足群众需求、方便群众办事的多功能服务中心。 最后，张欣宁同志强调大家在今后的工作中要坚持以党建为统领，因地制宜，选取优势项目，加强提前谋划和指导，发展优势产业，长短结合，决战决胜脱贫攻坚；同时要结合易地移民搬迁实际，大力提升搬迁后续扶持力度，带动其他产业快速发展；要把抓党建和促发展结合起来，把强乡和富民结合起来，提升基层党组织凝聚力、战斗力，发挥党员的示范带动作用，有力推进脱贫攻坚与乡村振兴的无缝衔接。",
              picture: "/profile/upload/content/2021/02/6023309c884cf.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-02-08 09:02:00",
              menuParentId: null,
              searchContent: null,
            },
          ],
          whollyOwnedList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:12:22",
              remark: null,
              id: 5274,
              menuId: 2186,
              title: "山西数据交易中心",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "山西数据交易中心，经山西省人民政府批准，于2024年11月成立，系全省唯一持牌数据交易机构。围绕省委、省政府重大战略任务，以充分释放数据要素价值，促进数字技术与实体经济深度融合，助力产业数智化业转型和企业高质量发展为己任。业务涵盖数据流通交易、数据资产登记评估、数据产品孵化运营、数据资产化服务等领域，积极探索数据赋能实体经济的新路径，致力于将数据价值转化为推动经济社会高质量发展的新动力。",
              picture:
                "/profile/upload/2025/02/08/山西数据交易中心_20250208183441A015.jpg",
              officialUrl: "https://www.sxdataex.com/",
              homePageUrl: "www.sxdataex.com",
              homePagePicture:
                "/profile/upload/2025/02/08/59eefece932d5_20250208121248A009.jpg",
              companyName: "山西数据交易中心有限公司",
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2025-02-08 12:15:09",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:07:16",
              remark: null,
              id: 4303,
              menuId: 2186,
              title: "绿色产业投资",
              subtitle: null,
              keywords: "",
              description:
                "山西省绿色产业投资集团有限公司，为山西金融投资控股集团旗下全资专业化投资集团，是贯彻习近平生态文明思想和绿色发展理念，落实生态文明建设、能源革命和碳达峰碳中和决策部署，经省政府金融办核准设立的绿色产业投资平台。于2018年4月17日注册成立，2022年1月18日更为现名。山西省绿色产业投资集团，致力于贯彻落实省委省政府重大决策，按照山西金控战略部署，在战略定位上，坚持金融资本+绿色产业+现代科技+业态的“1+1+1+N”...",
              copyFrom: null,
              content:
                "山西省绿色产业投资集团有限公司，为山西金融投资控股集团旗下全资专业化投资集团，是贯彻习近平生态文明思想和绿色发展理念，落实生态文明建设、能源革命和碳达峰碳中和决策部署，经省政府金融办核准设立的绿色产业投资平台。于2018年4月17日注册成立，2022年1月18日更为现名。 山西省绿色产业投资集团，致力于贯彻落实省委省政府重大决策，按照山西金控战略部署，在战略定位上，坚持金融资本+绿色产业+现代科技+业态的“1+1+1+N”的发展战略；推动绿色新能源投资，城市建设投资和绿色生态修复，健康养生产业，绿色服务等业务板块的发展。 “十四五”期间，山西省绿色产业投资集团将突出金融属性，发挥投资优势，服务绿色产业，构建“集团化管控、扁平化架构、板块化经营、专业化管理、智能化运行、市场化激励、资本化运作、证券化发展”的管理体系和商业模式，增强绿色产业发展动能，致力于成为“两山”理论的践行者、绿色产业的领军者，为推动绿色产业高质量发展做出积极贡献。",
              picture: "/profile/upload/content/2023/02/63f70e314cc00.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/6054789fb9121.jpg",
              companyName: "山西省绿色产业投资集团有限公司",
              sort: 23,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2022-02-22 11:09:51",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:08:31",
              remark: null,
              id: 4305,
              menuId: 2186,
              title: "养老资产",
              subtitle: null,
              keywords: "",
              description:
                "山西省养老保险基金资产管理有限公司成立于2020年12月，注册资本8000万元，是我省划转部分国有资本充实社保基金的承接主体，专门管理运营划入的国有资本和运营收益。养老资产作为政策性金融机构，不以自身盈利为主要目的，所持有的股权分红和运作收益，专项用于弥补基金缺口，负有建立社保基金战略储备基金，增进民生福祉，实现代际公平，增强制度可持续性的重要使命。经营范围：在政策范围内运营管理划转的国有资本及收益，受托管...",
              copyFrom: null,
              content:
                "山西省养老保险基金资产管理有限公司成立于2020年12月，注册资本8000万元，是我省划转部分国有资本充实社保基金的承接主体，专门管理运营划入的国有资本和运营收益。养老资产作为政策性金融机构，不以自身盈利为主要目的，所持有的股权分红和运作收益，专项用于弥补基金缺口，负有建立社保基金战略储备基金，增进民生福祉，实现代际公平，增强制度可持续性的重要使命。 经营范围：在政策范围内运营管理划转的国有资本及收益，受托管理山西省国有资本投资并从事相关咨询服务业务。（不含国家法律法规、国务院规定限制和禁止的项目）（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
              picture: "/profile/upload/content/2021/03/605477534ec74.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/6054789fb9121.jpg",
              companyName: "山西省养老保险基金资产管理有限公司",
              sort: 25,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2021-03-19 17:49:53",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-03-19 17:41:06",
              remark: null,
              id: 4304,
              menuId: 2186,
              title: "金控资本",
              subtitle: null,
              keywords: "",
              description:
                "山西金控资本管理有限公司成立于2020年03月，注册资本30亿元，是山西金控服务全省重大项目的投资平台，集团内部金融协同的重要推手，特殊资产运营的专业管理人。金控资本围绕集团战略发展及决策部署，按照市场化原则开展业务，主要从事金融股权投资、重大项目协同投资、资产重组整合、资产收购处置及资产盘活增值。",
              copyFrom: null,
              content:
                "山西金控资本管理有限公司成立于2020年03月，注册资本30亿元，是山西金控服务全省重大项目的投资平台，集团内部金融协同的重要推手，特殊资产运营的专业管理人。金控资本围绕集团战略发展及决策部署，按照市场化原则开展业务，主要从事金融股权投资、重大项目协同投资、资产重组整合、资产收购处置及资产盘活增值。",
              picture: "/profile/upload/content/2023/02/63f70f4de6565.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/605478bd3b23b.jpg",
              companyName: "山西金控资本管理有限公司",
              sort: 24,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-03-19 17:41:06",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:08:52",
              remark: null,
              id: 4302,
              menuId: 2186,
              title: "产业基金",
              subtitle: null,
              keywords: "",
              description:
                "山西省产业基金管理有限公司是山西金控集团旗下从事政府产业投资基金和私募股权投资管理的专业私募股权基金管理机构（执牌号为：P1067526）。公司于2017年10月在山西综改示范区注册成立，注册资金1亿元，在职员工28人，其中党员12人（占公司全员42.86%），研究生以上学历12人（占公司全员42.86%），全员取得基金从业资格。产业基金成立至今，以高质量党建引领公司高质量全面发展。公司坚持把服务省内重点产业转型发展、确保私募股...",
              copyFrom: null,
              content:
                "山西省产业基金管理有限公司是山西金控集团旗下从事政府产业投资基金和私募股权投资管理的专业私募股权基金管理机构（执牌号为：P1067526）。公司于2017年10月在山西综改示范区注册成立，注册资金1亿元，在职员工28人，其中党员12人（占公司全员42.86%），研究生以上学历12人（占公司全员42.86%），全员取得基金从业资格。 产业基金成立至今，以高质量党建引领公司高质量全面发展。公司坚持把服务省内重点产业转型发展、确保私募股权基金专业化运营、坚持国有属性行业主渠道经营运作作为公司的立企宗旨，围绕我省经济工作主线，立足服务省内转型综改，服务国企产业提质升级，以“传统产业的基金化股权重整”和“新兴产业的基金化资本运作”为抓手，聚焦产业，坚持“产融结合，以融促产”。运作方向上，坚持产业发展的私募股权基金化运作，确定了服务综改示范区产业落地、服务省属重点国企转型提质升级、省内区域重点产业整合升级改造、市场化股权投资等主要业务方向；运作方式上，坚持以“专业化运营、市场化运作、资本化退出”为基本运作模式，坚持“赛道优先、质量优先”与“项目主流、资金主流、机构主流”的“两优先、三主流”基本运作原则，坚持“实事求是的全面风险管控”体系建设，坚持“合规底线运营”。截至目前，产业基金在中基协备案3支私募股权基金产品，参控股3家子公司，已注册成立13个合伙制基金运作主体，始终保持主体合规、牌照合规和产品合规。目前，公司担任山西省投资基金业协会副会长单位，在“山西资本市场转型发展年会”上获得辖区机构“金飞翼”奖。 公司目前是综改区新能源产业和高端装备制造产业两支子基金共160亿元规模的管理机构，发起设立了规模100多亿元的“山西燃气产业发展基金”和“山西氢能源产业发展基金”等系列国企转型提质增效升级基金；发起设立山西省氢能全产业链发展基金、山西晋信文化产业基金、山西清洁能源产业发展基金、山西省城镇化发展基金等省重点产业发展基金；发起管理定襄法兰产业升级发展基金、“一带一路”（祁县）中小企业特色产业合作发展基金等县域经济发展基金；与江苏金茂、上海君桐等市场主流投资机构共同设立了总规模为5065万元的新兴产业市场化系列基金，截至目前，项目运作安全、收益可期。 截止目前，公司荣获了2018年国信集团“年度综合考评第一名”及“优秀基层党组织”称号，被山西省直机关精神文明委员会评为“2018年度省直文明单位”。 经营范围：受托管理股权投资企业，从事股权投资管理及相关咨询服务（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）。",
              picture: "/profile/upload/content/2023/02/63f70f1d7d74b.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea69293bb22f.jpg",
              companyName: "山西省产业基金管理有限公司",
              sort: 22,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:51:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:09:16",
              remark: null,
              id: 4301,
              menuId: 2186,
              title: "城建投",
              subtitle: null,
              keywords: "",
              description:
                "山西城投系金控集团全资子公司，成立于2017年8月1日，作为我省城市建设投资的新生力量，山西城投自成立伊始，便以“提升城市配套功能、提高居民幸福指数”为企业担当，以打造具有人文气息、时代特色、前瞻视野的新城投为努力目标，创新发展、多元并进，布局了“类金融、土地开发、PPP项目投资及幸福产业”四大业务板块，旗下8个子公司，对全省7市18县形成投资覆盖，服务地方经济社会发展的能力得到显著增强。未来，山西城投将继...",
              copyFrom: null,
              content:
                "山西城投系金控集团全资子公司，成立于2017年8月1日，作为我省城市建设投资的新生力量，山西城投自成立伊始，便以“提升城市配套功能、提高居民幸福指数”为企业担当，以打造具有人文气息、时代特色、前瞻视野的新城投为努力目标，创新发展、多元并进，布局了“类金融、土地开发、PPP项目投资及幸福产业”四大业务板块，旗下8个子公司，对全省7市18县形成投资覆盖，服务地方经济社会发展的能力得到显著增强。 未来，山西城投将继续发扬“开拓创新、合作包容、务实高效、勇争一流”的企业精神，继续发挥投融资平台的传统优势和独特作用，协调推进投融资业务、金融业务、实体业务，持之以恒务实笃行，以一己之重为金控集团乃至全省全国发展大局添秤。 业务领域：投资类 经营范围：主要从事城市基础设施建设的投资和经营；金融服务、资产托管；土地开发；餐饮服务、食品生产、食品经营。",
              picture: "/profile/upload/content/2023/02/63f70de7e18ce.jpg",
              officialUrl: "http://www.sxsctjt.com",
              homePageUrl: "www.sxsctjt.com",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6927c3d00d.jpg",
              companyName: "山西省城建投融资管理集团有限公司",
              sort: 21,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:48:16",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:09:34",
              remark: null,
              id: 4300,
              menuId: 2186,
              title: "国信医投",
              subtitle: null,
              keywords: "",
              description:
                "山西国信医疗健康投资管理有限公司成立于2016年10月，注册资本1亿元，主要经营范围包括：对医疗、养老行业投资及资产委托管理；医疗服务；医药咨询服务；医疗器械批发零售等。目前业务涉足基层医疗服务、医疗器械贸易、母婴健康管理及商业保理等业务领域。隶属于山西金融投资控股集团有限公司。国信医投始终坚持以国家支持医疗体制改革为契机，以政府政策为导向，坚持稳中求进总基调，积极寻求市场机遇，不断探索业务领域，不断提高...",
              copyFrom: null,
              content:
                "山西国信医疗健康投资管理有限公司成立于2016年10月，注册资本1亿元，主要经营范围包括：对医疗、养老行业投资及资产委托管理；医疗服务；医药咨询服务；医疗器械批发零售等。目前业务涉足基层医疗服务、医疗器械贸易、母婴健康管理及商业保理等业务领域。隶属于山西金融投资控股集团有限公司。 国信医投始终坚持以国家支持医疗体制改革为契机，以政府政策为导向，坚持稳中求进总基调，积极寻求市场机遇，不断探索业务领域，不断提高管理水平，强化团队建设，企业实力和规模不断扩大。目前，公司下设一室五部：综合办公室、财务部、资本运营部、项目管理部、风控部、贸易部。下设四个子公司：山西国信博爱母婴健康管理有限公司、山西国信迅达医疗器械有限公司、深圳国信海诚商业保理有限公司、山西国信医疗服务有限公司。 国信医投作为一家专门投资医疗、健康产业的国有投资机构，致力于构建涵盖国有投融资平台、医疗服务、健康管理、医药耗材供应等为一体的全产业链，服务我省的医疗体制改革，优化医疗资源配置。 业务类别：投资类 经营范围：以自有资金对医疗、养老行业投资及资产委托管理（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）；医疗服务；医药咨询服务；企业管理咨询服务；商务咨询服务；会议及展览服务；医疗器械经营：医疗器械批发零售；煤炭批发零售、铁矿石批发。",
              picture: "/profile/upload/content/2023/02/63f70ee4d2fe7.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea69260afcdf.jpg",
              companyName: "山西国信医疗健康投资管理有限公司",
              sort: 20,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:45:06",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:42",
              remark: null,
              id: 4299,
              menuId: 2186,
              title: "投融资",
              subtitle: null,
              keywords: "",
              description:
                "山西省国有投融资管理有限公司（以下简称“投融资公司”）成立于2016年9月，属山西金融投资控股集团有限公司全资控股子公司，注册资本金1亿元。公司营业执照是山西省首家“五证合一、一照一码”执照。投融资公司经营范围涵盖国有资本运营及资产管理；投资管理及相关咨询服务（不含证券、期货投资咨询）；担保业务（不含融资性担保）；国内外贸易、供应链管理及金融服务。为顺应国家供给侧结构性改革中大力推动供应链发展战略政策趋...",
              copyFrom: null,
              content:
                "山西省国有投融资管理有限公司（以下简称“投融资公司”）成立于2016年9月，属山西金融投资控股集团有限公司全资控股子公司，注册资本金1亿元。公司营业执照是山西省首家“五证合一、一照一码”执照。 投融资公司经营范围涵盖国有资本运营及资产管理；投资管理及相关咨询服务（不含证券、期货投资咨询）；担保业务（不含融资性担保）；国内外贸易、供应链管理及金融服务。 为顺应国家供给侧结构性改革中大力推动供应链发展战略政策趋势，结合山西省被中央指定为首个能源革命综合改革试点省份，按照国家对山西省重大决策部署及指示精神和我省对供应链管理服务发展思路及山西金控集团业务板块结构特点，投融资公司将“以山西支柱能源产业为依托，通过植入‘区块链+供应链’双链结构，形成完整的网络化、生态化供应链管理服务模式，打造山西优秀的供应链管理服务平台旗舰企业 ”确定为公司战略发展目标。通过依托大型国有企业及上市企业平台优势及资源优势，国内知名数字技术企业技术优势，打造供应链管理服务平台，聚焦能源及相关产业，以物流为基石，电商交易为引擎，供应链金融为抓手，数字化智慧供应链平台为支撑，打造“区块链+物联网”智慧供应链金融服务平台，搭建从资金、管理、仓储、运输到客户的全流程供应链服务。 投融资公司投资业务主要以股权为主，下设全资子公司——山西国盈富通股权投资管理有限公司（以下简称“国盈富通”），是投融资公司私募股权投资的业务平台，于2018年5月设立，注册资本2000万元。私募基金管理人备案登记编码为： P1070314。经营范围为：受托管理股权投资企业，从事股权投资管理及相关咨询服务。 国盈富通秉持“国富民强，通盈四方”的初心和“市场化运营、专业化管理”的理念立足山西，面向全国开展业务，着力发挥自身在政府、产业和企业等不同层面和主体间的资源整合优势，着重服务于山西省提质增效的传统行业及转型升级的战略新兴产业，主要有节能环保、智能制造、军民融合、大健康、乡村振兴等领域。投资产品主要有产业基金、并购基金、定增基金等。 投融资公司自成立以来，先后获得团省委及人社厅命名的“省级青年文明号”单位、中国物流与采购联合会确定为“中物联金融委副会长单位”，“2019年中国物流与供应链金融服务创新企业”、集团公司颁发的“2017年度先进基层党组织”、“2017年度先进集体”“2018年度先进基层党组织”“标准化党支部”“庆祝改革开放40周年合唱比赛一等奖”“道德风尚奖”等荣誉。 未来的投融资公司将以“锻造资本纽带、建造资本桥梁、打造发展舞台、创造更大价值”为使命，以“打造山西省供应链管理服务旗舰企业，建成省内一流国有资产管理、投融资平台”为目标，以“自然、自强、自省、自勉、自信、自立”的核心价值观，大力提高国有资本配置和运营效率，提升资源整合能力，助推产业转型升级。 业务领域：投资类 山西省国有投融资管理有限公司经营范围： （一）国有资本运营及资产管理； （二）投资管理及相关咨询服务（不含证券、期货投资咨询）； （三）担保业务（不含融资性担保）； 国内外贸易（法律禁止的除外）。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。",
              picture: "/profile/upload/content/2023/02/63f70d7768cf4.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6923a9eb0a.jpg",
              companyName: "山西省国有投融资管理有限公司",
              sort: 19,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:42:05",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:31",
              remark: null,
              id: 4298,
              menuId: 2186,
              title: "清洁投资",
              subtitle: null,
              keywords: "",
              description:
                "山西金信清洁引导投资有限公司是山西金融投资控股集团有限公司旗下的国有独资地方金融类企业，是政府、财政引导资金的出资人代表，致力于打造全国一流的政策性、专业性兼具公益性的政府指导与市场化运营有机结合的省级资本运营和管理平台。目前管理并运营着总规模100亿元的山西省煤炭清洁利用投资基金和总规模100亿元的山西省政府和社会资本合作（PPP）融资支持基金。曾荣膺“2018年度山西转型发展创新新动力企业”“山西省金融...",
              copyFrom: null,
              content:
                "山西金信清洁引导投资有限公司是山西金融投资控股集团有限公司旗下的国有独资地方金融类企业，是政府、财政引导资金的出资人代表，致力于打造全国一流的政策性、专业性兼具公益性的政府指导与市场化运营有机结合的省级资本运营和管理平台。目前管理并运营着总规模100亿元的山西省煤炭清洁利用投资基金和总规模100亿元的山西省政府和社会资本合作（PPP）融资支持基金。 曾荣膺“2018年度山西转型发展创新新动力企业”“山西省金融系统优质服务先进单位”“山西省金融系统优质服务杰出标兵单位”“山西省金融系统五一劳动奖状”等荣誉称号，成为我省基金行业的示范标杆和领跑者。 公司经营范围： 煤炭清洁能源利用的投资管理；政府、财政对外投资的管理;参股、控股或者委托设立基金管理公司；政府引导资金的投资管理；政府与社会资本合作项目的咨询服务；资产管理;投融资方案咨询服务；财务会计咨询服务。",
              picture: "/profile/upload/content/2023/02/63f70eaf2cca3.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea692269a18b.jpg",
              companyName: "山西金信清洁引导投资有限公司",
              sort: 18,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:38:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:22",
              remark: null,
              id: 4297,
              menuId: 2186,
              title: "国信文旅",
              subtitle: null,
              keywords: "",
              description:
                "山西国信文化旅游投资发展集团有限公司成立于2012年3月13日，是山西金融投资控股集团有限公司的全资子公司，注册资本3亿元。公司经营范围涵盖了文化旅游、房地产、生态修复、园林绿化、商务服务等多个业务领域的投资及管理；具体包括旅游地产、农业旅游、研学旅行及金融科技、商务、教育、便民等相关服务领域的业务。公司建立了现代化法人治理结构，党委领导班子成员通过法定程序进入董事会、经理层任职；公司内设7个部门负责投资、...",
              copyFrom: null,
              content:
                "山西国信文化旅游投资发展集团有限公司成立于2012年3月13日，是山西金融投资控股集团有限公司的全资子公司，注册资本3亿元。公司经营范围涵盖了文化旅游、房地产、生态修复、园林绿化、商务服务等多个业务领域的投资及管理；具体包括旅游地产、农业旅游、研学旅行及金融科技、商务、教育、便民等相关服务领域的业务。 公司建立了现代化法人治理结构，党委领导班子成员通过法定程序进入董事会、经理层任职；公司内设7个部门负责投资、融资、风控、党群等日常运营工作；下设山西国信园林绿化工程有限公司、山西国信文旅商务服务有限公司、山西立体停车场有限公司3个全资子公司和山西国信山水园有限公司1个参股子公司，围绕公司各类主营业务，搭建了权责明确、务实高效、监督制衡的科学管理体系。 公司秉承“创新驱动、追求卓越”的企业精神，坚持“围绕主业谋发展，发挥优势求突破”的战略方针；按照“发挥资源优势，坚持绿色发展，聚焦创新驱动，争做行业标杆”的发展思路；一手抓主责，一手抓主业，“两手抓、两手硬”，努力打造全省文化旅游投资行业的示范标杆。 经营范围：园林绿化、旅游、房地产、文化产业、停车场等的投资。 业务领域：投资类",
              picture: "/profile/upload/content/2023/02/63f70e75b9653.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691df04d1b.jpg",
              companyName: "山西国信文化旅游投资发展集团有限公司",
              sort: 15,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:31:45",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:12",
              remark: null,
              id: 4296,
              menuId: 2186,
              title: "山西光信",
              subtitle: null,
              keywords: "",
              description:
                "山西省光信地产投资集团有限公司成立于1992年10月28日，隶属于山西金融投资控股集团有限公司，注册资本3.19亿元，国家一级房地产开发资质。公司经营范围包括开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售等。山西光信本部在职员工50余人，设9个职能部室，下设山西帝景房地产...",
              copyFrom: null,
              content:
                "山西省光信地产投资集团有限公司成立于1992年10月28日，隶属于山西金融投资控股集团有限公司，注册资本3.19亿元，国家一级房地产开发资质。 公司经营范围包括开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售等。 山西光信本部在职员工50余人，设9个职能部室，下设山西帝景房地产开发有限公司、品德实业（太原）有限公司、山西毛条厂、山西国信物业管理服务有限公司四个全资子公司，参股太原晋信卓惠城建投资中心（有限合伙）。 山西光信创立于中国房地产发展的黄金年代，成立以来，先后取得ISO 9001质量管理体系认证、ISO14000环境管理体系认证和OHSAS18000职业健康安全管理体系认证。通过多年深耕太原房地产市场，贡献了多个精品楼盘，逐渐在我省财政、金融系统获得了良好的口碑。秉承国企声誉和晋商品格，传承严谨的工作作风和企业管理特色，项目选址精准、定位清晰、品质优良、价格适中，既符合城市发展方向，又适当提前布局，使各项目成为当时太原房地产市场的宠儿和焦点。取得国家一级房地产开发资质后，光信品牌价值得到了巨大提升，成为太原乃至山西省内房地产行业知名房企，获得了市场和业界的广泛认可。 山西光信秉承国企实力，始终坚持“品质于形，服务于心”的品牌理念，恪守“厚生明德，创新至善”的核心价值观，坚持“殚精竭虑谋划，一丝不苟执行”的工作作风，形成了独具光信特色的企业八大文化，全力为广大业主打造 “专业化、精细化、个性化”产品。近年来，山西光信积极探索“地产+”发展新思路，向金融、健康、教育、文旅、商业等产业，向家装、物业、租赁、智慧社区等上下游延伸产业链，不断向着“做山西地产界有独特竞争力、受尊重的龙头企业”的企业愿景迈进。 经营范围：实业类：房地产开发：开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
              picture: "/profile/upload/content/2023/02/63f70400cebb5.jpg",
              officialUrl: "http://sxgxdc.com",
              homePageUrl: "http://sxgxdc.com",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691c560860.jpg",
              companyName: "山西省光信地产投资集团有限公司",
              sort: 14,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:25:54",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:01",
              remark: null,
              id: 4295,
              menuId: 2186,
              title: "山西国贸",
              subtitle: null,
              keywords: "",
              description:
                "山西省国贸投资集团有限公司（以下简称“山西国贸”）前身为成立于2002年1月的山西国际贸易中心有限公司，系山西金融投资控股集团有限公司的全资子公司。山西国贸注册资本金为36000万元。2018年8月14日，公司更名为“山西省国贸投资集团有限公司”。山西国贸的经营范围为：对非上市公司的股权、上市公司非公开发行的股权等非公开交易的股权投资以及相关的咨询服务；自有房屋的租赁；房地产经纪服务；物业服务。山西国贸始终坚持“金...",
              copyFrom: null,
              content:
                "山西省国贸投资集团有限公司（以下简称“山西国贸”）前身为成立于2002年1月的山西国际贸易中心有限公司，系山西金融投资控股集团有限公司的全资子公司。山西国贸注册资本金为36000万元。2018年8月14日，公司更名为“山西省国贸投资集团有限公司”。 山西国贸的经营范围为：对非上市公司的股权、上市公司非公开发行的股权等非公开交易的股权投资以及相关的咨询服务；自有房屋的租赁；房地产经纪服务；物业服务。 山西国贸始终坚持“金融立企、实业兴企、产融结合”的发展思路，将股权投资与供应链金融确立为公司改革转型发展的重要目标，现已发展成为拥有山西国贸大饭店管理有限公司、山西国际贸易中心有限公司、山西国贸物业管理有限公司、山西国贸能源科技有限公司、晋融汇通（天津）商业保理有限公司五个子公司，涉足写字楼综合运营、商业综合管理服务、住宿餐饮、商业保理、股权投资等多个领域的重要省属企业。 在写字楼运营领域，山西国贸运营着山西第一家集五星级酒店、三甲写字楼、高档公寓、会展中心于一体的综合性项目——山西国际贸易中心，以卓越的硬件设施与优质的物业服务，赢得了广大用户的称赞，取得了良好的社会效益。作为山西国贸写字楼的重要配套，山西国贸大饭店于2004年1月正式运营，是山西省首家五星级饭店，并以管理输出的方式陆续承接了晋学苑、平型关国际酒店、省委应急指挥中心等项目；山西国贸物业管理有限公司成立于2003年7月，是拥有国家二级资质的专业物业服务机构，主要负责山西国际贸易中心的物业服务，山西国际贸易中心项目先后荣获“全国物业管理示范大厦”、五星级小区（大厦）。 在商业管理领域，山西国贸以新零售理念为引领，以实体门店、电子商务、移动互联网为核心，通过融合线上线下，重构人、货、场等核心要素，以“全场景、全数据、全渠道、全时段、全体验、全品类”的零售新模式、以股权投资合作等金融手段，持续拓展新的商业项目，开拓商业连锁运营的新局面，打造独树一帜的“国贸”新品牌。 在商业保理领域，山西国贸将坚持推动能源供应链管理与商业保理业务的互融互促，加大与省内外知名供应链管理企业的合作力度，围绕大型省属能源集团企业客户，做好电力行业这一垂直细分领域的商业保理服务，努力实现核心企业、供应商、保理商三方的互利共赢，着力为供应链中小企业缓解融资难题，切实为保障省内能源供应链畅通贡献力量。 在股权投资领域，围绕山西省委关于构建现代产业体系的重大部署，山西国贸灵活运用股权投资手段，加大现代物流、能源科技、生物医药、人工智能等领域的投资力度，通过并购符合公司战略方向与发展业态的企业股权，持续优化资产布局。 “全球化视野”、“创新变革”、“开放包容”、“差异化运营”是山西国贸的核心价值观，支撑国贸走出了独具特色的发展路径，形成了多板块投资、聚焦类金融的经营格局。跨入新时代，面对新机遇，山西国贸将不断提升自我，奉行“关爱客户、注重品质”的价值理念，用勇气和智慧拥抱时代变革，用诚信与包容携手合作伙伴，用激情和卓越开创企业高质量发展的新局面。",
              picture: "/profile/upload/content/2023/02/63f7046c59a83.jpg",
              officialUrl: "http://shanxigomo.com/",
              homePageUrl: "http://shanxigomo.com/",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691ad58cc9.jpg",
              companyName: "山西省国贸投资集团有限公司",
              sort: 13,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:22:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:12:50",
              remark: null,
              id: 4294,
              menuId: 2186,
              title: "太行基金",
              subtitle: null,
              keywords: "",
              description:
                "为支持山西省供给侧结构性改革、综改示范区建设、国企改革，推动战略新兴、文化旅游、大数据、电子信息等产业以及民营企业、中小企业等发展，服务实体经济发展，加快培育新动能，促进我省经济转型升级、提质增效，根据《山西省政府投资基金管理暂行办法》，山西省政府特设立山西省太行产业投资基金。太行产业投资基金采用母子基金结构，其中母基金总规模为人民币300亿元，由山西金融投资控股集团有限公司作为财政出资人认缴100亿元...",
              copyFrom: null,
              content:
                "为支持山西省供给侧结构性改革、综改示范区建设、国企改革，推动战略新兴、文化旅游、大数据、电子信息等产业以及民营企业、中小企业等发展，服务实体经济发展，加快培育新动能，促进我省经济转型升级、提质增效，根据《山西省政府投资基金管理暂行办法》，山西省政府特设立山西省太行产业投资基金。 太行产业投资基金采用母子基金结构，其中母基金总规模为人民币300亿元，由山西金融投资控股集团有限公司作为财政出资人认缴100亿元；由山西太行产业投资基金管理有限公司作为基金管理人向社会合格投资者募集200亿元；在子基金层面，采用包括母基金管理人在内的双管理人模式，最终形成总规模为1050亿元的产业投资基金。 山西太行产业投资基金管理有限公司成立于2017年8月22日，注册资本2亿元，由山西金控独资设立。公司作为省级政府投资基金管理机构，主要从事省级政府投资基金的管理，并适时探索推进市场化基金业务。 业务定位：一是管理省级政府投资母基金；二是设立并管理直投基金，开展直投基金业务；三是参与设立各类子基金。在基金理事会的直接领导下，按照遴选标准遴选优秀的子基金管理机构，并进行管理、监督、考核与评价。根据省委、省政府安排，落实相关重大经济决策。 经营范围：管理或受托管理股权类投资并从事相关咨询服务业务。",
              picture: "/profile/upload/content/2023/02/63f6d4f46c760.jpg",
              officialUrl: "http://www.shanxith.cn",
              homePageUrl: "www.shanxith.cn",
              homePagePicture:
                "/profile/upload/content/2017/11/5a0152489bf39.jpg",
              companyName: "山西太行产业投资基金管理有限公司",
              sort: 12,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-11-07 11:46:46",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:39",
              remark: null,
              id: 4293,
              menuId: 2186,
              title: "山西金租",
              subtitle: null,
              keywords: "",
              description:
                "山西金融租赁有限公司是1992年由山西省计划委员会、省工商银行和省建设银行合资组建，经中国人民银行批准设立的主营融资租赁业务的非银行金融机构。注册资本5亿元人民币，股东为山西金融投资控股集团有限公司。公司成立二十多年来，秉承“诚信、勤勉、稳健、创新”的经营理念，充分发挥融资租赁这一独特金融工具融资融物、加速技术进步、促进产业升级等显著优势，已在企业技术改造、交通运输、能源环保、工程机械、医疗印刷等领域为...",
              copyFrom: null,
              content:
                "山西金融租赁有限公司是1992年由山西省计划委员会、省工商银行和省建设银行合资组建，经中国人民银行批准设立的主营融资租赁业务的非银行金融机构。注册资本5亿元人民币，股东为山西金融投资控股集团有限公司。 公司成立二十多年来，秉承“诚信、勤勉、稳健、创新”的经营理念，充分发挥融资租赁这一独特金融工具融资融物、加速技术进步、促进产业升级等显著优势，已在企业技术改造、交通运输、能源环保、工程机械、医疗印刷等领域为众多企事业单位提供融资租赁服务，为促进经济发展做出了积极努力。与此同时，公司也在与企业的合作过程中取得了良好的经济效益和社会效益，公司自成立以来保持持续盈利，并精心打造了一个管理高效、服务一流、信誉卓著的金融租赁品牌。",
              picture: "/profile/upload/content/2017/12/5a2a2b7b7fd4d.jpg",
              officialUrl: "http://www.leasing.com.cn/",
              homePageUrl: "www.leasing.com.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefe3452235.jpg",
              companyName: "山西金融租赁有限公司",
              sort: 7,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:47:51",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:52",
              remark: null,
              id: 4292,
              menuId: 2186,
              title: "山西再担保",
              subtitle: null,
              keywords: "",
              description:
                "山西省融资再担保集团有限公司是省委、省政府为促进小微企业和“三农”发展而成立的省级政策性担保机构，现为山西金融投资控股集团有限公司全资子公司。公司前身为“山西省中小企业信用担保有限公司”，成立于2000年7月，于2015年11月改制为“山西国信融资再担保有限公司”，2017年6月更名为“山西省融资再担保有限公司”。2018年10月更名为“山西省融资再担保集团有限公司”。截止2018年底，注册资本金188260万元，总资产236700万...",
              copyFrom: null,
              content:
                "山西省融资再担保集团有限公司是省委、省政府为促进小微企业和“三农”发展而成立的省级政策性担保机构，现为山西金融投资控股集团有限公司全资子公司。公司前身为“山西省中小企业信用担保有限公司”，成立于2000年7月，于2015年11月改制为“山西国信融资再担保有限公司”，2017年6月更名为“山西省融资再担保有限公司”。2018年10月更名为“山西省融资再担保集团有限公司”。截止2018年底，注册资本金188260万元，总资产236700万元。 多年来，公司秉持“传导全省产业政策，提升行业担保能力，引导行业规范经营，化解行业担保风险”的经营方针，开展再担保、融资担保、非融资担保、创业贷款担保、委托贷款和投资理财、企业咨询等业务。 成立以来，公司稳步发展，服务实体经济与小微企业能力逐渐凸显，经济效益和社会效益齐头并进，累计为全省9300余户中小微企业和“三农”客户担保近600亿元，带动企业及三农增加销售收入约1000亿元，增加利税约100亿元，解决就业岗位20余万个。担保业务范围覆盖全省11个地级市，与我省8个市级担保机构开展再担保合作，银行授信总额超过100亿元，推动了我省担保体系建设。荣膺“全国十大最具影响力中小企业信用担保机构”、全国“最具影响力再担保机构”、 “全国中小企业融资担保创新奖”。 未来，公司将继续秉承“诚信、廉洁、务实、创新”的企业文化，进一步发挥准公共产品的作用，服务我省供给侧结构性改革和综改区建设，为我省经济转型发展贡献更多力量。",
              picture: "/profile/upload/content/2017/12/5a2a2b8c55e56.jpg",
              officialUrl: "http://www.sxsrzzdb.com/",
              homePageUrl: "www.sxsrzzdb.com",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefde1652b5.jpg",
              companyName: "山西省融资再担保集团有限公司",
              sort: 6,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:46:27",
              menuParentId: null,
              searchContent: null,
            },
          ],
          dynamicList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-29 10:25:45",
              remark: null,
              id: 5310,
              menuId: 2048,
              title: "中煤保险作品获评“中国保险业2024年度好新闻”",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "近日，在国家金融监督管理总局的指导下，中国保险行业协会发布“中国保险业2024年度好新闻”，公司《中煤保险创新探索服务新模式——专业型特色化保险护航发展之路》稿件在341件参评作品中脱颖而出，入选年度好新闻榜单（公司组）。 本篇报道总结了近年来公司在发挥经济减震器和社会稳定器功能方面的突出贡献，展现出公司在做好绿色金融、普惠金融等方面的创新举措和显著成效，为宣传保险业高质量发展营造了良好舆论氛围。 此次奖项不仅是对中煤保险宣传工作的高度肯定，更是激励前行的强劲动力。站在新的起点上，中煤保险将持续深化宣传工作，聚焦服务实体经济、乡村振兴、绿色发展等核心领域，挖掘更多鲜活的保险服务案例，加强与行业媒体、主流平台的深度合作，传递保险行业的责任与担当，讲好保险保障民生的生动故事。 信息来源：中国保险行业协会微信公众号",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2025-04-29 10:25:08",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-24 11:10:05",
              remark: null,
              id: 5293,
              menuId: 2048,
              title: "中煤保险召开2025年全面从严治党暨党风廉政建设工作会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "中煤保险",
              content:
                "2025年3月18日，公司党委召开2025年全面从严治党暨党风廉政建设工作会议。省纪委监委驻集团纪检监察组李立国副组长出席会议并发表讲话，公司党委书记、董事长郭建民，党委委员、纪委书记李慧明分别作工作报告。会议由党委副书记、总经理张振军主持，公司领导班子成员、各党组织书记、各部门负责人、分（子）公司班子成员及党员代表共同参加。 李慧明带领大家学习了二十届中央纪委四次全会精神、山西省纪委十二届五次全会精神及集团全面从严治党会议精神，回顾总结了公司2024年度纪检工作，对2025年工作进行了安排部署。一是紧紧围绕“两个维护”，强化政治监督。二是健全完善监督体系，做实做精日常监督。三是加强作风建设，推动党的作风持续向好。四是一体推进“三不腐”，净化政治生态。五是加大严管严治，努力建设一支忠诚干净担当的纪检铁军。 郭建民全面回顾总结2024年全面从严治党和党风廉政建设工作，对2025年工作提出六点要求。一是全面加强党的领导，推动政治监督具体化、精准化、常态化。二是将巡视巡察整改等纳入政治监督范围，常态化开展整改监督。三是巩固深化党纪学习教育成果，认真开展深入贯彻中央八项规定精神学习教育。四是严格执行新形势下党内政治生活若干准则，创建“一支部一特色”党建品牌。五是建设高素质专业化干部人才队伍，激活队伍活力。六是压实全面从严治党政治责任，加强对分（子）公司“一把手”和年轻干部的监督管理。 李立国副组长对中煤保险落实全面从严治党五项责任，带动各项工作取得的新成效给予了充分肯定，对下一步工作提出五点希望。一是以持续深化“三必有”机制为重点，全面加强金融系统党的建设。二是以贯彻落实中央八项规定精神学习教育为重点，切实强化作风建设。三是以风腐险同查同治为重点，一体推进惩治金融腐败和防控金融风险。四是以全面准确贯彻“四种形态”为重点，切实营造遵规守纪、干事创业的良好氛围。五是以“规范化法治化正规化建设年”为重点，加强纪检队伍自身建设。 会议最后，全体参会同志集中观看党风廉政警示教育片。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2025-03-24 11:09:53",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-02-25 10:58:01",
              remark: null,
              id: 5286,
              menuId: 2048,
              title: "中煤保险受邀参加运城市政金企对接暨向民间资本推介项目活动",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "中煤保险",
              content:
                "2025年2月21日，运城市首季“开门红”政金企对接暨向民间资本推介项目活动盛大开幕。中煤保险党委书记、董事长郭建民，党委委员、副总经理兼山西分公司党委书记、总经理冀宪钧受邀参加此次活动。 （图片来源：运城日报） 本次活动由中共运城市委、运城市人民政府联合主办，旨在通过搭建政府、金融机构与企业间沟通合作桥梁，深化政金企合作，推动金融资源与实体经济精准对接，为运城高质量发展注入强劲新动能。中煤保险凭借在助力地方经济发展中取得的良好成绩，荣获“运城高质量发展（金融贡献）先进集体奖”。 （图片来源：运城日报） 会议现场，中煤保险运城中支与闻喜县卓生越种植专业合作社达成金融服务合作协议，通过定制化保险产品助力乡村振兴。 中煤保险将持续夯实专业核心及特色创新优势，按照运城市优化金融生态，激发民间投资活力，促进民营经济发展壮大的各项政策要求，积极发挥金融保障功能，深度参与地方经济建设，为乡村振兴和实体经济发展提供更多创新保险产品和服务，助力运城市实现高质量发展目标。",
              picture:
                "/profile/upload/image/2024/12/10/97eb236f-128f-4a63-80cb-bf690dc5f1d4.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2025-02-25 10:47:40",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-02-06 15:32:42",
              remark: null,
              id: 5271,
              menuId: 2048,
              title: "新春复工干劲足，凝心聚力向未来",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "中煤保险",
              content:
                "2月5日，春节后的首个工作日，春和景明、惠风和畅，全体员工元气满满返岗复工，处处洋溢着万象更新的蓬勃朝气。 公司党委书记、董事长郭建民携公司领导班子，通过现场加视频的方式，向全体员工送上了诚挚的新春祝福，传递了对每一位员工辛勤工作的深深敬意和衷心祝愿。 郭建民亲临一线，来到消保中心向员工致以问候，详细询问了客服消保室春节期间整体服务情况和小案管理案件线上理赔处理情况，重点关注灾害天气、重特大交通事故对报案量的影响，对消保中心上下一心、协同作业、高效服务予以肯定，勉励大家保持积极向上的工作状态，持续、稳定提升服务质效，加强高科技工具的应用，为客户提供专业、高效、品质服务。 郭建民一行深入办公楼层，实地查看消防设施、疏散通道和安全出口等情况，对消防设施的完好率、使用状况进行了仔细检查。他要求，全体员工要时刻保持消防安全意识，熟练掌握消防设施的使用方法，细化安全生产措施，加大安全培训力度，确保公司安全生产形势持续稳定。 新年伊始，公司召开周例会，对节后工作进行了全面细致的安排和部署。公司上下信心满满，纷纷表示，将以更加饱满的热情、更加昂扬的斗志，全身心投入到工作中，携手并肩精心擘画专业型特色化高质量转型发展的崭新蓝图！",
              picture:
                "/profile/upload/image/2024/12/10/9130c78e-de72-4855-9309-08a38bafb843.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2025-02-06 15:30:22",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-01-27 18:55:27",
              remark: null,
              id: 5270,
              menuId: 2138,
              title: "金控资本召开2024年度述职大会",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "金控资本",
              content:
                "不负五载好年华 身担重任再出发 ——金控资本召开2024年度述职大会 2025年1月23日，金控资本召开2024年度述职会议，会议检视复盘工作成果，系统总结经营情况，梳理启发工作思路，为重点工作推进与公司未来发展蓄势赋能。金控资本班子成员与全体干部职工参加会议。 会上，经营层分别汇报了存量项目资产盘活、子公司股权划转、市场化投资机构沟通渠道构建、项目投资模型完善等方面的收获体会，提出了持续提升工作质效、做好压力传导与紧抓团队管理的目标要求。公司干部职工依次进行述职，对自身工作开展情况、存在不足之处、改进努力方向进行精炼陈述。大家结合工作实际深刻剖析，说经验、讲不足、论未来。公司领导既肯定成绩，又直击问题，会议气氛严肃而热烈。 会议指出，公司发展既要看到干事氛围风清气正、职能定位方向明确、资产质量优良的有利一面，也要看到与各类主体联系不深不密、市场化经验欠缺、中后台支撑不足的短板弱环。要求全体干部职工持续提升专业水平，强化事务处理能力，保持积极进取心态，向着能力突出、上级满意、业界认可的目标一道努力。 会议强调，“1777个日夜，是每个金控资本人的奋斗足迹”。公司自2020年3月13日成立以来，已将满五个年头。从集团整合、部门组建，到公司成立、开启业务实践，再到团队不断成长、业务不断发展，公司一路走来承载了每个人的努力与心血，是辛苦付出的结晶与集体奋斗的见证。“脚踏实地去锻炼磨砺，是提升能力的攀登阶梯”。公司团队整体年龄较轻，缺少经验就要多磨练，提升能力就得“事上见”。做事要保持恒心、常怀公心、处处用心。敢于实践，而不应当畏首畏尾；放眼长远，不计一时利益得失。充分发挥主观能动性提升专业能力与综合素养。“奋斗实现美好未来，是对公司发展的殷切期许”。政府投资基金是国家高度重视、省政府重点关注、集团持续聚焦的重要工作，公司作为省级政府投资基金引导资金管理平台的管理机构，责任重大、使命光荣、机遇难得，全体干部职工要提高政治站位，全力投入工作，坚决完成任务，用笃行不怠、奋斗不息的劲头，把公司的“发展潜力”兑现为“发展实力”。 “重新出发，再创佳绩”。既是公司主要领导的衷心祝愿，也是每名员工的奋斗目标。2025年，金控资本上下将锚定重点任务与经营目标，团结一致、全力以赴，以方向不偏、力度不减、靶心不散的毅力与恒心，坚持做好“难而正确的事”，奋力谱写公司高质量发展新篇章。",
              picture:
                "/profile/upload/image/2024/12/10/6ba7d6d5-209a-4daf-a54f-eb5c9960e020.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "jkzb",
              inputTime: "2025-01-27 18:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-01-24 12:11:59",
              remark: null,
              id: 5269,
              menuId: 2048,
              title: "中煤保险召开2025年度工作会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "中煤保险",
              content:
                "中煤保险于1月20-21日召开2025年度工作会议。公司党委书记、董事长郭建民做年度工作报告，党委副书记、副董事长、总经理张振军主持会议并做经营工作报告。公司独立董事、领导班子成员、各部门负责人、各分（子）公司班子成员、各业务及管理条线相关人员参会。 郭建民全面回顾了公司2024年度经营情况，明确了2025年经营目标，对重点工作进行安排部署。他指出，2025年是公司承上启下的关键之年，全体员工要在集团公司的正确领导下，认真贯彻落实中央经济工作会议、中央金融工作会议精神，严格遵循国务院发布的保险业“国十条”、金融监管总局出台的财险业“二十条”等指引要求，坚定不移地坚守专业型特色化高质量转型发展战略定位，向连续六年稳定盈利目标奋勇前行。要持续加强党的领导，贯彻党代会精神凝聚发展向心力，以效益为导向持续优化险种结构，持续提升精细化经营管理能力、算账经营能力及合规经营能力，强化执行力确保经营目标达成。 张振军对2024年分机构、分险种经营情况及重点工作执行情况进行复盘总结，对达成2025年度经营目标进行具体部署。他要求，公司上下要以高度的执行力践行“简单、务实、高效、担当”的企业文化，推进公司各项战略部署及重点工作有效落地，全面提升车险精细化经营能力及风险管控能力，着力提升本土农险创新发展及合规发展动能，进一步加快提升非车险核心竞争优势，全力推进理赔提质增效，持续推动精细化经营管理成效再升级。 会议还听取了公司各业务条线、管理部门以及各分支机构工作报告。",
              picture:
                "/profile/upload/image/2024/12/10/8fff9349-8a5b-474c-87d7-e363bc553fab.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2025-01-24 12:10:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-01-13 16:07:24",
              remark: null,
              id: 5264,
              menuId: 2048,
              title:
                "中国共产党中煤财产保险股份有限公司第一次党员代表大会胜利召开",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "中煤保险",
              content:
                "2024年12月28日，中国共产党中煤财产保险股份有限公司第一次党员代表大会胜利召开。来自公司各级党组织的100名党员代表出席会议，公司部分领导班子及中层干部列席会议。 本次大会的主题是：以习近平新时代中国特色社会主义思想为指导，深入贯彻党的二十大和二十届二中、三中全会精神，落实中央经济工作会议、中央金融工作会议精神，按照省委省政府、国家金融监督管理总局决策部署和集团公司党委工作要求，党建引领强根基、笃行实干担使命、踔厉奋发启新程，团结带领公司各级党组织、广大党员干部真抓实干、久久为功，为公司专业型特色化高质量转型发展取得新成效不懈奋斗。 12月28日上午10时，中国共产党中煤财产保险股份有限公司第一次党员代表大会正式开幕，会场气氛庄严热烈，全场起立，奏唱中华人民共和国国歌。 在热烈的掌声中，郭建民同志代表公司党委作了题为《党建引领强根基 笃行实干担使命 奋力谱写专业型特色化高质量转型发展新篇章》的工作报告，系统总结回顾了公司党委近年来的高质量发展成效，分析研判了当前的形势任务，明确提出了下一阶段的奋斗目标与战略举措。 报告指出，公司党委以勤干为本、以实干为基、以善干为要，凝聚发展合力，取得高质量发展阶段性成效。一是深入践行“两个一以贯之”的要求，党的领导更加坚强有力；二是坚持不懈用党的理论武装头脑，进一步夯实理想信念根基；三是以党的领导为战略制定和实施提供坚强保证，推动“十四五”规划核心目标按进度如期实现；四是深入践行以企业改革发展成果检验党组织的工作和战斗力要求，经营管理水平显著提升；五是严格落实把国有企业基层党组织建设成为坚强战斗堡垒要求，基层党建工作更加扎实，党组织凝聚力、向心力、战斗力更强；六是深入践行新时代人才工作的新理念新战略新举措，干部人才队伍更有活力；七是深入践行全面从严治党要在国有企业落实落细的各项要求，政治生态更加清明。 报告强调，要加强党的领导，把握发展大局，砥砺担当作为，科学擘画高质量发展新蓝图。下一阶段要以习近平新时代中国特色社会主义思想为指引，带领全体党员干部员工紧密团结在一起，走好赶考路，奋进新征程：一是要加强党的全面领导，以高质量党建引领保障企业高质量发展；二是要以增强党组织的政治功能和组织力为重点，全面加强基层党组织建设；三是要把党管干部、党管人才的优势更好地转化为公司发展的前进源动力；四是要加强党风廉政建设，把党的纪律优势更好地转化为服务企业健康发展的内驱力；五是要保持战略定力，科学编制“十五五”规划；六是要对标行业先进主体，持续深化结构转型；七是要加快数智化转型，助力公司高质量发展；八是要苦练内功提质增效，为公司高质量发展固本培元；九是要防范风险守住底线，为公司高质量发展保驾护航；十是凝聚企业发展向心力，把党的群众优势更好地转化为企业发展的强大动力。 大会期间，与会代表以高度的责任感和使命感，严格执行选举程序与纪律要求开展换届选举各项工作。全体代表分四个代表团展开了分团讨论，对党委工作报告、纪委工作报告进行了认真讨论审议。在总监票人、监票人的监督下，大会以无记名投票方式差额选举产生了第一届党委委员和第一届纪委委员。大会还审议通过了党委工作报告的决议、纪委工作报告的决议及党费收缴使用管理情况报告。 郭建民同志在闭幕会上作了讲话。号召公司各级党组织把学习贯彻好这次大会精神作为当前和今后一段时间的重要任务，迅速兴起学习贯彻党代会精神的热潮，进一步统一思想和行动，凝聚智慧和力量，切实把大会精神转化为公司发展的生动实践。号召全体党员充分发挥模范带头作用，以更加昂扬的精气神、更加强大的战斗力来迎接新的挑战，夺取新的胜利，推动公司专业型特色化高质量转型发展迈上新的台阶。 在激昂的《国际歌》中圆满闭幕。大会闭幕后，中煤保险第一届党委、纪委分别召开了第一次全体会议，以无记名投票方式选举产生了第一届党委书记、副书记和第一届纪委书记。",
              picture:
                "/profile/upload/image/2024/12/10/640c04f0-54c1-467b-8643-6611c1c4f3d3.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zmbx",
              inputTime: "2024-12-31 16:58:18",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2024-10-31 10:21:02",
              remark: null,
              id: 5238,
              menuId: 2053,
              title: "中国银行山西省分行副行长刘溟一行到访山西再担保",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "山西再担保",
              content:
                "10月30日，中国银行山西省分行副行长刘溟一行到访山西再担保，就全省担保体系与中国银行合作的地方“总对总”批量担保模式、科技创新类业务担保模式、“惠担贷”线上担保业务模式进行交流座谈。 公司党委副书记、副董事长、总经理蔡绍青对刘溟行长一行表示热烈欢迎。他围绕公司基本情况、业务发展、信息化建设等方面进行了详细介绍，尤其是公司与中行的合作情况、目前合作中存在的难点、堵点问题等。 他表示，近年来，山西再担保与中行山西省分行通力合作，共同发挥作用，为全省小微企业高质量发展提供了有力支撑。下一步，双方要继续深化合作，共同增强地方“总对总”批量担保模式在地市落地效果，紧紧抓住科技创新专项担保业务的政策东风，在试点担保机构推动相关业务，总结经验教训，争取尽快在担保体系内推广落地，共同服务好我省转型发展大局。 刘溟行长充分肯定了以公司为龙头的全省融资担保体系与中国银行的合作成绩。他指出，全省政府性融资担保机构“市县一体化”运营改革后，中行与我省政府性融资担保机构合作飞速发展，中行山西省分行充分利用网点覆盖广、人员素质高、业务能力强等优势特点，不断深化银担合作，共同为我省小微企业提供更优质的普惠金融服务。他表示，要通过本次科技创新类业务合作，探索将担保嵌入专项产品服务的模式，共同推动系统直联、精准防控风险等方面合作，进一步精准化支持我省科技型中小企业，释放银担合作新动能。 公司党委委员、副总经理、山西融担执行董事杨英文，相关部门负责人，中国银行山西省分行普惠金融事业部总经理参加了此次座谈。",
              picture:
                "/profile/upload/image/2024/10/10/7d88f7aa-5860-4931-9d29-2076cde71bec.JPG",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "zdb",
              inputTime: "2024-10-31 09:21:44",
              menuParentId: null,
              searchContent: null,
            },
          ],
          partyList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-12-04 11:29:38",
              remark: null,
              id: 3885,
              menuId: 2159,
              title:
                "山西省总工会党组书记、常务副主席梁敬华莅临山西金控调研指导",
              subtitle: "",
              keywords: "",
              description:
                "2023年11月30日，山西省总工会党组书记、常务副主席梁敬华，山西省总工会一级巡视员、金融工委主任韩丽珍一行莅临山西金控，深入所属子公司山西证券就基层工会工作进行调研指导。山西金控党委专职副书记、副董事长、工会主席，山西证券党委书记、董事长侯巍陪同调研。梁敬华一行详细了解了山西证券及其工会的基本情况，以及山西证券工会近年来打造的文化品牌、活动品牌、职工书屋和职工创新工作室的情况，并对王忠宁创新工作室进行...",
              copyFrom: "党群工作部",
              content:
                "2023年11月30日，山西省总工会党组书记、常务副主席梁敬华，山西省总工会一级巡视员、金融工委主任韩丽珍一行莅临山西金控，深入所属子公司山西证券就基层工会工作进行调研指导。山西金控党委专职副书记、副董事长、工会主席，山西证券党委书记、董事长侯巍陪同调研。 梁敬华一行详细了解了山西证券及其工会的基本情况，以及山西证券工会近年来打造的文化品牌、活动品牌、职工书屋和职工创新工作室的情况，并对王忠宁创新工作室进行了实地调研。 梁敬华对山西证券工会工作给予了充分肯定，并对下一步工会阵地升级打造工作提出了意见和建议。他强调，要进一步深化工会改革创新，加强资源整合，创新职工服务模式，不断提升服务阵地效能和发挥作用水平，着力把职工服务阵地建设成为凝聚人心的坚强阵地，不断满足广大职工日益增长的精神文化需求，推动基层工会工作取得更好成效。 下一步，集团工会将继续巩固拓展学习贯彻习近平新时代中国特色社会主义思想主题教育成果，按照省总工会、集团党委部署要求，不断加强集团系统各级工会组织建设，把服务大局、服务职工作为工会工作的切入点、着力点、落脚点，在政治引领、民主管理、服务职工、自身建设上精准发力，团结动员广大职工发扬劳模精神、劳动精神、工匠精神，主动作为、岗位建功，用实际行动推动山西金控高质量发展。",
              picture: "/profile/upload/content/2023/12/656d47770081d.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-12-01 18:26:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-08-16 18:31:05",
              remark: null,
              id: 3884,
              menuId: 2159,
              title:
                "山西金控集团党委2023年基层党支部书记、党务工作者专题培训班圆满结业",
              subtitle: "",
              keywords: "",
              description:
                "为深入学习贯彻习近平新时代中国特色社会主义思想和党的二十大精神，切实提高基层党支部书记和党务工作者政治素养和专业能力，推动基层党建各项工作破新题开新局，8月2日至4日，集团党委利用3天时间，在晋学苑举办2023年基层党支部书记、党务工作者专题培训班。集团各基层党支部书记及党务工作者170余人参加培训。开班式动员有力 统一思想明确目标8月2日，集团党委专职副书记、副董事长侯巍出席开班仪式并作讲话。侯巍书记全面阐明...",
              copyFrom: "党群工作部",
              content:
                "为深入学习贯彻习近平新时代中国特色社会主义思想和党的二十大精神，切实提高基层党支部书记和党务工作者政治素养和专业能力，推动基层党建各项工作破新题开新局，8月2日至4日，集团党委利用3天时间，在晋学苑举办2023年基层党支部书记、党务工作者专题培训班。集团各基层党支部书记及党务工作者170余人参加培训。 开班式动员有力 统一思想明确目标 8月2日，集团党委专职副书记、副董事长侯巍出席开班仪式并作讲话。侯巍书记全面阐明举办这次全封闭、大规模的培训的重要意义，要求参训人员要提高政治站位，认清培训重要意义，切实做到“三个充分认识到”，即充分认识到这次培训是贯彻落实党的二十大精神的重要举措，充分认识到这次培训是全面加强集团基层党组织建设的迫切需要，充分认识到这次培训是提升基层党支部书记、党务工作者能力素质的实践路径。同时，他就举办好本次培训班提出明确要求，强调做到“三个突出”，即突出党的创新理论武装，突出党内制度法规体系学习，突出党建工作业务能力提升。最后，侯巍书记结合主题教育学思用贯通、知信行统一目标，要求以此次培训为契机，以严的措施、严的要求、严的氛围强化自我约束和管理，静心学习，学以致用，以“钻”和“挤”的劲头，带头学、争着学、比着学，确保把这次培训学到的新理论、新知识、新技能，转化为推动基层党建工作落实的科学思路、工作举措和实际成效。 聚焦主线辅导学 做到学懂弄通做实 坚持把学习党的创新理论放在首位，把增强基层党支部书记、党务工作者的政治判断力、政治领悟力、政治执行力贯穿培训全过程。在培训内容设置上，聚焦学习贯彻习近平新时代中国特色社会主义思想这条主线，将学习党的二十大精神、习近平总书记在山西考察重要讲话重要指示批示精神作为的必修课。培训班期间，邀请省委党校三位资深教授和长治学院党委副书记，围绕《以中国式现代化全面推进中华民族伟大复兴》《坚定不移全面从严治党，深入推进新时代党的建设新的伟大工程》《党的根本大法的与时俱进—学习二十大党章修正案》《时代楷模：黄文秀》等方面进行专题讲座，通过系统学习，引导参训学员以更加饱满的政治热情和精神状态，推动学习往深里走、往心里走、往实里走，在学深悟透党的创新理论中汲取精神力量，进一步坚定了用习近平新时代中国特色社会主义思想武装头脑、指导实践、推动工作的思想自觉、政治自觉、行动自觉。 找准问题研讨学 拓展思维务求真知 他山之石，可以攻玉。本次培训将学、思、研、考有机结合，8月2日，大家带着以求知若渴的精神，利用晚间自学时间，进行分组讨论，全体参训学员坚持读原著学原文悟原理，在各组组长的带领下，原原本本领学《中国共产党支部工作条例（试行）》《中国共产党国有企业基层组织工作条例》《中国共产党纪律处分条例》《中国共产党廉洁自律准则》等党内法规制度。随后，六个小组全体学员结合各自公司业态和岗位工作实际，踊跃发言，积极讨论，将自己在实践中总结的优秀经验和方法进行共享，各抒己见，取长补短，在交流研讨中总结经验做法，探讨工作思路，及时发现自身短板，查缺补漏，不断提升学员学中思、思中察、察中悟、悟中践的能力，真正实现了互学互促、共同提升。现场思想的火花不断碰撞，气氛十分热烈，很多工作中存在的问题，在讨论现场便得到答疑解惑。 大家纷纷表示，通过开展交流研讨，为进一步落实好支部工作启迪了思路，增强了政治意识、加强支部阵地建设、调动党员群众积极性、推动党建与业务深度融合，在拓展工作思维，收获工作经验的同时，还加深了大家彼此了解，增进了彼此友谊，达到了互学互助、共同提高的目的。 围绕业务深化学 教学设计精准发力 培训班坚持需求导向、问题导向、目标导向，按照“干什么学什么，缺什么补什么”的原则精心设置课程。邀请到省直工委组织部三名部长围绕党组织换届、发展党员、党费管理等党务工作实操进行专题授课，课程紧凑、内容丰富，对基层党务工作实操具有极强的针对性、指导性，切实把基层党建工作的政策规定、主要任务、目标要求、实践方法学到手，进一步理清工作思路，匡正干的导向，激发干的动力，形成干的合力，引领基层建设全面进步、全面过硬。 “课程安排紧密结合全面提高基层党务工作质效，精心安排了3堂干货满满的专题课程，授课老师以鲜活的事例，给我们带来了一批高标准、高水平、高质量的培训课程，为我们今后高质量研究谋划推动基层党建工作提供了更广阔的思路和视野，收获太大了！”学员们纷纷表示，通过培训系统掌握了党务工作实操和党务工作的基本要求，交流学习“标杆党支部”创建的先进工作方法和经验，为学员进一步做好基层党务工作奠定理论基础。 培训班结业式上，参训学员结合此次学习的所学所获所悟，撰写了学习心得，6名学员代表现场分享了培训心得。大家一致表示，此次培训紧贴实际，内容丰富，既有理论高度又有实践厚度，通过此次培训在理论武装上有了新的收获，在党性修养上有了新的进步，在工作实践中有了新的提升。 新时代开启新征程，新使命展现新作为。下一步，集团党委将持续加大培训力度，充分发挥好基层党组织书记、党务工作者在抓基层党建工作中的关键作用，进一步引导党支部书记和党务工作者们继续团结奋斗、开拓创新，锐意进取、砥砺前行，奋力推动集团基层党建工作再上新台阶，为推动集团高质量改革发展提供坚强保障。",
              picture: "/profile/upload/content/2023/08/64dca556da24d.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-08-16 18:31:05",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-11 11:57:41",
              remark: null,
              id: 3883,
              menuId: 2159,
              title:
                "山西金控集团党委举办2022年度基层党组织书记培训暨党的二十大专题学习网络培训班",
              subtitle: "",
              keywords: "",
              description:
                "为深入学习宣传贯彻党的二十大精神，切实把思想和行动统一到党的二十大精神上来，12月28日-30日，山西金控集团党委举办2022年度基层党组织书记培训暨党的二十大专题学习网络培训班，来自集团系统各级党组织书记、基层党务工作者近300人参加了培训。培训以全面、系统、深入学习党的二十大精神为主线，对培训内容和形式进行了精心设计。培训紧密围绕党的二十大报告解读、党的二十大精神解析、《中国共产党章程（修正案）》解读等内容...",
              copyFrom: "党群工作部",
              content:
                "为深入学习宣传贯彻党的二十大精神，切实把思想和行动统一到党的二十大精神上来，12月28日-30日，山西金控集团党委举办2022年度基层党组织书记培训暨党的二十大专题学习网络培训班，来自集团系统各级党组织书记、基层党务工作者近300人参加了培训。 培训以全面、系统、深入学习党的二十大精神为主线，对培训内容和形式进行了精心设计。培训紧密围绕党的二十大报告解读、党的二十大精神解析、《中国共产党章程（修正案）》解读等内容，结合当下疫情防控形势，最大限度保护学员身体健康，最大程度确保学员学习效果，采用“腾讯会议”进行线上授课。为把工作做实做细，保障培训效果，培训还选取部分学员代表进行了线上学习心得分享。大家纷纷表示，此次培训理论性强、内容丰富、收获满满，今后将以党的二十大精神为指导，把培训收获应用于工作实践之中，不断创新方式方法，实现党建工作与企业改革发展同频共振、互促共进。 学习宣传贯彻党的二十大精神是当前和今后一个时期的首要政治任务，本次培训是集团党委学习宣传贯彻党的二十大精神的重要举措。集团各级党组织、广大党员要把学习贯彻党的二十大精神作为头等大事，深刻理解党中央重要部署精神，时刻保持头脑清醒、态度坚决、行动自觉，把培训与贯彻落实中央经济工作会议精神、省委经济工作会议精神结合起来，与谋划公司2023年工作结合起来，把学习党的二十大精神转化为推动企业发展改革的内生动力，奋力开创山西金控高质量发展的新局面。",
              picture: "/profile/upload/content/2023/01/63be337288147.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-01-11 11:57:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-10 16:55:55",
              remark: null,
              id: 3882,
              menuId: 2159,
              title: "以党支部规范化建设 推动基层党建工作从“有形”走向“有效”",
              subtitle: "",
              keywords: "",
              description:
                "习近平总书记在党的二十大报告中明确指出，“增强党组织政治功能和组织功能，坚持大抓基层的鲜明导向，把基层党组织建设成为有效实现党的领导的坚强战斗堡垒，激励党员发挥先锋模范作用，保持党员队伍先进性和纯洁性。”党支部规范化建设是加强新时代党支部建设、推动党建高质量发展的有力抓手。山西金控集团党委自2021年启动党支部规范化建设以来，坚持严在标准、重在规范、要在实效，对照开展标杆党支部创建工作，推动基层组织全...",
              copyFrom: "党群工作部",
              content:
                "习近平总书记在党的二十大报告中明确指出，“增强党组织政治功能和组织功能，坚持大抓基层的鲜明导向，把基层党组织建设成为有效实现党的领导的坚强战斗堡垒，激励党员发挥先锋模范作用，保持党员队伍先进性和纯洁性。”党支部规范化建设是加强新时代党支部建设、推动党建高质量发展的有力抓手。山西金控集团党委自2021年启动党支部规范化建设以来，坚持严在标准、重在规范、要在实效，对照开展标杆党支部创建工作，推动基层组织全面进步、全面过硬，为实现党建引领高质量发展提供了坚强保障。 按照《中国共产党支部工作条例（试行）》相关要求，结合集团党建工作实际，2021年8月，集团党委制定印发《关于开展基层党支部规范化建设的实施方案》，提出了“五化五好三提升两发挥”创建要求，分解细化了10项33个操作点，作为党支部开展工作和对照自查的基础管理工具。创建方案采取“三步走”战略，即“一年打基础，两年上水平，三年显成效”，力争在2024年集团规范化党支部创建达标率达到95%以上，促进基层党建工作水平显著提升，推动企业发展的能力明显增强。 经过近一年创建，2022年6月，集团党委启动了标准化党支部达标验收工作。对于首批申报的党支部，集团党委从严考核把关，经基层支部自查自评、子公司自主申报、集团党委考核验收等环节，在要求党支部考核评分90分以上，党员群众满意度不低于90%的基础上，将党支部工作是否融入中心工作，是否发挥了党支部战斗堡垒作用，是否发挥了党员先锋模范作用，以及党风廉政建设情况纳入考核，确保首批“标杆党支部”各项工作全面过硬，真正在集团内部起到引领示范作用。经过层层审核把关，集团党委会议研究决定，将山西证券股份有限公司第二党支部等21个基层党支部命名为集团系统首批“标杆党支部”。 党支部标准化建设作为一项常态化工作，是基层党建工作从“有形”走向“有效”的重要起点和关键环节。下阶段，集团党委将以党的二十大精神为指导，深入贯彻落实习近平新时代中国特色社会主义思想，在推进党支部标准化建设基础上，进一步在学懂弄通做实上下功夫、见实效，推动企业经营工作提质增效，切实发挥党支部战斗堡垒作用和党员先锋模范作用，让党旗始终在基层一线高高飘扬。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-01-10 16:55:55",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2022-10-16 22:27:20",
              remark: null,
              id: 3881,
              menuId: 2159,
              title: "山西金控集团组织收听收看党的二十大开幕式实况",
              subtitle: "",
              keywords: "",
              description:
                "10月16日上午，中国共产党第二十次全国代表大会在人民大会堂隆重开幕。山西金控集团组织系统内4900余名党员干部职工和离退休老干部收听收看开幕实况，聆听习近平总书记代表十九届中央委员会向大会所作的报告。大家一致认为，习近平总书记所作的报告立意高远、思想深邃、内涵丰富，擘画了新时代新征程中国共产党的使命任务，令人深受鼓舞、倍感振奋。报告全面阐述了过去五年的工作和新时代十年的伟大变革，明确指出我们党团结带领全...",
              copyFrom: "党群工作部",
              content:
                "10月16日上午，中国共产党第二十次全国代表大会在人民大会堂隆重开幕。山西金控集团组织系统内4900余名党员干部职工和离退休老干部收听收看开幕实况，聆听习近平总书记代表十九届中央委员会向大会所作的报告。 大家一致认为，习近平总书记所作的报告立意高远、思想深邃、内涵丰富，擘画了新时代新征程中国共产党的使命任务，令人深受鼓舞、倍感振奋。报告全面阐述了过去五年的工作和新时代十年的伟大变革，明确指出我们党团结带领全国人民，攻克了许多长期没有解决的难题，办成了许多事关长远的大事要事，推动党和国家事业取得举世瞩目的重大成就。这一系列全方位开创性的成就、深层次的变革，在党史、新中国史、改革开放史、社会主义发展史、中华民族发展史上具有里程碑意义。这些伟大变革和成就必将激励我们在前进的道路上更加自信自强、守正创新，踔厉奋发、勇毅前行，不断创造新的辉煌。 大家一致表示，必须把深入学习宣传贯彻党的二十大报告作为当前和今后一个时期的首要政治任务，主动学、自觉学、深入学，迅速把思想和行动统一到习近平总书记重要讲话精神上来，坚定拥护“两个确立”，自觉做到“两个维护”。要围绕金融企业服务实体经济、防范化解金融风险、深化金融改革三大使命任务，立足本职岗位，主动担当作为，以昂扬的精神状态和奋斗姿态担重任、创佳绩、争一流。要时刻保持全面从严治党永远在路上、党的自我革命永远在路上的战略定力，锲而不舍落实中央八项规定精神，持续深化纠治“四风”，一体推进不敢腐、不能腐、不想腐，自觉在清廉企业建设中尽职责、当表率、作模范，为助力我省全方位推动高质量发展、为中国式现代化建设事业贡献智慧和力量。",
              picture: "/profile/upload/content/2022/10/634c146401adb.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2022-10-16 17:02:00",
              menuParentId: null,
              searchContent: null,
            },
          ],
          allianceList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-12-12 09:37:42",
              remark: null,
              id: 4212,
              menuId: 2175,
              title: "祝贺！山西金控青年获评中国青年志愿服务最高荣誉！",
              subtitle: "",
              keywords: "",
              description:
                "12月5日是第三十八个国际志愿者日，共青团中央、中国青年志愿者协会对第十四届中国青年志愿者优秀个人、组织和项目进行表彰，授予260名个人第十四届“中国青年志愿者优秀个人奖”。其中，山西金控旗下中合盛资本曹杰同志荣获第十四届“中国青年志愿者优秀个人奖”。曹杰，现任山西金控旗下中合盛资本管理有限公司综合办公室行政专员、团支部委员。曾获河南省2021年度“防汛救灾优秀志愿者”、山西省2022年度“省直机关第五批优秀志...",
              copyFrom: "党群工作部",
              content:
                "12月5日是第三十八个国际志愿者日，共青团中央、中国青年志愿者协会对第十四届中国青年志愿者优秀个人、组织和项目进行表彰，授予260名个人第十四届“中国青年志愿者优秀个人奖”。其中，山西金控旗下中合盛资本曹杰同志荣获第十四届“中国青年志愿者优秀个人奖”。 曹杰，现任山西金控旗下中合盛资本管理有限公司综合办公室行政专员、团支部委员。曾获河南省2021年度“防汛救灾优秀志愿者”、山西省2022年度“省直机关第五批优秀志愿者”等荣誉称号。作为一名普通的90后回族男孩，他利用业余时间加入山西天龙救援队，积极参与各种救援，累计志愿服务时长680小时。2021年河南郑州特大暴雨，他义无反顾参与首批防洪抗洪救援行动；同年10月暴雨席卷山西，他又第一时间赶往祁县救灾临时指挥所转运分装救援物资；新冠疫情期间，他多次奔赴阳性病例家庭、学校、商场等公共场所开展防疫消杀。2021年，他成为了临县三交镇双塔村一名驻村帮扶队队员，期间不仅出色完成驻村帮扶工作，还积极搭建临县三交镇、天龙救援队和公司协作开展志愿服务的通道，协调公司为三交镇的两所小学捐赠电教设备及操场，影响带动公司员工参与天龙救援队壹基金“温暖包计划”。曹杰矢志践行“请党放心、强国有我”的青春誓言，用实际行动诠释了“奉献、友爱、互助、进步”的志愿精神，书写了不平凡的青春故事，充分彰显了山西金控青年的爱心善意和责任担当,为山西金控青年作出了榜样，树立了标杆。 榜样力量，引领前行，志愿服务一直在路上。山西金控集团将继续组织开展形式多样、内容丰富的志愿服务活动，引深志愿服务品牌，激励和引导集团广大职工在积极投身改革发展主战场、急难险重攻坚战、服务群众最前沿中勇担重任、展现作为，用实际行动践行社会主义核心价值观，胸怀“国之大者”，在新时代履行社会责任中发挥更多更大地作用！",
              picture: "/profile/upload/content/2023/12/65790ba8aaed4.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-12-12 09:37:42",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-12-12 09:37:42",
              remark: null,
              id: 4205,
              menuId: 2175,
              title: "祝贺！山西金控青年获评中国青年志愿服务最高荣誉！",
              subtitle: "",
              keywords: "",
              description:
                "12月5日是第三十八个国际志愿者日，共青团中央、中国青年志愿者协会对第十四届中国青年志愿者优秀个人、组织和项目进行表彰，授予260名个人第十四届“中国青年志愿者优秀个人奖”。其中，山西金控旗下中合盛资本曹杰同志荣获第十四届“中国青年志愿者优秀个人奖”。曹杰，现任山西金控旗下中合盛资本管理有限公司综合办公室行政专员、团支部委员。曾获河南省2021年度“防汛救灾优秀志愿者”、山西省2022年度“省直机关第五批优秀志...",
              copyFrom: "党群工作部",
              content:
                "12月5日是第三十八个国际志愿者日，共青团中央、中国青年志愿者协会对第十四届中国青年志愿者优秀个人、组织和项目进行表彰，授予260名个人第十四届“中国青年志愿者优秀个人奖”。其中，山西金控旗下中合盛资本曹杰同志荣获第十四届“中国青年志愿者优秀个人奖”。 曹杰，现任山西金控旗下中合盛资本管理有限公司综合办公室行政专员、团支部委员。曾获河南省2021年度“防汛救灾优秀志愿者”、山西省2022年度“省直机关第五批优秀志愿者”等荣誉称号。作为一名普通的90后回族男孩，他利用业余时间加入山西天龙救援队，积极参与各种救援，累计志愿服务时长680小时。2021年河南郑州特大暴雨，他义无反顾参与首批防洪抗洪救援行动；同年10月暴雨席卷山西，他又第一时间赶往祁县救灾临时指挥所转运分装救援物资；新冠疫情期间，他多次奔赴阳性病例家庭、学校、商场等公共场所开展防疫消杀。2021年，他成为了临县三交镇双塔村一名驻村帮扶队队员，期间不仅出色完成驻村帮扶工作，还积极搭建临县三交镇、天龙救援队和公司协作开展志愿服务的通道，协调公司为三交镇的两所小学捐赠电教设备及操场，影响带动公司员工参与天龙救援队壹基金“温暖包计划”。曹杰矢志践行“请党放心、强国有我”的青春誓言，用实际行动诠释了“奉献、友爱、互助、进步”的志愿精神，书写了不平凡的青春故事，充分彰显了山西金控青年的爱心善意和责任担当,为山西金控青年作出了榜样，树立了标杆。 榜样力量，引领前行，志愿服务一直在路上。山西金控集团将继续组织开展形式多样、内容丰富的志愿服务活动，引深志愿服务品牌，激励和引导集团广大职工在积极投身改革发展主战场、急难险重攻坚战、服务群众最前沿中勇担重任、展现作为，用实际行动践行社会主义核心价值观，胸怀“国之大者”，在新时代履行社会责任中发挥更多更大地作用！",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-12-12 09:37:42",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-11-23 11:55:17",
              remark: null,
              id: 4204,
              menuId: 2175,
              title: "团聚金控 共赴一场青春之约",
              subtitle: "",
              keywords: "",
              description:
                "初冬时节，甜蜜邂逅。11月12日，由省直团工委主办，山西金控集团工会、团委承办的“青春之约 团聚金控”单身青年联谊活动暨省直机关“青春之约”第二期在山西国贸大饭店举办。来自省直厅局、省属企业、金融机构等20多家单位的70多名单身青年以爱之名，相约初冬，共赴一场浪漫的青春之约。省直团工委书记姚兰、省直团工委挂职干部朱杰到场指导。缤纷气球，精美甜点，可爱玩偶，现场氛围拉满。怀揣着憧憬与期待到场的青年们，在签到处...",
              copyFrom: "党群工作部",
              content:
                "初冬时节，甜蜜邂逅。11月12日，由省直团工委主办，山西金控集团工会、团委承办的“青春之约 团聚金控”单身青年联谊活动暨省直机关“青春之约”第二期在山西国贸大饭店举办。来自省直厅局、省属企业、金融机构等20多家单位的70多名单身青年以爱之名，相约初冬，共赴一场浪漫的青春之约。省直团工委书记姚兰、省直团工委挂职干部朱杰到场指导。 缤纷气球，精美甜点，可爱玩偶，现场氛围拉满。怀揣着憧憬与期待到场的青年们，在签到处领取专属号码牌并拍照留念， 一段浪漫旅程就此开启。 为了让初次见面的青年朋友快速“破冰”，活动精心策划了五个趣味运动项目，将男女嘉宾分成六队进行比拼，让大家在游戏运动中拉近彼此的距离。 伴随着经典游戏“俄罗斯方块”音乐响起，各队男女嘉宾手拿充气拼图，快速奔跑，你追我赶，现场一下子热闹起来，大家之间那种拘束、紧张顿时烟消云散。 “趣味汉诺塔”不仅是速度和智力的比拼，也是团队协作能力的比拼，在队长的带领下，队员们团结互助、共同协作，集团队智慧，解锁闯关。 “旱地龙舟”仪式感满满，队员们一个个跃上龙舟，喊着一二一二的号子，脚步跟着号子声一齐迈动，整齐的动作一气呵成，逐渐向着目的地靠近，男女嘉宾的配合也越来越默契。 接下来是“滚滚向前”，各组男女嘉宾搭配，有的推动、有的传递、有的摆放，齐心协力，滚滚向前，轻松欢乐的氛围布满全场。 “足球标靶”中，队员们你一脚我一脚，足球在大家脚下，一次次飞起，一次次命中标靶，这场技巧加运气的比赛，让大家欢呼雀跃。 经过紧张激烈的趣味运功会，青年们在游戏运动中充分交流，展示自我的独特竞技风采，迅速增进了解，加深印象，大家彼此之间的距离从初识到熟识、从破冰到默契。 最后进入人气男女嘉宾评选、表白牵手环节，主持人鼓励大家敞开心扉、热情主动、大胆追爱。男女嘉宾分别将手中的玫瑰花、棒棒糖送给心仪的对象，迈出牵手邀约、成为好朋友的第一步。在浪漫气氛的烘托下，全场共有6对男女嘉宾牵手成功，他们携手走上舞台，山西金控集团工会、团委为他们送上了暖心的“牵手礼包”。 服务青年职工是工会、共青团的职责所在。本次活动聚焦青年职工新需求，适应青年职工新变化，强化服务意识，为广大青年职工搭建了交友、沟通、联谊的平台，拓宽了青年职工沟通交流渠道，丰富了青年职工业余生活，激发了青年职工工作热情，营造了健康活力、以人为本的良好企业氛围。",
              picture: "/profile/upload/content/2023/11/6560655383961.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-11-23 11:55:17",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-11-01 15:43:01",
              remark: null,
              id: 4203,
              menuId: 2175,
              title:
                "山西金控集团代表队喜获山西省金融系统职工羽毛球比赛团体第二名",
              subtitle: "",
              keywords: "",
              description:
                "近期，在省总工会金融工委主办的“中国梦·劳动美——凝心铸魂跟党走 团结奋斗新征程”全省金融系统“兴业银行杯”第五届职工羽毛球比赛中，山西金控代表队在全省36家金融系统中取得“团体第二名”的好成绩。本次羽毛球团体赛设男子双打、女子双打、混合双打。集团工会积极组织参与，择优选拔八名队员组成山西金控代表队。比赛中，队员们尽显技艺、默契配合，一招一式都展现出矫健的身姿，每一次挥拍都充满了力量和激情，他们一路过...",
              copyFrom: "党群工作部",
              content:
                "近期，在省总工会金融工委主办的“中国梦·劳动美——凝心铸魂跟党走 团结奋斗新征程”全省金融系统“兴业银行杯”第五届职工羽毛球比赛中，山西金控代表队在全省36家金融单位中取得“团体第二名”的好成绩。 本次羽毛球团体赛设男子双打、女子双打、混合双打。集团工会积极组织参与，择优选拔八名队员组成山西金控代表队参赛。比赛中，队员们尽显技艺、默契配合，一招一式都展现出矫健的身姿，每一次挥拍都充满了力量和激情，他们一路过关斩将，闯入决赛，最终获得了团体第二名。队员们用实际行动诠释了“永不言败、永攀高峰”的体育精神，赢得了在场观众的阵阵掌声。 山西金控集团工会自成立以来，为丰富职工精神文化生活,倡导积极、乐观、健康、向上的生活风尚,积极组织参加三晋友谊杯乒乓球赛等活动，组织开展义务植树活动、山西金控3V3篮球赛、三晋友谊杯乒乓球赛等丰富多样、异彩纷呈的文体活动，营造了积极、和谐、向上的良好氛围。下一步，集团工会将继续秉承“更快、更高、更强、更团结”的体育精神，为职工提供更多的机会去展示自我、锻炼自我、提高自我，增进职工间的团结与合作，为企业和谐发展注入新的活力。",
              picture: "/profile/upload/content/2023/11/654201477db04.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-10-31 18:09:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-10-10 18:59:04",
              remark: null,
              id: 4202,
              menuId: 2175,
              title:
                "喜报！山西金控旗下山西股权交易中心获评首批“二星级全国青年文明号”",
              subtitle: "",
              keywords: "",
              description:
                "近日，第21届全国青年文明号评选结果正式出炉，山西44个集体光荣上榜。山西金控旗下山西股权交易中心榜上有名，被认定为首批“二星级全国青年文明号”。近年来，山西金控集团团委深入开展青年文明号创建工作，以服务经营工作为核心，以提升服务品质为重点，以创建工作为载体，在营业部、对外窗口等单位，广泛开展“号声嘹亮·青年文明号向祖国报告”“青年文明号开放周”等系列活动，组织引导广大青年职工岗位建功、开拓创新，全力...",
              copyFrom: "党群工作部",
              content:
                "近日，第21届全国青年文明号评选结果正式出炉，山西44个集体光荣上榜。山西金控旗下山西股权交易中心榜上有名，被认定为首批“二星级全国青年文明号”。 近年来，山西金控集团团委深入开展青年文明号创建工作，以服务经营工作为核心，以提升服务品质为重点，以创建工作为载体，在营业部、对外窗口等单位，广泛开展“号声嘹亮·青年文明号向祖国报告”“青年文明号开放周”等系列活动，组织引导广大青年职工岗位建功、开拓创新，全力打造山西金控优质金融服务品牌，展示了山西金控青年良好的职业素养和职业文明。集团系统现有国家级青年文明号2个，省级青年文明号10个，省直级青年文明号4个，集团级青年文明号6个，青年文明号品牌效应进一步释放，作用发挥进一步凸显。 山西股权作为我省唯一的区域性股权市场运营机构，公司拥有一支平均年龄35岁，勤于服务实体经济、助力山西经济高质量发展的青年队伍。自青年文明号创建以来，山西股权以“金融引领，树四板新标杆；服务一流，展股权新风采”为创建主题，以“创意、创业、创新，融智、融资、融合”为创建口号，将创建工作与服务我省青年创业企业有机结合，在打造中小微企业综合金融服务平台、私募股权投融资服务平台、拟上市企业规范辅导平台中勇当先锋队、突击队，不断提升区域性股权市场服务实体经济质效。截至目前，山西股权培育企业3979家，成功转板新三板企业27家，北交所上市2家，登记托管企业1766家，完成了全省94%地方商业银行股权托管，托管家数居全国第一梯队，累计帮助企业实现融资240.49亿元，为全省中小微企业发展提供了强有力的金融支持。 此次山西股权获评全国首批“二星级全国青年文明号”，为山西金控各级青年文明号集体树立了标杆。下一步，山西金控集团团委将进一步加大全系统青年文明号的创建力度，构建多层级青年文明号梯队，有效发挥青年文明号集体在高质量发展中的示范引领作用，带动广大青年投身工作实践，为山西经济高质量发展贡献更大的力量。",
              picture: "/profile/upload/content/2023/10/65252e69ae96c.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 2,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-10-10 18:59:04",
              menuParentId: null,
              searchContent: null,
            },
          ],
          civilizationList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-13 11:37:48",
              remark: null,
              id: 4241,
              menuId: 2180,
              title: "【身边人·身边事】让“来自星星的孩子”不再孤单",
              subtitle: "",
              keywords: "",
              description:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金...",
              copyFrom: "党群工作部",
              content:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金控人”的典型事迹，拨动着我们心灵深处对道德的崇尚。为此，我们开设【身边人·身边事】专题，持续刊登山西金控集团涌现出的先进典型事迹，以事迹展现风采，以文化凝聚力量。今天，我们一起学习山西金控资本公司审计风控部高悦洋的事迹。 为星星的孩子点亮一盏灯 几年前的一次偶然机会，她走进这个特殊的群体——自闭症儿童，从那时起，她一直致力于了解到他们需要更多的关爱和接纳，努力帮助他们和同龄人一样，为星星的孩子点亮一盏灯。她就是山西金控资本管理有限公司审计风控部高悦洋。 在她眼里，自闭症儿童明明离父母亲友很近，却“视而不见”“充耳不闻”，活在自己的世界里，仿佛天上遥远的星星独自闪烁。他们是自闭症患者，被成为“星星的孩子”。但这浪漫的称呼背后，是自闭症儿童言语发育迟缓、人际交往障碍、兴趣狭窄以及行为方式刻板的残酷现实。 不忘初心，走近“星星的孩子” 2015年硕士实习结束后，高悦洋决定回到祖国，建设家乡。工作学习之余，她主动参与社会公益组织献爱心和定点帮扶活动。基于在社区的工作经验，她参与组织了太原海归俱乐部的献爱心慰问活动，并了解到了在我们身边有这样一群不幸的孩子们。 自闭症患儿被叫做“星星的孩子”，他们就像天上的星星，在遥远而漆黑的夜空中独自闪烁着。然而，在这美丽浪漫的名字背后却往往是家人的遗弃，社会的曲解以及缺失的教育。他们需要更多的了解、关爱和接纳。“我希望尽自己绵薄之力，为星星的孩子点亮一盏灯。”在位于平阳路和南中环街交汇处的方舟自闭症康复研究院是省内一家致力于为自闭症儿童康复的民办学校，是由范世禄院长于2005年发起，目前有来自省内各地的患儿来这里学习和治疗。 通过院长介绍，她了解了学院发展历程以及自闭症的成因，自闭症儿童有哪些表现，如何对待和治疗自闭症患者等专业知识，还观摩了自闭症儿童的现场教学，一位自闭症儿童现场还表演了吹葫芦丝，大家为他送上了鼓励的掌声。在康复大厅，有几位大孩子正在接受康复训练，他们有的垒积木，有的在做手工，旁边有老师在不停的鼓励他们。范院长带来其中一位孩子，请现场的人随便说出某个年月，这个孩子马上可以说出对应的是星期几，真是十分神奇。 组织走进“灵星社区” 由于疫情影响、资金短缺等原因，大部分自闭症教育机构面临着倒闭的处境。得知这一消息，高悦洋积极动员公司内青年群体，自发组织来到太原市灵星社区服务中心。在了解完灵心社区之后，高悦洋决定和大家一起走进这个“自闭症”患儿之家。一开始，高悦洋有些担心这些孩子有些怪异的举动会吓到她的同事们，但是另她没有想到的是，金控资本从组织到个人，从领导到员工，仿佛跟这里的孩子有某种注定的缘分一样，主动伸出援助之手，捐款捐物，在困难处境下得到了爱的援助。 走进社区，灵星创办人动情地为大家讲述十二年来，为了这些特殊的孩子可以接受教育，克服万难坚持办学的感人事迹。之后5名自闭症患儿在老师的引导下为大家演唱歌曲《听我说谢谢你》赢得了全场热烈的掌声。随后带领金控资本志愿者们参观校舍，与孩子一起互动、做游戏，孩子们也不再拘谨，慢慢融入其中。随后，志愿者们关切地询问孩子们家境状况、身体状况，并提出想要长期一对一地帮扶患儿。志愿服务过程中，大家互相合作、劲头十足，校区负责人对大家的到来表示非常感谢。 在她看来，陪伴在他们身边的过程是一种很奇妙的体会，那是一种油然而生的情感，一种发自内心的关爱，而这种来自内心的快乐正是那些“星星的孩子们”留给我的。可是，看着他们破旧的校舍和简陋的学习条件，这让高悦洋和金控资本的同事们很心痛。他们现场捐赠了学习用品和一部分现金，并与院长沟通，希望可以为孩子们提供更多帮助。 2022年，在公司主要领导的带领下，金控资本有5位员工与“灵星”5位儿童结成“一帮一”小组，每月向学校转账资助这5位困难学生的生活起居。在此之后每个月，金控资本的爱心小分队都会抽时间去看望这些孩子们，还介绍身边的朋友去献爱心以及当志愿者。这个研究院目前没有任何政府补助资金，全靠社会捐赠维持。高悦洋和金控资本也从没停歇致力于让更多的人去了解这个孩子群体，帮助他们康复。 “灵星”校长李小娇女士说，金控资本这个公司是个有温度的组织，他们从心底渴望参与对自闭症儿童的关爱救助，真正体现了“奉献、友爱、互助、进步”的志愿服务精神。同时，李校长也呼吁，真心希望有更多像金控资本这样的企业关注慈善，投身公益。 希望大家一起关注 公益路上不停歇 她坚持的公益事业得到组织的认同和参与后，高悦洋更加主动地联系山西儿童福利院、孔妈妈孤儿院等社会福利机构，为他们送过去精神和物质的关怀。她还计划带领公司爱心人士定期去山西社会儿童福利院送温暖，定期向山东沂蒙、四川凉山等贫困困难地区邮寄书本衣物生活用品。 在新冠肺炎疫情席卷武汉之际，高悦洋通过联系山西医科大学附属医院远赴武汉支援的护士朋友，为武汉捐款捐物，并通过海归协会等其他社会团体为太原市多家医院捐献防疫救灾物品。“为别人提供帮助的同时，我也能感受到自己内心的满足和自身社会价值感的实现。”如今，高悦洋常年帮扶一户困难家庭，一个大学生和一个小学生。不论多忙，过节一定会前往送去温暖。 高悦洋说到，今后将继续为需要帮助的群体提供力所能及的关怀，并进一步加大对儿童的关注，为孤儿、自闭症儿童营造更包容、更温暖的环境。她的愿望是这些孩子未来可以和普通人一样，能够享受美好的生活，同时也呼吁能有更多的人去关注和帮助他们。 2021年，高悦洋被评选为太原市“向上向善”好青年，同时她的事迹也被省内多家媒体报道。采访中她说“我要继续用爱和行动，唤起整个社会的爱，来温暖那些‘来自星星的孩子’，让他们的生命拥有阳光和色彩。”",
              picture: "/profile/upload/content/2023/01/63c0d1d5c45c4.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2023-01-10 11:25:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-09 11:59:02",
              remark: null,
              id: 4240,
              menuId: 2180,
              title: "【身边人·身边事】践行誓言，崇德向善 做新时代合格共产党员",
              subtitle: "",
              keywords: "",
              description:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个...",
              copyFrom: "党群工作部",
              content:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金控人”的典型事迹，拨动着我们心灵深处对道德的崇尚。为此，我们开设【身边人·身边事】专题，持续刊登山西金控集团涌现出的先进典型事迹，以事迹展现风采，以文化凝聚力量。今天，我们一起学习山西股权交易中心子公司山西晋兴资本市场发展服务有限公司党支部副书记、副总经理田军威的事迹。 一朝入伍，军魂入骨，一声“到”，一生到。无论是身着戎装保家卫国，还是脱下军装，田军威不改军人作风，践行入党时的铿锵誓词，无论工作岗位，还是志愿服务，他爱岗敬业、冲锋在前，牢记初心使命、践行责任担当。 2022年4月，突如其来的疫情再次打破太原城的平静，防控成为了重中之重。和时间赛跑、与病毒较量。田军威作为一名退伍军人，当这场没有硝烟的“战役”打响的那一刻，积极响应省直工委、金控集团党委号召，主动请缨投身抗疫一线，加入太原市小店区小店街道通达社区的抗疫志愿者队伍，并成为临时党支部的主力成员。 这段日子里，他坚守一线，哪里有危险他在哪儿，哪里有重活儿他抢着干，每天奋战到凌晨是家常便饭，这一干就是半个多月。通达街附近地铁站口作为临时核酸检测点，他每次都要赶早去“领活”，拉运物资、配合社区网格员摆放桌椅到位……核酸检测开始，又化身“大白”负责疏导居民，缓解居民的情绪，给其他志愿者树立了良好榜样。他同时负责辖区114小区巡逻、劝返扎堆居民工作。每天下午巡逻4个小时，行走上万步，成为志愿者里走路步数最多的人。他总说：“咱这大体格，这些活儿小事一桩！” 2022年4月13日，114小区居民群里，田军威搀扶八旬老人下台阶的一张照片成了“热点”，这是一位居民悄悄用手机记录下的暖心瞬间。当天下午在劝返扎堆居民时，一位八旬老人走路蹒跚，田军威一个快步上前，托着老人下了台阶，目送老人进了单元楼，他才走往下一栋。为解决大家采购难题，想方设法联系到清徐农民张健健、张二健两位爱心兄弟，经过热心牵线搭桥，夜幕中，满载5000斤蔬菜的车辆缓缓驶入通达社区，一袋袋绿油油的生菜分发到居民手中。 参加抗疫白加黑连轴转的田军威，没有落下本职工作，每天都要与居家办公的同事们一起开视频会议，在线上助企纾困，最大力度帮助企业。 熟悉他的人都知道，田军威的爱人是山西白求恩医院的职工，爱人坚守岗位连续几天没有回家，两口子“白加黑”忙抗疫，孩子跟着姥姥、姥爷。老人们叮嘱他们：“你们放心去做事，家里有我们！” 在家里，田军威是一名好儿子、好丈夫、好爸爸。对于双方的老人，他在繁忙的工作之余，经常与老人家谈心，不仅在生活上关心、体贴老人，而且在思想上关心老人，让父母生活得快乐、健康。对孩子，无论工作再忙，回到家，他总要抽出时间多陪陪，阅读绘本、陪伴玩耍，教孩子做人做事的道理，和家人一起建造温馨、和谐、向上的党员模范家庭。 为鼓励职工崇德向善，山西股权交易中心设立了职工“道德银行”。田军威是积极参与者。2022年六一儿童节前，他和同事们一起，为太原市迎泽港道小学学生捐书、深入吕梁市临县三交镇双塔村了解民生需求及乡村产业发展现状，研究区域性股权市场助力村民增收的措施。他还连续两年为神池县八角镇营头镇村杨謦羽同学募捐助学金……在公司，他的“道德银行”积分已达到90分，在党员中名列前茅。 作为晋兴资本党支部副书记，他坚持在“学习强国”平台进行理论知识学习，积分达到6.2万多分，在公司学习排行榜位列第一，努力做到了知行合一，把爱党敬业融入到实际工作中。 党的二十大胜利闭幕，向全党发出了奋进新征程的伟大号召。作为金融战线上的一名共产党员，田军威说，他要用信念、实干、担当、创新，怀揣初心，立足岗位，砥砺奋进，为推动高质量发展贡献青春力量。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2022-12-30 16:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-09 11:57:43",
              remark: null,
              id: 4239,
              menuId: 2180,
              title: "【身边人·身边事】同心战“疫” 共克时艰",
              subtitle: "",
              keywords: "",
              description:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个...",
              copyFrom: "党群工作部",
              content:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金控人”的典型事迹，拨动着我们心灵深处对道德的崇尚。为此，我们开设【身边人·身边事】专题，持续刊登山西金控集团涌现出的先进典型事迹，以事迹展现风采，以文化凝聚力量。今天，我们一起学习国信医投公司奋力战“疫”的事迹。 2022年11月，太原市遭遇今年第6轮新冠疫情，我省常态化疫情防控形势异常严峻复杂。国信医投积极响应国家号召，投资共建日检测量达10万管的PCR气膜方舱核酸检测实验室。经过10天连夜奋战，气膜方舱实验室完成搭建、设备调试、技术验收，于11月19日早9时正式投入使用。 11月22日晚，得知气膜方舱实验室面临核酸检测工作时间紧、任务重、人力不足等困难，国信医投立即向公司全体干部职工发起倡议，号召大家投身疫情防控一线，积极参与疫情防控支援工作。党支部书记路素军带领班子成员、中层管理人员、职工及综改区体检中心医护人员近30人随即投身一线，帮助协调方舱实验室运行各环节工作、配合完成检前处理、信息录入等工作，共同“筑”力抗疫。 截至11月30日，方舱实验室为太原六城区及古交、平遥、清徐、原平等周边多个地区提供检测服务，累计检测量66万余管，平均日检测量达5.5万管，共检测575万余人次。 国信医投所属的嘉园门诊作为国有品牌的基层医疗卫生机构，积极助力疫情防控工作。在负责人郭小明及护士长雷晓晶的带领下，全体医务人员闻令而动，逆行出征，全力以赴支援核酸采样工作，不惧危险，不怕苦累，连续作战，协助社区及学校优化采样流程。他们先后赴财经大学、光信国信嘉园、北辰苑小区、康乐幼儿园、哈福沃幼儿园、通宝育杰学校、并南一社区、太航社区、许西社区为居民及学生开展核酸采样工作。封控期间，部分员工更是就地转岗，参与小区疫情防控工作。疫情期间，累计采样标本达1万余人次。 作为企业，既要维持门诊正常运转，又要全力支援每日核酸采集工作。嘉园门诊员工义无反顾，哪里缺人哪里补上，不曾退后一步，他们以实际行动支援小店区疫情防控工作，彰显了国有企业的责任与担当。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2022-12-26 17:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-09 11:56:46",
              remark: null,
              id: 4238,
              menuId: 2180,
              title: "【身边人·身边事】 做好平凡“小事” 服务改革“大业”",
              subtitle: "",
              keywords: "",
              description:
                "做好平凡“小事” 服务改革“大业”近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖...",
              copyFrom: "党群工作部",
              content:
                "做好平凡“小事” 服务改革“大业” 近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金控人”的典型事迹，拨动着我们心灵深处对道德的崇尚。为此，我们开设【身边人·身边事】专题，持续刊登山西金控集团涌现出的先进典型事迹，以事迹展现风采，以文化凝聚力量。今天，我们一起学习山西产权子公司山西省产权交易市场有限责任公司业务一部负责人李媛的事迹。 她是产权交易行业一名“新兵”，起步就是冲刺，从一毕业就投身到国有资产交易的大潮中，八年来一直在平凡的岗位上挥洒青春和汗水；她没有炫目的光环也没有显赫的头衔，走基层、下企业、与客户倾心交谈，扑下身子干、挺起脊梁扛，把“以客户为中心”的理念注入血液里、写在岗位上、融进事业中。在产权交易的沃土上，在国资国企改革的浪潮中，她秉心坚守、默默耕耘，用严谨和细心守护着公平正义，用守法和专业书写责任与情怀。 多角度服务国资国企改革，助推经济高质量发展，是山西产权的初心使命。作为公司一员，李媛以“公平、公正、公开”作为自己的行为准则，以认真严谨高效的态度对待每一个项目，力求给予客户最严谨、专业、守法、高效的服务。 在当前日新月异的发展形势下，产权交易行业面临着重要的战略机遇，同时也面临巨大的压力和挑战，李媛始终以坚强的意志和耐力拼搏在竞争激烈的市场上。按照国企混改和供给侧改革的要求，她把“巩固老客户，扩展新客户”作为工作的突破口，为企业提供“一企一案”的精准化服务，成功完成了企业多标的股债捆绑转让、并购融资等业务，在公司产生较大的示范效应。 爱岗敬业，做素质过硬的产权人 从事地市、省属和央企的国有资产交易业务以来，无论严寒酷暑，她终日奔波于公司与客户之间，致力于提升客户“满意度”。想方设法，多渠道挖掘客户需求，不放过任何一个服务主体。根据企业实际需求，提供专业化服务，全方位推进项目，协调企业产权转让过程中涉及的各项统筹工作。 事非经过不知难。李媛深知“利其器”方可“善其事”，为了把工作做得更好，她首先从提高自身素质入手，一方面认真学习党的各项路线方针政策，学习党纪党规，提高政策理论水平，提高执行党的各项经济政策的自觉性和主动性，用党纪党规规范自己行为。另一方面，李媛认真学习产权交易有关业务知识，《政治经济学》《金融学》《贸易谈判》成为她案前的常备资料。她积极参加各项业务培训，虚心向老同志学习工作经验和工作方法，提高了分析问题、解决问题的能力和水平。正是由于她讲政治、懂业务、敬业奉献，圆满完成了领导交办的各项任务，受到领导和同志们一致的好评。 务实创新，做脚踏实地的产权人 近年来，李媛始终紧跟山西产权打造专业化“平台+投行”服务模式的步伐，不断延伸服务链条、提升服务质量，快速提升个人综合能力，让自己具备了推动新模式发展的扎实功力。 2021年初，一家民营企业对公司即将挂牌交易的项目有摘牌意向，但是缺少流动资金，成为项目成交的“拦路虎”。为促进项目顺利成交，解决中小企业融资难、融资贵，加快国有资产、金融机构与非公企业之间的快速流动和高效配置，李媛开始探索金融服务新路径。她围绕各类业务交易过程中企业或个人出现的资金短缺等问题，了解各家银行并购贷款的模式，站在客户的角度思考，用心聆听客户诉求，带领团队顶风冒雨奔波，在银行和客户之间搭建起了高效沟通的桥梁，与多家金融机构建立合作关系，反复研究确定操作新模式。历经6个月，该企业最终通过了银行对融资主体和担保主体的尽职调查及贷前审查，为后期参与项目受让奠定基础。 李媛以“交易+融资”的创新交易模式，通过全过程、市场化的服务，充分将服务向交易的前端、后端延伸，为助力产权资本市场更好地服务国资国企改革摸索出新方法、探索出新路子。 严谨高效，做争当先锋的产权人 在国资国企改革“赶考”“补考”大环境中，山西产权肩负着国有资产公开、公平、阳光交易的重任，服务于国企改革的第一线，而李媛就是一线上的排头兵。她敢为人先、努力进取，团结和带领团队在提高素质上作文章、在务实创新上下功夫、在严谨高效上求实效，内强素质、外树形象，连续多年提前超额完成业绩指标。 服务某企业的“腾笼换鸟”项目是李媛参与的我省省属企业深化国企改革提质增效的重大项目之一。面对转让方持多家标的公司股权及相关债权打包捆绑转让，如何最大程度收回投资和债权，确保国有资产保值增值，成为必须攻克的“山头”。 李媛带领团队从项目初期就开始介入，通过现场面谈、会议、电话、微信等方式，全天候24小时快速有效地响应转让方及上级单位提出的各类问题，提供全流程顾问服务和交易服务。凭借其自身在执业经验、团队组织协调能力、项目价值分析、操作风险预警和对法规政策掌握等方面的优势，为客户提出“评估值与投资值就高原则”的股权定价方式，并在公告中对意向受让方就职工安置、职工欠薪欠保、债权债务处置进行明确要求。同时在项目公告期间，充分运用市场化手段，通过多种宣传模式，最广泛地征集意向受让方。最终成功击破难点，实现项目成交，净回笼资金近70亿元人民币，对推进国资国企改革，优化山西国有经济布局，推动国有企业转型发展意义重大。 严谨高效，是项目成功背后的“秘钥”，也是成为一名合格产权人的基本素质。她坚持每个项目、每道流程进行风险评估，严谨防范可能产生的风险，从业以来无一起违约项目。她常说，在其职，谋其事，把每一件产权交易“小事”做细做好，就能为服务公司发展、国企国资改革“大业”赋能助力。 一片赤诚献产权，初心不改勇担当。李媛从事产权交易工作八年来，共完成股权、实物资产交易、增资扩股、经营权转让等各种交易规模达100多亿元，为公司直接创造收益5000多万元。她出色的工作和扎实的服务获得了上级的肯定，更赢得了客户的认可和赞誉。面对成绩和荣誉，她说“每一项荣誉都是一个新的起点，没有什么比服务好客户更有价值。”",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2022-12-23 10:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-01-09 11:54:48",
              remark: null,
              id: 4237,
              menuId: 2180,
              title: "【身边人·身边事】一个普通的90后家庭",
              subtitle: "",
              keywords: "",
              description:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个...",
              copyFrom: "党群工作部",
              content:
                "近年来，根据上级有关安排，山西金控集团先后组织开展了评选推荐道德模范、文明家庭、文明窗口、优秀志愿者等工作，挖掘出许许多多典型事迹。这些事迹彰显了山西金控集团企业文化的引领力和感染力，在山西金控集团系统营造了良好的文化氛围。特别在今年疫情防控的紧要关头，广大干部、一线员工冲锋在前、担当在前，守望相助、全力战疫，涌现出许多感人事迹。一个又一个“金控人”的感动时刻，温暖、洗涤着身边的你和我，一个又一个“金控人”的典型事迹，拨动着我们心灵深处对道德的崇尚。为此，我们开设【身边人·身边事】专题，持续刊登山西金控集团涌现出的先进典型事迹，以事迹展现风采，以文化凝聚力量。今天，我们一起学习晋金所信息科技部陈健亮的事迹。 有这样一对90后夫妻：丈夫陈健亮，山西省金融资产交易中心有限公司的一名系统开发工程师，妻子李明星，山西省人民医院的一名外科主管护师，他们在非常时期的非常选择把我们带回了2020年初的那次毅然逆行——平凡中总能带给我们更多的感动和激励。 面对疫情，一个普通家庭的勇于担当 2020年春节期间，人在老家临汾的陈健亮一家，正为难得一聚的过年而开心忙碌着。但是，电视里不断传来新冠肺炎疫情蔓延的新闻，让身为医护人员的李明星颇为敏感。“这个病好像不简单，咱山西会不会有，我说不定需要回去。”李明星跟丈夫陈健亮聊着自己的猜测，那几天，她一边关注着事态的发展，一边留意着工作群，“就怕单位有通知，错过了。” 果然，疫情的发展速度远比人们想象的快，作为省内三甲医院之一的山西省人民医院向全体医护人员发起了倡议——“支援武汉，抗击疫情”。听到这声“集结号”，在老家的李明星坐不住了，她第一时间向单位递交了“抗疫请愿书”。那天是正月初二，这突然的变化，让陈健亮也有些措手不及，他捂着妻子的手，眼里充满了担心。但是，妻子李明星却说：“我是一名医护人员，更是一名共产党员，现在正是需要我们的时候，这种时候我不能退缩。”多年的相濡以沫让陈健亮深知妻子的决心，也知道妻子一直以来对这份职业的深深热爱，于是他们安顿好老人孩子后，连夜驱车赶回了太原。 根据组织安排，李明星被分到第四批预备队准备前往武汉，虽然由于特殊原因最终并未成行，但抗疫的工作并没有停。不论是2020年的疫情阻击战，还是近年来的常态化防控，冲在最前线的队伍里总有李明星的身影，而丈夫陈健亮，就是她最坚实的后盾。尤其是今年4月和近期山西突发的疫情，李明星再次踏上披星戴月的路程，先后去清徐、小店、大同、第四人民医院等地进行支援，成为防疫工作中一名普通而可敬的“大白”。由于在抗疫工作中的突出表现，李明星先后获得医院“512国际护士节‘先进个人’抗疫特别奖”、“2021年度抗疫特别奖”等殊荣。 家风传承，一对年轻夫妻的坚定选择 家是小小国，国是千千家，这是中国人传承的家国情怀。陈健亮的爷爷是一位老红军，十分重视优良家风的传承，他的爷爷常说：“咱们老陈家的人对家庭要负责、对工作要尽心、对社会要有贡献，要亲友睦邻、以身作则、以德为根。”陈健亮是听着爷爷的红色故事，在听党话、感党恩、跟党走的氛围中成长起来的，老一辈榜样的力量一直激励他在家里要做一个好丈夫，工作上要做一名有为青年。 陈健亮作为公司信息科技部的一名系统工程师，承担着公司网络安全维护、系统漏洞及开发质量评估、审查重要数据及技术资料备份、落实系统安全管理等工作重任。他与团队成员一起兢兢业业的守卫着公司后台网络，确保公司信息系统安全运行，为公司安全经营高效发展提供了重要保障。 在工作之余，他不忘参加各种公益活动，不仅积极参与山西省积善助残公益活动、希望工程助学活动以及各类募捐活动，更在疫情期间积极投身志愿服务行列，用平凡小事践行文明风尚。 妻子李明星作为一名外科主管护师，整日忙于抢救、护理病人，以至于按时下班、正常休息都成了一种奢求。陈建亮作为家庭最重要的支撑和后盾，为了不让妻子分心，在繁忙的工作之余主动承担起了照顾家庭的重任，看护幼子、陪伴年迈父母，大家庭的和谐离不开陈健亮的努力付出。用他的话来说，“家人就是要相互理解、相互扶持，我爱人的职业神圣而光荣，我对她无条件支持！” 平日里，陈健亮夫妇热情帮助邻里，疫情期间更是积极参与社区志愿行列，与邻居们相处非常融洽。特殊时期，夫妻俩工作繁忙，白天孩子只能一个人在家，有一天竟把自己反锁在了门外。还是好心的邻居大姐得知此事后，主动提出帮忙照看孩子，才解了他们的燃眉之急。对此，陈健亮说“虽然孩子还小，可能并不理解父母的工作，但相信总有一天，他会为自己的父母骄傲。”闲暇之时，陈健亮夫妇也经常带孩子一起读书，以“我们不管喜欢什么，都能从书中得到答案”的观念，培养孩子从小树立正确的世界观、人生观和价值观。 妻子冲锋在“疫线”，丈夫支援在“后方”。一个冲锋在前，一个护卫在后，这一对“夫妻档”用奉献和坚守诠释了战“疫”的责任和担当。 陈健亮家庭的抗疫经历，不仅诠释了医务工作者“敬佑生命”的职业精神，共产党员的勇于担当、无私奉献，更让我们看到了新时代青年的奋发有为、积极向上，他们之间相互尊重信任、相互成就彼此，他们用自己的实际行动体现了一个普通家庭、一对普通夫妻的“平凡”和“不凡”，彰显了他们的担当和奉献。",
              picture: "/profile/upload/content/2023/01/63bbd4dd03de8.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: null,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2022-12-19 10:00:00",
              menuParentId: null,
              searchContent: null,
            },
          ],
          newsList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-28 09:48:21",
              remark: null,
              id: 5308,
              menuId: 2017,
              title:
                "山西金控集团召开2025年第4次党委理论学习中心组（扩大）学习会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "4月17日，山西金控集团召开2025年第4次党委理论学习中心组（扩大）学习会议。会议学习了3月31日习近平总书记主持召开的中央政治局会议精神，传达学习了国务院办公厅《关于做好金融“五篇大文章”的指导意见》，分专题学习了《习近平文化思想学习纲要》之《像石榴籽一样紧紧抱在一起》《唱响主旋律，弘扬正能量》和违反中央八项规定及其实施细则精神的典型案例等，围绕《习近平关于加强党的作风建设论述摘编》第一至三篇等进行了研讨交流。山西金控集团党委书记、董事长王振宇主持会议，集团党委班子成员、党委理论学习中心组扩大学习成员参加。 王振宇强调，要持续压实巡视整改责任，毫不松懈抓好巡视问题整改“后半篇文章”，以钉钉子精神巩固整改成效。要充分做好中央巡视延伸下沉的思想准备和工作准备，始终保持高度警觉，强化统筹协调，以严慎细实的作风将各项工作抓牢、抓细、抓到位。 王振宇强调，要深刻学习领会《指导意见》精神，深化“五篇大文章”的战略定位，强化内部能力建设，对照文件要求严格对标对表、精准落实到位。要紧跟形势与政策，及时组织研究新出台的统计制度，准确把握统计要求，确保涉及的相关业务全面纳入统计体系，以制度化、规范化举措推动集团高质量发展。 “心往一处想、劲往一处使”，王振宇强调，要深刻把握“铸牢中华民族共同体意识”的精神实质，将全体员工的思想行动凝聚成发展合力，把共同体意识切实转化为集团团结奋进的文化基因。要深入学习信息化条件下舆论主导权相关内容，全面提升舆论引导能力，精准发力，以科学策略与高效行动筑牢意识形态阵地，营造积极健康的舆论环境。 王振宇强调，各级党组织要扎实推进学习教育走深走实，精研细悟典型案例的警示意义，从中深刻汲取教训，以案为鉴、警钟长鸣。要对照规定要求与工作实际，主动查摆问题、精准剖析根源，坚持问题导向抓整改，以刀刃向内的态度落实落细各项纪律要求，建立健全长效机制，持续加固作风建设堤坝，确保中央八项规定精神在集团上下落地生根、见行见效。",
              picture:
                "/profile/upload/image/2025/04/11/3b6e228e-6f42-4ec1-982a-8ca74ed15e76.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 470,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-18 10:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-28 09:48:21",
              remark: null,
              id: 5309,
              menuId: 2017,
              title: "山西金控集团党委书记、董事长王振宇赴山西征信开展调研",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "综合管理部",
              content:
                "4月23日，山西金控集团党委书记、董事长王振宇，党委委员、副总经理刘振龙一行赴山西征信开展调研，详细了解了山西征信在碳征信、数据产品研发等重点服务领域取得的成效和当前发展面临的困境，听取了基层职工在工作中的问题和意见建议。 王振宇董事长强调，山西征信要立足省级征信平台的定位，强化数据治理、深挖数据价值，高举高打、抢占先机，加快推进产品赋能和模型创新，探索更多“信用+”场景应用，提升企业画像能力，丰富定制化产品服务体系，增强专业服务力和核心竞争力。此外，要同步在市场服务和内部协同中探索发展空间，加强与银行等各类金融机构的业务合作，推进与山西再担保、山西数据交易中心等兄弟单位的联动发展，实现征信平台服务边界和服务能力的全面提升。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 471,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-25 17:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-28 09:48:21",
              remark: null,
              id: 5307,
              menuId: 2017,
              title: "山西金控集团与吕梁市政府开展座谈交流",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "综合管理部",
              content:
                "4月16日，山西金控集团党委书记、董事长王振宇，党委专职副书记、副董事长侯巍，党委委员、副总经理刘鹏飞赴吕梁市政府开展座谈交流。吕梁市市委副书记、市长熊义志，市委常委、常务副市长任忠，市政府秘书长王建强出席。山西证券、山西信托、中煤保险、山西交易集团、山西股权、中合盛资本、金控资本、绿色产业投资、晋商资产主要负责人参加会议并围绕项目合作进行了发言。 王振宇感谢吕梁市长期以来的信任、支持和帮助，并简要介绍了山西金控的业务结构与功能作用。他表示，吕梁市发展态势良好、市场潜力巨大，希望双方能够建立会商机制、保持紧密合作。未来，山西金控将发挥全牌照优势，打造一站式综合服务平台，通过资金供给、风险保障、要素交易、担保培育等传统金融服务与碳、数据、信用等创新金融服务，帮助地市从平台公司融资优化到对资产的管理运营和价值发现，实现产融结合的环节优化和模式升级，为地方经济社会发展提供坚实支撑。 熊义志对王振宇一行表示欢迎。他表示，金融创新对经济发展十分重要，当前，吕梁市正处于转型的关键阶段，山西金控此次到访恰逢其时，一定会迎来丰硕的合作成果。下一步，希望双方以此次座谈为契机，通过建立顾问咨询、驻场对接、培训讲座、案例分享、项目共建的“五个一”合作机制，围绕产业转型、城市更新、文旅发展、生态环境等领域，全面加强对接、深化合作关系、抓好项目落地，实现优势互补、共赢发展，打造企地合作的新样板。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 469,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-18 10:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:49:30",
              remark: null,
              id: 5302,
              menuId: 2017,
              title:
                "山西金控集团召开2025年第3次党委理论学习中心组（扩大）学习会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "近日，山西金控集团召开2025年第3次党委理论学习中心组（扩大）学习会议，以视频方式与一级子公司中心组连线共学，并首次采用部分议题“子公司轮值领学”创新机制。集团党委书记、董事长王振宇主持会议，集团党委班子成员、党委理论学习中心组扩大学习成员在主会场参会，各公司中心组成员视频参学。 会议集中学习了习近平总书记在贵州和云南考察时发表的重要讲话精神，系统学习了《习近平文化思想学习纲要》之《实现精神上的独立自主》《人民有信仰，国家有力量，民族有希望》、证券行业警示案例等重要内容，并围绕能源革命改革进行了研讨交流。山西证券作为首期轮值子公司，相关班子成员结合证券行业实践，就文化建设专题、警示案例剖析、资本市场服务能源革命等内容进行了深度解读。 王振宇强调，要深刻领会习近平总书记考察贵州、云南重要讲话精神的核心要义，深化对经济工作的规律性认识，以科技创新引领新质生产力发展，夯实实体经济根基，推动数字经济与实体经济深度融合；要立足山西资源禀赋，在服务能源革命、优化营商环境、创新金融供给中担当作为。要坚持深耕山西，以“金融服务店小二”的姿态主动对接战略客户，探索资产证券化创新路径，在盘活资产证券化、提供融智支持等领域深化实践，为地方经济高质量发展贡献金控方案。 王振宇强调，企业文化是集团行稳致远的立身之本，要加快推进企业文化建设，通过全员参与、内外协同，打造兼具传统底蕴与时代精神的价值观体系。要依托“心声论坛”构建互动平台，引导员工形成健康向上的认知体系，实现个人成长与企业发展的良性互促。 王振宇强调，要深刻认识到贯彻落实中央八项规定精神，绝不是一阵风、走过场，而是一场必须打赢的持久战。要从警示教育案例中深刻汲取教训，全面把握风腐同源、互为表里的特征，以案为鉴、警钟长鸣。党员领导干部要带头转作风、强担当，以风清气正的政治生态保障改革发展。 下一步，集团将持续优化中心组学习模式，提升中心组学习整体质效，着力将中心组学习打造为干部素质提升和业务创新发展的重要引擎，为集团高质量发展注入持久动力。",
              picture:
                "/profile/upload/image/2024/12/10/6ec15a0e-c939-486c-a131-87451f981d9a.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 468,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-01 09:46:16",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:44:11",
              remark: null,
              id: 5301,
              menuId: 2017,
              title:
                "山西金控集团举办党委理论学习中心组深入贯彻中央八项规定精神学习教育读书班",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "3月27日至28日，山西金控集团举办党委理论学习中心组深入贯彻中央八项规定精神学习教育读书班，集团党委书记、董事长王振宇作开班讲话，集团党委班子成员、党委理论学习中心组扩大学习成员参加学习。 读书班采取领导领学、个人自学、交流研讨等形式，深入学习领会习近平总书记关于加强党的作风建设的重要论述，认真研读中央八项规定及其实施细则精神等，交流研讨深入、联系实际紧密、学用导向鲜明。 王振宇强调，在全党开展深入贯彻中央八项规定精神学习教育，是以习近平同志为核心的党中央作出的重大决策部署。要深入学习和领悟习近平总书记关于党的作风建设的重要论述，准确把握中央八项规定精神的核心和内涵，以更高标准、更严要求把中央八项规定及其实施细则精神融入工作职责中、落到行动上，为集团高质量发展提供坚强作风保障。 一是提高政治站位，深刻认识学习教育的重大意义。将落实中央八项规定及其实施细则精神作为检验政治忠诚的标准，从政治高度审视作风问题，确保党中央及省委决策部署在集团落地。深化对作风建设规律的认识，巩固“推动高质量发展从营造风清气正政治生态抓起”的共识，以过硬作风护航集团改革发展。 二是注重贯通融合，持续加固中央八项规定精神堤坝。将学习中央八项规定精神与学习习近平总书记关于党的建设、金融工作等重要论述及习近平文化思想相结合，原原本本学，领会精神实质，把握核心要义。把学习教育与省委巡视整改、防范金融风险等重点工作结合，作为密切联系群众的实际行动，推动八项规定精神化风成俗。 三是聚焦重点内容，推动学习教育走深走实。把握中央八项规定精神内涵，增强自我约束意识，将学习成果融入业务和管理。把握“四风”特点，正视、发现问题，剖析根源，精准纠治。坚持问题导向，有效运用纪检监察、审计等多方监督力量，整治作风顽疾，解决突出问题。以学习教育为契机，健全作风建设长效机制，提升集团管理水平。借助智慧党建“监督信箱”“心声论坛”等平台，收集群众诉求，以群众满意度检验整改成效。 王振宇要求，一要大兴调研之风，统筹安排调研计划，穿透基层摸实情、听民声、解难题；二要强化数字赋能，完善信息共享平台，有效利用数字化工具，加强沟通交流，从严规范文件报表报送机制，力戒官僚主义；三要严控经费支出，强化津补贴、公务接待等领域专项监督检查，筑牢合规管理防线；四要提升新闻宣传质效，坚持服务战略、服务经营、服务客户、赋能发展；五要厚植清廉根基，将文化建设深度融入中央八项规定精神落实，以文化涵养风清气正的政治生态。 大家一致表示，将以此次学习为起点，持续深化对中央八项规定精神的学习与贯彻，以优良的作风推动集团高质量发展，为服务我省经济社会发展贡献金控力量。",
              picture:
                "/profile/upload/image/2024/12/10/c0e76845-20e4-4f86-bb93-915ec9563fc6.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 467,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-03-28 20:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:38:19",
              remark: null,
              id: 5300,
              menuId: 2017,
              title:
                "以科技创新为笔 以网络安全为基 推动山西金控数字化转型迈出新步伐",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "数字科技部",
              content:
                "在数字化浪潮下，山西金控积极顺应金融行业发展趋势，将金融科技创新视为驱动自身发展的关键引擎，凭借 “技术赋能 + 安全筑基” 双轨并行的创新实践模式，全力探索数字化转型的有效路径。 技术赋能，新知识激发新潜能。截至目前山西金控组织全系统员工开展了十余场DEEPSEEK技术知识培训活动，内容涵盖了大语言模型应用、大模型技术原理、NLP中台构建、提示词工程、AI编程助手应用实践及知识库与RAG技术等多个领域。员工们全方位接触了行业前沿技术，激发创新思维，为集团在数字金融领域的探索提供了坚实的技术支撑。 安全筑基，强法规筑牢强防线。集团精心组织的信息安全培训中，全面覆盖了网络安全法、数据安全法、个人信息保护法、关键信息基础设施安全保护条例、网络数据安全条例等法律法规。通过专家对法规的深入剖析，结合实际案例分享实用防护措施，有效增强员工信息安全意识，为集团构建了安全防线，确保集团在数字化转型的道路上稳健前行。 山西金控集团将进一步探寻数据使用场景，持续提升数据聚合效能，全力推进客户服务综合管理平台与 CRM 系统建设，以数字化转型成果赋能，助力集团迈向高质量发展的新征程。",
              picture:
                "/profile/upload/image/2024/12/10/10e3b093-145e-447a-96f4-12a317ecafd7.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 466,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-03-28 12:00:00",
              menuParentId: null,
              searchContent: null,
            },
          ],
          visits: 354807,
          linkList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 16:00:24",
              remark: null,
              id: 11,
              menuId: 2477,
              title: "中华人民共和国财政部",
              thumb: "",
              siteUrl: "http://www.mof.gov.cn/index.htm",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 16:00:24",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 16:00:04",
              remark: null,
              id: 10,
              menuId: 2477,
              title: "中国证券监督管理委员会",
              thumb: "",
              siteUrl: "http://www.csrc.gov.cn/pub/newsite/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 16:00:04",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:59:41",
              remark: null,
              id: 9,
              menuId: 2477,
              title: "中国银行业保险监督管理委员会",
              thumb: "",
              siteUrl: "http://www.cbirc.gov.cn/cn/view/pages/index/index.html",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:59:41",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:58:59",
              remark: null,
              id: 8,
              menuId: 2477,
              title: "中国保险监督管理委员会",
              thumb: "",
              siteUrl: "http://www.circ.gov.cn/web/site0/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:58:59",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:46:12",
              remark: null,
              id: 7,
              menuId: 2477,
              title: "山西省人民政府",
              thumb: "",
              siteUrl: "http://www.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:46:12",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:45:47",
              remark: null,
              id: 6,
              menuId: 2477,
              title: "山西省财政厅",
              thumb: "",
              siteUrl: "http://czt.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:45:47",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:45:29",
              remark: null,
              id: 5,
              menuId: 2477,
              title: "山西省商务厅",
              thumb: "",
              siteUrl: "http://swt.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:45:29",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:45:04",
              remark: null,
              id: 4,
              menuId: 2477,
              title: "山西省人民政府国有资产监督管理委员会",
              thumb: "",
              siteUrl: "http://gzw.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:45:04",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:44:26",
              remark: null,
              id: 3,
              menuId: 2477,
              title: "山西省工业和信息化厅",
              thumb: "",
              siteUrl: "http://gxt.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:44:26",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:43:09",
              remark: null,
              id: 2,
              menuId: 2477,
              title: "山西省发展和改革委员会",
              thumb: "",
              siteUrl: "http://fgw.shanxi.gov.cn/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:43:09",
              typeLabel: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-11-17 15:41:56",
              remark: null,
              id: 1,
              menuId: 2477,
              title: "山西金融服务平台",
              thumb: "",
              siteUrl: "http://www.sxjrfwpt.com/",
              type: 2,
              userName: "admin",
              inputTime: "2017-11-17 15:41:56",
              typeLabel: null,
            },
          ],
          companyList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:12:22",
              remark: null,
              id: 5274,
              menuId: 2186,
              title: "山西数据交易中心",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "山西数据交易中心，经山西省人民政府批准，于2024年11月成立，系全省唯一持牌数据交易机构。围绕省委、省政府重大战略任务，以充分释放数据要素价值，促进数字技术与实体经济深度融合，助力产业数智化业转型和企业高质量发展为己任。业务涵盖数据流通交易、数据资产登记评估、数据产品孵化运营、数据资产化服务等领域，积极探索数据赋能实体经济的新路径，致力于将数据价值转化为推动经济社会高质量发展的新动力。",
              picture:
                "/profile/upload/2025/02/08/山西数据交易中心_20250208183441A015.jpg",
              officialUrl: "https://www.sxdataex.com/",
              homePageUrl: "www.sxdataex.com",
              homePagePicture:
                "/profile/upload/2025/02/08/59eefece932d5_20250208121248A009.jpg",
              companyName: "山西数据交易中心有限公司",
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2025-02-08 12:15:09",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:38",
              remark: null,
              id: 5273,
              menuId: 2191,
              title: "山西征信",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: null,
              content:
                "山西省征信有限公司是全省唯一获得备案的企业征信机构。始终坚持积极响应国家构建信用社会、推进普惠金融的号召，紧扣“五篇大文章”，立足“政府+市场”的建设模式，内抓管理，外抓成效，在深化完善平台建设，积极盘活数据资源的基础上，不断强化“平台+产品+服务”三大业务板块，逐步建立起较为完善的企业征信产业生态。",
              picture:
                "/profile/upload/2025/02/10/2ecd8dcf0c6b00f0e644cdde40b22a5_20250210102403A017.jpg",
              officialUrl: "https://www.tyqyzx.cn/",
              homePageUrl: "www.tyqyzx.cn/",
              homePagePicture:
                "/profile/upload/2025/02/07/59eefece932d5_20250207164706A007.jpg",
              companyName: "山西省征信有限公司",
              sort: 8,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2025-02-07 16:49:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:07:16",
              remark: null,
              id: 4303,
              menuId: 2186,
              title: "绿色产业投资",
              subtitle: null,
              keywords: "",
              description:
                "山西省绿色产业投资集团有限公司，为山西金融投资控股集团旗下全资专业化投资集团，是贯彻习近平生态文明思想和绿色发展理念，落实生态文明建设、能源革命和碳达峰碳中和决策部署，经省政府金融办核准设立的绿色产业投资平台。于2018年4月17日注册成立，2022年1月18日更为现名。山西省绿色产业投资集团，致力于贯彻落实省委省政府重大决策，按照山西金控战略部署，在战略定位上，坚持金融资本+绿色产业+现代科技+业态的“1+1+1+N”...",
              copyFrom: null,
              content:
                "山西省绿色产业投资集团有限公司，为山西金融投资控股集团旗下全资专业化投资集团，是贯彻习近平生态文明思想和绿色发展理念，落实生态文明建设、能源革命和碳达峰碳中和决策部署，经省政府金融办核准设立的绿色产业投资平台。于2018年4月17日注册成立，2022年1月18日更为现名。 山西省绿色产业投资集团，致力于贯彻落实省委省政府重大决策，按照山西金控战略部署，在战略定位上，坚持金融资本+绿色产业+现代科技+业态的“1+1+1+N”的发展战略；推动绿色新能源投资，城市建设投资和绿色生态修复，健康养生产业，绿色服务等业务板块的发展。 “十四五”期间，山西省绿色产业投资集团将突出金融属性，发挥投资优势，服务绿色产业，构建“集团化管控、扁平化架构、板块化经营、专业化管理、智能化运行、市场化激励、资本化运作、证券化发展”的管理体系和商业模式，增强绿色产业发展动能，致力于成为“两山”理论的践行者、绿色产业的领军者，为推动绿色产业高质量发展做出积极贡献。",
              picture: "/profile/upload/content/2023/02/63f70e314cc00.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/6054789fb9121.jpg",
              companyName: "山西省绿色产业投资集团有限公司",
              sort: 23,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2022-02-22 11:09:51",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:08:31",
              remark: null,
              id: 4305,
              menuId: 2186,
              title: "养老资产",
              subtitle: null,
              keywords: "",
              description:
                "山西省养老保险基金资产管理有限公司成立于2020年12月，注册资本8000万元，是我省划转部分国有资本充实社保基金的承接主体，专门管理运营划入的国有资本和运营收益。养老资产作为政策性金融机构，不以自身盈利为主要目的，所持有的股权分红和运作收益，专项用于弥补基金缺口，负有建立社保基金战略储备基金，增进民生福祉，实现代际公平，增强制度可持续性的重要使命。经营范围：在政策范围内运营管理划转的国有资本及收益，受托管...",
              copyFrom: null,
              content:
                "山西省养老保险基金资产管理有限公司成立于2020年12月，注册资本8000万元，是我省划转部分国有资本充实社保基金的承接主体，专门管理运营划入的国有资本和运营收益。养老资产作为政策性金融机构，不以自身盈利为主要目的，所持有的股权分红和运作收益，专项用于弥补基金缺口，负有建立社保基金战略储备基金，增进民生福祉，实现代际公平，增强制度可持续性的重要使命。 经营范围：在政策范围内运营管理划转的国有资本及收益，受托管理山西省国有资本投资并从事相关咨询服务业务。（不含国家法律法规、国务院规定限制和禁止的项目）（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
              picture: "/profile/upload/content/2021/03/605477534ec74.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/6054789fb9121.jpg",
              companyName: "山西省养老保险基金资产管理有限公司",
              sort: 25,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2021-03-19 17:49:53",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-03-19 17:41:06",
              remark: null,
              id: 4304,
              menuId: 2186,
              title: "金控资本",
              subtitle: null,
              keywords: "",
              description:
                "山西金控资本管理有限公司成立于2020年03月，注册资本30亿元，是山西金控服务全省重大项目的投资平台，集团内部金融协同的重要推手，特殊资产运营的专业管理人。金控资本围绕集团战略发展及决策部署，按照市场化原则开展业务，主要从事金融股权投资、重大项目协同投资、资产重组整合、资产收购处置及资产盘活增值。",
              copyFrom: null,
              content:
                "山西金控资本管理有限公司成立于2020年03月，注册资本30亿元，是山西金控服务全省重大项目的投资平台，集团内部金融协同的重要推手，特殊资产运营的专业管理人。金控资本围绕集团战略发展及决策部署，按照市场化原则开展业务，主要从事金融股权投资、重大项目协同投资、资产重组整合、资产收购处置及资产盘活增值。",
              picture: "/profile/upload/content/2023/02/63f70f4de6565.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2021/03/605478bd3b23b.jpg",
              companyName: "山西金控资本管理有限公司",
              sort: 24,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-03-19 17:41:06",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:08:52",
              remark: null,
              id: 4302,
              menuId: 2186,
              title: "产业基金",
              subtitle: null,
              keywords: "",
              description:
                "山西省产业基金管理有限公司是山西金控集团旗下从事政府产业投资基金和私募股权投资管理的专业私募股权基金管理机构（执牌号为：P1067526）。公司于2017年10月在山西综改示范区注册成立，注册资金1亿元，在职员工28人，其中党员12人（占公司全员42.86%），研究生以上学历12人（占公司全员42.86%），全员取得基金从业资格。产业基金成立至今，以高质量党建引领公司高质量全面发展。公司坚持把服务省内重点产业转型发展、确保私募股...",
              copyFrom: null,
              content:
                "山西省产业基金管理有限公司是山西金控集团旗下从事政府产业投资基金和私募股权投资管理的专业私募股权基金管理机构（执牌号为：P1067526）。公司于2017年10月在山西综改示范区注册成立，注册资金1亿元，在职员工28人，其中党员12人（占公司全员42.86%），研究生以上学历12人（占公司全员42.86%），全员取得基金从业资格。 产业基金成立至今，以高质量党建引领公司高质量全面发展。公司坚持把服务省内重点产业转型发展、确保私募股权基金专业化运营、坚持国有属性行业主渠道经营运作作为公司的立企宗旨，围绕我省经济工作主线，立足服务省内转型综改，服务国企产业提质升级，以“传统产业的基金化股权重整”和“新兴产业的基金化资本运作”为抓手，聚焦产业，坚持“产融结合，以融促产”。运作方向上，坚持产业发展的私募股权基金化运作，确定了服务综改示范区产业落地、服务省属重点国企转型提质升级、省内区域重点产业整合升级改造、市场化股权投资等主要业务方向；运作方式上，坚持以“专业化运营、市场化运作、资本化退出”为基本运作模式，坚持“赛道优先、质量优先”与“项目主流、资金主流、机构主流”的“两优先、三主流”基本运作原则，坚持“实事求是的全面风险管控”体系建设，坚持“合规底线运营”。截至目前，产业基金在中基协备案3支私募股权基金产品，参控股3家子公司，已注册成立13个合伙制基金运作主体，始终保持主体合规、牌照合规和产品合规。目前，公司担任山西省投资基金业协会副会长单位，在“山西资本市场转型发展年会”上获得辖区机构“金飞翼”奖。 公司目前是综改区新能源产业和高端装备制造产业两支子基金共160亿元规模的管理机构，发起设立了规模100多亿元的“山西燃气产业发展基金”和“山西氢能源产业发展基金”等系列国企转型提质增效升级基金；发起设立山西省氢能全产业链发展基金、山西晋信文化产业基金、山西清洁能源产业发展基金、山西省城镇化发展基金等省重点产业发展基金；发起管理定襄法兰产业升级发展基金、“一带一路”（祁县）中小企业特色产业合作发展基金等县域经济发展基金；与江苏金茂、上海君桐等市场主流投资机构共同设立了总规模为5065万元的新兴产业市场化系列基金，截至目前，项目运作安全、收益可期。 截止目前，公司荣获了2018年国信集团“年度综合考评第一名”及“优秀基层党组织”称号，被山西省直机关精神文明委员会评为“2018年度省直文明单位”。 经营范围：受托管理股权投资企业，从事股权投资管理及相关咨询服务（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）。",
              picture: "/profile/upload/content/2023/02/63f70f1d7d74b.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea69293bb22f.jpg",
              companyName: "山西省产业基金管理有限公司",
              sort: 22,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:51:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:09:16",
              remark: null,
              id: 4301,
              menuId: 2186,
              title: "城建投",
              subtitle: null,
              keywords: "",
              description:
                "山西城投系金控集团全资子公司，成立于2017年8月1日，作为我省城市建设投资的新生力量，山西城投自成立伊始，便以“提升城市配套功能、提高居民幸福指数”为企业担当，以打造具有人文气息、时代特色、前瞻视野的新城投为努力目标，创新发展、多元并进，布局了“类金融、土地开发、PPP项目投资及幸福产业”四大业务板块，旗下8个子公司，对全省7市18县形成投资覆盖，服务地方经济社会发展的能力得到显著增强。未来，山西城投将继...",
              copyFrom: null,
              content:
                "山西城投系金控集团全资子公司，成立于2017年8月1日，作为我省城市建设投资的新生力量，山西城投自成立伊始，便以“提升城市配套功能、提高居民幸福指数”为企业担当，以打造具有人文气息、时代特色、前瞻视野的新城投为努力目标，创新发展、多元并进，布局了“类金融、土地开发、PPP项目投资及幸福产业”四大业务板块，旗下8个子公司，对全省7市18县形成投资覆盖，服务地方经济社会发展的能力得到显著增强。 未来，山西城投将继续发扬“开拓创新、合作包容、务实高效、勇争一流”的企业精神，继续发挥投融资平台的传统优势和独特作用，协调推进投融资业务、金融业务、实体业务，持之以恒务实笃行，以一己之重为金控集团乃至全省全国发展大局添秤。 业务领域：投资类 经营范围：主要从事城市基础设施建设的投资和经营；金融服务、资产托管；土地开发；餐饮服务、食品生产、食品经营。",
              picture: "/profile/upload/content/2023/02/63f70de7e18ce.jpg",
              officialUrl: "http://www.sxsctjt.com",
              homePageUrl: "www.sxsctjt.com",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6927c3d00d.jpg",
              companyName: "山西省城建投融资管理集团有限公司",
              sort: 21,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:48:16",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:09:34",
              remark: null,
              id: 4300,
              menuId: 2186,
              title: "国信医投",
              subtitle: null,
              keywords: "",
              description:
                "山西国信医疗健康投资管理有限公司成立于2016年10月，注册资本1亿元，主要经营范围包括：对医疗、养老行业投资及资产委托管理；医疗服务；医药咨询服务；医疗器械批发零售等。目前业务涉足基层医疗服务、医疗器械贸易、母婴健康管理及商业保理等业务领域。隶属于山西金融投资控股集团有限公司。国信医投始终坚持以国家支持医疗体制改革为契机，以政府政策为导向，坚持稳中求进总基调，积极寻求市场机遇，不断探索业务领域，不断提高...",
              copyFrom: null,
              content:
                "山西国信医疗健康投资管理有限公司成立于2016年10月，注册资本1亿元，主要经营范围包括：对医疗、养老行业投资及资产委托管理；医疗服务；医药咨询服务；医疗器械批发零售等。目前业务涉足基层医疗服务、医疗器械贸易、母婴健康管理及商业保理等业务领域。隶属于山西金融投资控股集团有限公司。 国信医投始终坚持以国家支持医疗体制改革为契机，以政府政策为导向，坚持稳中求进总基调，积极寻求市场机遇，不断探索业务领域，不断提高管理水平，强化团队建设，企业实力和规模不断扩大。目前，公司下设一室五部：综合办公室、财务部、资本运营部、项目管理部、风控部、贸易部。下设四个子公司：山西国信博爱母婴健康管理有限公司、山西国信迅达医疗器械有限公司、深圳国信海诚商业保理有限公司、山西国信医疗服务有限公司。 国信医投作为一家专门投资医疗、健康产业的国有投资机构，致力于构建涵盖国有投融资平台、医疗服务、健康管理、医药耗材供应等为一体的全产业链，服务我省的医疗体制改革，优化医疗资源配置。 业务类别：投资类 经营范围：以自有资金对医疗、养老行业投资及资产委托管理（不得从事吸收公众存款或变相吸收公众存款、发放贷款等金融业务）；医疗服务；医药咨询服务；企业管理咨询服务；商务咨询服务；会议及展览服务；医疗器械经营：医疗器械批发零售；煤炭批发零售、铁矿石批发。",
              picture: "/profile/upload/content/2023/02/63f70ee4d2fe7.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea69260afcdf.jpg",
              companyName: "山西国信医疗健康投资管理有限公司",
              sort: 20,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:45:06",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:42",
              remark: null,
              id: 4299,
              menuId: 2186,
              title: "投融资",
              subtitle: null,
              keywords: "",
              description:
                "山西省国有投融资管理有限公司（以下简称“投融资公司”）成立于2016年9月，属山西金融投资控股集团有限公司全资控股子公司，注册资本金1亿元。公司营业执照是山西省首家“五证合一、一照一码”执照。投融资公司经营范围涵盖国有资本运营及资产管理；投资管理及相关咨询服务（不含证券、期货投资咨询）；担保业务（不含融资性担保）；国内外贸易、供应链管理及金融服务。为顺应国家供给侧结构性改革中大力推动供应链发展战略政策趋...",
              copyFrom: null,
              content:
                "山西省国有投融资管理有限公司（以下简称“投融资公司”）成立于2016年9月，属山西金融投资控股集团有限公司全资控股子公司，注册资本金1亿元。公司营业执照是山西省首家“五证合一、一照一码”执照。 投融资公司经营范围涵盖国有资本运营及资产管理；投资管理及相关咨询服务（不含证券、期货投资咨询）；担保业务（不含融资性担保）；国内外贸易、供应链管理及金融服务。 为顺应国家供给侧结构性改革中大力推动供应链发展战略政策趋势，结合山西省被中央指定为首个能源革命综合改革试点省份，按照国家对山西省重大决策部署及指示精神和我省对供应链管理服务发展思路及山西金控集团业务板块结构特点，投融资公司将“以山西支柱能源产业为依托，通过植入‘区块链+供应链’双链结构，形成完整的网络化、生态化供应链管理服务模式，打造山西优秀的供应链管理服务平台旗舰企业 ”确定为公司战略发展目标。通过依托大型国有企业及上市企业平台优势及资源优势，国内知名数字技术企业技术优势，打造供应链管理服务平台，聚焦能源及相关产业，以物流为基石，电商交易为引擎，供应链金融为抓手，数字化智慧供应链平台为支撑，打造“区块链+物联网”智慧供应链金融服务平台，搭建从资金、管理、仓储、运输到客户的全流程供应链服务。 投融资公司投资业务主要以股权为主，下设全资子公司——山西国盈富通股权投资管理有限公司（以下简称“国盈富通”），是投融资公司私募股权投资的业务平台，于2018年5月设立，注册资本2000万元。私募基金管理人备案登记编码为： P1070314。经营范围为：受托管理股权投资企业，从事股权投资管理及相关咨询服务。 国盈富通秉持“国富民强，通盈四方”的初心和“市场化运营、专业化管理”的理念立足山西，面向全国开展业务，着力发挥自身在政府、产业和企业等不同层面和主体间的资源整合优势，着重服务于山西省提质增效的传统行业及转型升级的战略新兴产业，主要有节能环保、智能制造、军民融合、大健康、乡村振兴等领域。投资产品主要有产业基金、并购基金、定增基金等。 投融资公司自成立以来，先后获得团省委及人社厅命名的“省级青年文明号”单位、中国物流与采购联合会确定为“中物联金融委副会长单位”，“2019年中国物流与供应链金融服务创新企业”、集团公司颁发的“2017年度先进基层党组织”、“2017年度先进集体”“2018年度先进基层党组织”“标准化党支部”“庆祝改革开放40周年合唱比赛一等奖”“道德风尚奖”等荣誉。 未来的投融资公司将以“锻造资本纽带、建造资本桥梁、打造发展舞台、创造更大价值”为使命，以“打造山西省供应链管理服务旗舰企业，建成省内一流国有资产管理、投融资平台”为目标，以“自然、自强、自省、自勉、自信、自立”的核心价值观，大力提高国有资本配置和运营效率，提升资源整合能力，助推产业转型升级。 业务领域：投资类 山西省国有投融资管理有限公司经营范围： （一）国有资本运营及资产管理； （二）投资管理及相关咨询服务（不含证券、期货投资咨询）； （三）担保业务（不含融资性担保）； 国内外贸易（法律禁止的除外）。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。",
              picture: "/profile/upload/content/2023/02/63f70d7768cf4.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6923a9eb0a.jpg",
              companyName: "山西省国有投融资管理有限公司",
              sort: 19,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:42:05",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:31",
              remark: null,
              id: 4298,
              menuId: 2186,
              title: "清洁投资",
              subtitle: null,
              keywords: "",
              description:
                "山西金信清洁引导投资有限公司是山西金融投资控股集团有限公司旗下的国有独资地方金融类企业，是政府、财政引导资金的出资人代表，致力于打造全国一流的政策性、专业性兼具公益性的政府指导与市场化运营有机结合的省级资本运营和管理平台。目前管理并运营着总规模100亿元的山西省煤炭清洁利用投资基金和总规模100亿元的山西省政府和社会资本合作（PPP）融资支持基金。曾荣膺“2018年度山西转型发展创新新动力企业”“山西省金融...",
              copyFrom: null,
              content:
                "山西金信清洁引导投资有限公司是山西金融投资控股集团有限公司旗下的国有独资地方金融类企业，是政府、财政引导资金的出资人代表，致力于打造全国一流的政策性、专业性兼具公益性的政府指导与市场化运营有机结合的省级资本运营和管理平台。目前管理并运营着总规模100亿元的山西省煤炭清洁利用投资基金和总规模100亿元的山西省政府和社会资本合作（PPP）融资支持基金。 曾荣膺“2018年度山西转型发展创新新动力企业”“山西省金融系统优质服务先进单位”“山西省金融系统优质服务杰出标兵单位”“山西省金融系统五一劳动奖状”等荣誉称号，成为我省基金行业的示范标杆和领跑者。 公司经营范围： 煤炭清洁能源利用的投资管理；政府、财政对外投资的管理;参股、控股或者委托设立基金管理公司；政府引导资金的投资管理；政府与社会资本合作项目的咨询服务；资产管理;投融资方案咨询服务；财务会计咨询服务。",
              picture: "/profile/upload/content/2023/02/63f70eaf2cca3.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea692269a18b.jpg",
              companyName: "山西金信清洁引导投资有限公司",
              sort: 18,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:38:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:10:57",
              remark: null,
              id: 4313,
              menuId: 2191,
              title: "中合盛",
              subtitle: null,
              keywords: "",
              description:
                "中合盛资本管理有限公司是山西国信投资集团有限公司旗下从事政府投资基金管理和私募股权投资的专业机构。公司于2014年12月在上海自贸区注册成立，注册资本1亿元人民币，2015年3月在中国证券投资基金业协会取得私募基金管理人登记证明，登记编号为P1008848。中合盛资本拥有一支专业的投研团队，核心成员来自政府、投行、证券、信托、担保、管理咨询、私募基金等相关机构，熟悉资本市场运作，投资经验丰富、实务操作熟练、行业资源广...",
              copyFrom: null,
              content:
                "中合盛资本管理有限公司是山西国信投资集团有限公司旗下从事政府投资基金管理和私募股权投资的专业机构。公司于2014年12月在上海自贸区注册成立，注册资本1亿元人民币，2015年3月在中国证券投资基金业协会取得私募基金管理人登记证明，登记编号为P1008848。中合盛资本拥有一支专业的投研团队，核心成员来自政府、投行、证券、信托、担保、管理咨询、私募基金等相关机构，熟悉资本市场运作，投资经验丰富、实务操作熟练、行业资源广泛。公司致力于有效对接实体经济与社会资本，为客户提供投资咨询、资产重组、私募融资、市值管理、产业延伸等多元化金融服务，助力企业实现跨越发展。 中合盛资本目前承担总规模近百亿元的山西省政府投资基金管理职能；同时从事市场化私募股权投资基金管理。通过直投、并购、定增、夹层基金等方式，聚焦新能源、现代煤化工、高端装备制造、TMT、文旅、医疗大健康等重点领域。2016年以来，中合盛资本运用所管理的山西省政府产业基金先后运作了潞安集团180万吨煤制油，山西大运新能源汽车，山西国耀新能源生物质发电，反腐倡廉电视剧《于成龙》，山西综改示范区太原移动能源产业园，海南易乐物联等一系列重点项目，基金管理规模达到43.5亿元；此外，成功运作和参与了新疆熙菱信息创业板iPo，亚宝药业定增、山西七一华富生物质发电、无锡新洁能半导体preipo等市场化项目，其中部分项目已成功退出。 中合盛资本秉承“凝聚智慧、创造价值”的创业理念，坚持“专业务实、追求卓越”的谋事作风，努力打造山西本土私募股权投资行业的优质品牌，并且已经逐步成长为山西省政府投资基金管理行业的主力军和排头兵。 公司经营范围 中合盛资本管理有限公司业务类别为投资类，经营范围主要包括股权投资，股权投资管理，资产管理，投资管理。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。",
              picture: "/profile/upload/content/2023/02/63f70d263580f.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea6920e090da.jpg",
              companyName: "中合盛资本管理有限公司",
              sort: 17,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:36:41",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:22",
              remark: null,
              id: 4297,
              menuId: 2186,
              title: "国信文旅",
              subtitle: null,
              keywords: "",
              description:
                "山西国信文化旅游投资发展集团有限公司成立于2012年3月13日，是山西金融投资控股集团有限公司的全资子公司，注册资本3亿元。公司经营范围涵盖了文化旅游、房地产、生态修复、园林绿化、商务服务等多个业务领域的投资及管理；具体包括旅游地产、农业旅游、研学旅行及金融科技、商务、教育、便民等相关服务领域的业务。公司建立了现代化法人治理结构，党委领导班子成员通过法定程序进入董事会、经理层任职；公司内设7个部门负责投资、...",
              copyFrom: null,
              content:
                "山西国信文化旅游投资发展集团有限公司成立于2012年3月13日，是山西金融投资控股集团有限公司的全资子公司，注册资本3亿元。公司经营范围涵盖了文化旅游、房地产、生态修复、园林绿化、商务服务等多个业务领域的投资及管理；具体包括旅游地产、农业旅游、研学旅行及金融科技、商务、教育、便民等相关服务领域的业务。 公司建立了现代化法人治理结构，党委领导班子成员通过法定程序进入董事会、经理层任职；公司内设7个部门负责投资、融资、风控、党群等日常运营工作；下设山西国信园林绿化工程有限公司、山西国信文旅商务服务有限公司、山西立体停车场有限公司3个全资子公司和山西国信山水园有限公司1个参股子公司，围绕公司各类主营业务，搭建了权责明确、务实高效、监督制衡的科学管理体系。 公司秉承“创新驱动、追求卓越”的企业精神，坚持“围绕主业谋发展，发挥优势求突破”的战略方针；按照“发挥资源优势，坚持绿色发展，聚焦创新驱动，争做行业标杆”的发展思路；一手抓主责，一手抓主业，“两手抓、两手硬”，努力打造全省文化旅游投资行业的示范标杆。 经营范围：园林绿化、旅游、房地产、文化产业、停车场等的投资。 业务领域：投资类",
              picture: "/profile/upload/content/2023/02/63f70e75b9653.jpg",
              officialUrl: "",
              homePageUrl: "",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691df04d1b.jpg",
              companyName: "山西国信文化旅游投资发展集团有限公司",
              sort: 15,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:31:45",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:12",
              remark: null,
              id: 4296,
              menuId: 2186,
              title: "山西光信",
              subtitle: null,
              keywords: "",
              description:
                "山西省光信地产投资集团有限公司成立于1992年10月28日，隶属于山西金融投资控股集团有限公司，注册资本3.19亿元，国家一级房地产开发资质。公司经营范围包括开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售等。山西光信本部在职员工50余人，设9个职能部室，下设山西帝景房地产...",
              copyFrom: null,
              content:
                "山西省光信地产投资集团有限公司成立于1992年10月28日，隶属于山西金融投资控股集团有限公司，注册资本3.19亿元，国家一级房地产开发资质。 公司经营范围包括开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售等。 山西光信本部在职员工50余人，设9个职能部室，下设山西帝景房地产开发有限公司、品德实业（太原）有限公司、山西毛条厂、山西国信物业管理服务有限公司四个全资子公司，参股太原晋信卓惠城建投资中心（有限合伙）。 山西光信创立于中国房地产发展的黄金年代，成立以来，先后取得ISO 9001质量管理体系认证、ISO14000环境管理体系认证和OHSAS18000职业健康安全管理体系认证。通过多年深耕太原房地产市场，贡献了多个精品楼盘，逐渐在我省财政、金融系统获得了良好的口碑。秉承国企声誉和晋商品格，传承严谨的工作作风和企业管理特色，项目选址精准、定位清晰、品质优良、价格适中，既符合城市发展方向，又适当提前布局，使各项目成为当时太原房地产市场的宠儿和焦点。取得国家一级房地产开发资质后，光信品牌价值得到了巨大提升，成为太原乃至山西省内房地产行业知名房企，获得了市场和业界的广泛认可。 山西光信秉承国企实力，始终坚持“品质于形，服务于心”的品牌理念，恪守“厚生明德，创新至善”的核心价值观，坚持“殚精竭虑谋划，一丝不苟执行”的工作作风，形成了独具光信特色的企业八大文化，全力为广大业主打造 “专业化、精细化、个性化”产品。近年来，山西光信积极探索“地产+”发展新思路，向金融、健康、教育、文旅、商业等产业，向家装、物业、租赁、智慧社区等上下游延伸产业链，不断向着“做山西地产界有独特竞争力、受尊重的龙头企业”的企业愿景迈进。 经营范围：实业类：房地产开发：开发、建设、经营房地产业；房地产咨询服务；以自有资金对房地产业、建筑业、住宿业、餐饮业、文化体育及娱乐业进行投资与经营；室内装饰装修：装潢装饰工程；物业服务；新型建材的研制，开发、生产和销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
              picture: "/profile/upload/content/2023/02/63f70400cebb5.jpg",
              officialUrl: "http://sxgxdc.com",
              homePageUrl: "http://sxgxdc.com",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691c560860.jpg",
              companyName: "山西省光信地产投资集团有限公司",
              sort: 14,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:25:54",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:13:01",
              remark: null,
              id: 4295,
              menuId: 2186,
              title: "山西国贸",
              subtitle: null,
              keywords: "",
              description:
                "山西省国贸投资集团有限公司（以下简称“山西国贸”）前身为成立于2002年1月的山西国际贸易中心有限公司，系山西金融投资控股集团有限公司的全资子公司。山西国贸注册资本金为36000万元。2018年8月14日，公司更名为“山西省国贸投资集团有限公司”。山西国贸的经营范围为：对非上市公司的股权、上市公司非公开发行的股权等非公开交易的股权投资以及相关的咨询服务；自有房屋的租赁；房地产经纪服务；物业服务。山西国贸始终坚持“金...",
              copyFrom: null,
              content:
                "山西省国贸投资集团有限公司（以下简称“山西国贸”）前身为成立于2002年1月的山西国际贸易中心有限公司，系山西金融投资控股集团有限公司的全资子公司。山西国贸注册资本金为36000万元。2018年8月14日，公司更名为“山西省国贸投资集团有限公司”。 山西国贸的经营范围为：对非上市公司的股权、上市公司非公开发行的股权等非公开交易的股权投资以及相关的咨询服务；自有房屋的租赁；房地产经纪服务；物业服务。 山西国贸始终坚持“金融立企、实业兴企、产融结合”的发展思路，将股权投资与供应链金融确立为公司改革转型发展的重要目标，现已发展成为拥有山西国贸大饭店管理有限公司、山西国际贸易中心有限公司、山西国贸物业管理有限公司、山西国贸能源科技有限公司、晋融汇通（天津）商业保理有限公司五个子公司，涉足写字楼综合运营、商业综合管理服务、住宿餐饮、商业保理、股权投资等多个领域的重要省属企业。 在写字楼运营领域，山西国贸运营着山西第一家集五星级酒店、三甲写字楼、高档公寓、会展中心于一体的综合性项目——山西国际贸易中心，以卓越的硬件设施与优质的物业服务，赢得了广大用户的称赞，取得了良好的社会效益。作为山西国贸写字楼的重要配套，山西国贸大饭店于2004年1月正式运营，是山西省首家五星级饭店，并以管理输出的方式陆续承接了晋学苑、平型关国际酒店、省委应急指挥中心等项目；山西国贸物业管理有限公司成立于2003年7月，是拥有国家二级资质的专业物业服务机构，主要负责山西国际贸易中心的物业服务，山西国际贸易中心项目先后荣获“全国物业管理示范大厦”、五星级小区（大厦）。 在商业管理领域，山西国贸以新零售理念为引领，以实体门店、电子商务、移动互联网为核心，通过融合线上线下，重构人、货、场等核心要素，以“全场景、全数据、全渠道、全时段、全体验、全品类”的零售新模式、以股权投资合作等金融手段，持续拓展新的商业项目，开拓商业连锁运营的新局面，打造独树一帜的“国贸”新品牌。 在商业保理领域，山西国贸将坚持推动能源供应链管理与商业保理业务的互融互促，加大与省内外知名供应链管理企业的合作力度，围绕大型省属能源集团企业客户，做好电力行业这一垂直细分领域的商业保理服务，努力实现核心企业、供应商、保理商三方的互利共赢，着力为供应链中小企业缓解融资难题，切实为保障省内能源供应链畅通贡献力量。 在股权投资领域，围绕山西省委关于构建现代产业体系的重大部署，山西国贸灵活运用股权投资手段，加大现代物流、能源科技、生物医药、人工智能等领域的投资力度，通过并购符合公司战略方向与发展业态的企业股权，持续优化资产布局。 “全球化视野”、“创新变革”、“开放包容”、“差异化运营”是山西国贸的核心价值观，支撑国贸走出了独具特色的发展路径，形成了多板块投资、聚焦类金融的经营格局。跨入新时代，面对新机遇，山西国贸将不断提升自我，奉行“关爱客户、注重品质”的价值理念，用勇气和智慧拥抱时代变革，用诚信与包容携手合作伙伴，用激情和卓越开创企业高质量发展的新局面。",
              picture: "/profile/upload/content/2023/02/63f7046c59a83.jpg",
              officialUrl: "http://shanxigomo.com/",
              homePageUrl: "http://shanxigomo.com/",
              homePagePicture:
                "/profile/upload/content/2020/04/5ea691ad58cc9.jpg",
              companyName: "山西省国贸投资集团有限公司",
              sort: 13,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2020-04-26 14:22:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:12:50",
              remark: null,
              id: 4294,
              menuId: 2186,
              title: "太行基金",
              subtitle: null,
              keywords: "",
              description:
                "为支持山西省供给侧结构性改革、综改示范区建设、国企改革，推动战略新兴、文化旅游、大数据、电子信息等产业以及民营企业、中小企业等发展，服务实体经济发展，加快培育新动能，促进我省经济转型升级、提质增效，根据《山西省政府投资基金管理暂行办法》，山西省政府特设立山西省太行产业投资基金。太行产业投资基金采用母子基金结构，其中母基金总规模为人民币300亿元，由山西金融投资控股集团有限公司作为财政出资人认缴100亿元...",
              copyFrom: null,
              content:
                "为支持山西省供给侧结构性改革、综改示范区建设、国企改革，推动战略新兴、文化旅游、大数据、电子信息等产业以及民营企业、中小企业等发展，服务实体经济发展，加快培育新动能，促进我省经济转型升级、提质增效，根据《山西省政府投资基金管理暂行办法》，山西省政府特设立山西省太行产业投资基金。 太行产业投资基金采用母子基金结构，其中母基金总规模为人民币300亿元，由山西金融投资控股集团有限公司作为财政出资人认缴100亿元；由山西太行产业投资基金管理有限公司作为基金管理人向社会合格投资者募集200亿元；在子基金层面，采用包括母基金管理人在内的双管理人模式，最终形成总规模为1050亿元的产业投资基金。 山西太行产业投资基金管理有限公司成立于2017年8月22日，注册资本2亿元，由山西金控独资设立。公司作为省级政府投资基金管理机构，主要从事省级政府投资基金的管理，并适时探索推进市场化基金业务。 业务定位：一是管理省级政府投资母基金；二是设立并管理直投基金，开展直投基金业务；三是参与设立各类子基金。在基金理事会的直接领导下，按照遴选标准遴选优秀的子基金管理机构，并进行管理、监督、考核与评价。根据省委、省政府安排，落实相关重大经济决策。 经营范围：管理或受托管理股权类投资并从事相关咨询服务业务。",
              picture: "/profile/upload/content/2023/02/63f6d4f46c760.jpg",
              officialUrl: "http://www.shanxith.cn",
              homePageUrl: "www.shanxith.cn",
              homePagePicture:
                "/profile/upload/content/2017/11/5a0152489bf39.jpg",
              companyName: "山西太行产业投资基金管理有限公司",
              sort: 12,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-11-07 11:46:46",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:50",
              remark: null,
              id: 4309,
              menuId: 2191,
              title: "中煤保险",
              subtitle: null,
              keywords: "",
              description:
                "中煤财产保险股份有限公司成立于2008 年10 月，注册地山西省太原市，是国内唯一一家具有煤炭行业背景的保险公司，也是首家总部设在山西省的全国性保险公司，经营范围涵盖车险、财产险、责任险、农业保险等各类财产保险业务。目前在山西、河北、山东、河南、四川、陕西设有分公司，山西省内机构覆盖11个地市和70个县市。中煤保险股东实力雄厚，山西金融投资控股集团是集银行、证券、保险、信托、股权、资产、产权、再担保、基金以及...",
              copyFrom: null,
              content:
                "中煤财产保险股份有限公司成立于2008 年10 月，注册地山西省太原市，是国内唯一一家具有煤炭行业背景的保险公司，也是首家总部设在山西省的全国性保险公司，经营范围涵盖车险、财产险、责任险、农业保险等各类财产保险业务。目前在山西、河北、山东、河南、四川、陕西设有分公司，山西省内机构覆盖11个地市和70个县市。 中煤保险股东实力雄厚，山西金融投资控股集团是集银行、证券、保险、信托、股权、资产、产权、再担保、基金以及投资等于一体的全牌照金融控股集团，中煤集团、晋煤集团、山西焦煤、潞安集团、同煤集团、阳煤集团等股东资产规模逾万亿，业务遍布主要煤炭大省和国外。 中煤保险以“管理高危风险，保障和谐社会”为使命，以成为“客户身边的高风险管理专家”为愿景，紧紧围绕“专业、责任、创新、价值”这一核心价值观，秉持“诚信守法、突出特色、驾驭风险、追求效益”的经营理念，以煤炭等高危保险为核心，传统领域优质业务为重点，新型保险业务为突破，全力打造识别、防范、化解煤炭等高危行业风险的技术体系，大胆探索符合高危客户风险管理需要的特色产品和服务模式，专注高危，精益运营，诚信服务，稳健发展，努力为高危企业、高危行业职业人群提供周全、完善、全面的风险保障，不断提升高危行业风险管理水平，为客户、股东、员工、社会公众和利益相关者创造价值，为促进经济发展与和谐社会建设做出应有的贡献。 经过几年发展，中煤保险业务遍布全国13个省、自治区、直辖市和9个大型煤炭基地及部分海外国家，为780个煤炭客户、1200座煤矿、200座非煤矿山、40万煤炭及高危行业职工提供保险服务，累计保险保障超过600亿元。在专注煤炭安全生产的同时，还为“蛟龙号”深海探测器7000米海试、澳大利亚、土耳其等海外能源项目、索契冬奥会滑雪运动员提供风险保障。 “做客户身边的高风险管理专家”，“忠于承诺，管理未来”，是中煤保险人的郑重承诺，也是中煤保险践行社会责任的卓越追求！",
              picture: "/profile/upload/content/2017/12/5a2a2bceb92e9.jpg",
              officialUrl: "http://www.chinacoal-ins.com/",
              homePageUrl: "www.chinacoal-ins.com",
              homePagePicture:
                "/profile/upload/content/2017/10/59eeff7c9c03b.jpg",
              companyName: "中煤财产保险股份有限公司",
              sort: 5,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:53:19",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:21:33",
              remark: null,
              id: 4311,
              menuId: 2191,
              title: "山西股权",
              subtitle: null,
              keywords: "",
              description:
                "山西股权交易中心有限公司（以下简称“山西股权交易中心”）是经山西省人民政府批准设立的省内唯一的区域性股权市场，是为我省中小微企业证券非公开发行、转让及相关活动提供设施与服务的场所，是我省中小微企业的私募股权市场，是地方人民政府扶持中小微企业政策措施的综合运用平台。控股股东为山西金融投资控股集团有限公司，太原高新区和山西证券股份有限公司为参股股东，注册资本金为1亿元。多层次资本市场结构图 业务范围：为...",
              copyFrom: null,
              content:
                "山西股权交易中心有限公司（以下简称“山西股权交易中心”）是经山西省人民政府批准设立的省内唯一的区域性股权市场，是为我省中小微企业证券非公开发行、转让及相关活动提供设施与服务的场所，是我省中小微企业的私募股权市场，是地方人民政府扶持中小微企业政策措施的综合运用平台。控股股东为山西金融投资控股集团有限公司，太原高新区和山西证券股份有限公司为参股股东，注册资本金为1亿元。 多层次资本市场结构图 业务范围： 为非上市股份公司股权的挂牌、登记、托管、转让提供服务； 为中小微企业改制、重组并购、上市、投资提供业务咨询服务； 提供与上述经营范围相关产品的信息发布及培训服务。 我们的使命： 　　为企业提供多元化、专业化、个性化融资融智平台； 　　为投资者提供多样化投资平台； 　　为会员单位提供新业务创新平台； 　　为山西综改试验区建设经济转型升级提供综合服务平台。",
              picture: "/profile/upload/content/2017/12/5a2a2c1278701.jpg",
              officialUrl: "http://www.sxgq.net/",
              homePageUrl: "www.sxgq.net",
              homePagePicture:
                "/profile/upload/content/2017/10/59eeff1dcf1a3.jpg",
              companyName: "山西股权交易中心有限公司",
              sort: 9,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:51:44",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:00",
              remark: null,
              id: 4310,
              menuId: 2191,
              title: "山西交易集团",
              subtitle: null,
              keywords: "",
              description:
                "山西省交易集团股份有限公司（以下简称“山西交易集团”）注册资本2.78亿元，是山西金控集团为贯彻落实中共中央、国务院关于深化要素交易市场化改革精神设立的山西省首家大型国有交易集团，是山西省唯一的大型全牌照金融控股集团——山西金融投资控股集团有限公司的重要子公司。山西交易集团负责运营和管理各类要素交易平台以及提供相关交易配套服务，围绕十三个业务板块，在深耕传统资产交易的基础上，拓宽业务边界，积极聚焦战略...",
              copyFrom: null,
              content:
                "山西省交易集团股份有限公司（以下简称“山西交易集团”）注册资本2.78亿元，是山西金控集团为贯彻落实中共中央、国务院关于深化要素交易市场化改革精神设立的山西省首家大型国有交易集团，是山西省唯一的大型全牌照金融控股集团——山西金融投资控股集团有限公司的重要子公司。山西交易集团负责运营和管理各类要素交易平台以及提供相关交易配套服务，围绕十三个业务板块，在深耕传统资产交易的基础上，拓宽业务边界，积极聚焦战略性新兴产业，充分发挥“信息集散、发现价值、资本进退、规范流动、优化资源配置”五大功能。 山西交易集团始终秉持“让天下没有难交易的资产”的企业愿景与“交易创造价值”的企业使命，恪守“阳光透明，合规合法”经营原则，坚持以习近平新时代中国特色社会主义思想为指导，全面贯彻党的二十大精神，不断推进旗下各要素交易平台市场化、信息化发展，致力于成为国内一流的基础性、权益性资本市场平台，并不断向全要素全资源综合性非标市场平台发展迈进，为我省实体经济提供优质服务，助力全国统一大市场的形成与高标准市场体系的建设，为山西省全方位推进高质量发展注入力量。",
              picture: "/profile/upload/content/2022/12/63a1362aacca1.jpg",
              officialUrl: "http://sxexgrp.cn/",
              homePageUrl: "www.sxexgrp.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefef68286d.jpg",
              companyName: "山西省交易集团股份有限公司",
              sort: 8,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:51:05",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:11:59",
              remark: null,
              id: 4308,
              menuId: 2191,
              title: "山西信托",
              subtitle: null,
              keywords: "",
              description:
                "山西信托是由山西省信托投资公司改制而成，于2002年4月1日正式获准重新登记，是经中国人民银行和山西省人民政府批准保留的山西唯一一家信托机构。公司注册资本金人民币13.57亿元，其中美元2414万元。2013年4月公司经中国银行业监督管理委员会批准，名称由“山西信托有限责任公司”变更为“山西信托股份有限公司”。目前，公司由3家股东单位组成，分别为：山西金融投资控股集团有限公司、太原市海信资产管理有限公司、山西国际电力集...",
              copyFrom: null,
              content:
                "山西信托是由山西省信托投资公司改制而成，于2002年4月1日正式获准重新登记，是经中国人民银行和山西省人民政府批准保留的山西唯一一家信托机构。公司注册资本金人民币13.57亿元，其中美元2414万元。2013年4月公司经中国银行业监督管理委员会批准，名称由“山西信托有限责任公司”变更为“山西信托股份有限公司”。目前，公司由3家股东单位组成，分别为：山西金融投资控股集团有限公司、太原市海信资产管理有限公司、山西国际电力集团有限公司。 为了适应不断变化的市场环境，保持公司的良好发展态势，公司将坚持以科学发展观统领公司发展全过程，紧紧围绕公司战略发展目标，规范经营，稳健发展，执着追求，勇于创新，努力提高核心竞争力，加快业务调整步伐，实现合理盈利模式，构建学习型、效益型、和谐型公司，充分实现股东权益、社会效益和员工利益的最大化，逐步将公司发展成为全国一流的信托机构，成为具有一定影响力的专业理财机构。",
              picture: "/profile/upload/content/2017/12/5a2a2c5b1cffa.jpg",
              officialUrl: "http://www.sxxt.net/",
              homePageUrl: "www.sxxt.net",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefece932d5.jpg",
              companyName: "山西信托股份有限公司",
              sort: 4,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:50:24",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:20:26",
              remark: null,
              id: 4307,
              menuId: 2191,
              title: "山西证券",
              subtitle: null,
              keywords: "",
              description:
                "山西证券股份有限公司最早成立于1988年7月，是全国首批证券公司之一，属国有控股性质。经过二十多年的发展，已成为作风稳健、经营稳定、管理规范、业绩良好的创新类证券公司。2010年9月，公司上市首发申请获中国证监会发审委审核通过，11月15日正式在深圳证券交易所挂牌上市，股票代码002500，注册资本28.2873亿元。公司股东资金实力雄厚，经营风格稳健，资产质量优良，盈利能力良好，其构成集中体现了多种优质资源、多家优势企业的...",
              copyFrom: null,
              content:
                "山西证券股份有限公司最早成立于1988年7月，是全国首批证券公司之一，属国有控股性质。经过二十多年的发展，已成为作风稳健、经营稳定、管理规范、业绩良好的创新类证券公司。2010年9月，公司上市首发申请获中国证监会发审委审核通过，11月15日正式在深圳证券交易所挂牌上市，股票代码002500，注册资本28.2873亿元。 公司股东资金实力雄厚，经营风格稳健，资产质量优良，盈利能力良好，其构成集中体现了多种优质资源、多家优势企业的强强联合。公司控股股东为山西金融投资控股集团有限公司。 经过近三十年的发展，山西证券的经营范围基本涵盖了所有的证券领域，分布于财富管理、资产管理、投资管理、投融资、研究、期货、国际业务等板块，具体包括：证券经纪；证券自营；证券资产管理；证券投资咨询；与证券交易、证券投资活动有关的财务顾问；证券投资基金代销；为期货公司提供中间介绍业务;融资融券；代销金融产品等。同时，公司具备公开募集证券投资基金管理业务资格，并获批开展债券质押式报价回购交易、股票质押式回购交易、约定购回式证券交易、转融通、上市公司股权激励行权融资、直接投资、柜台市场等业务。 公司控股中德证券有限责任公司，从事股票和债券的承销与保荐；全资控股格林大华期货有限公司，从事商品期货经纪、金融期货及期货投资咨询业务；全资控股山证国际金融控股有限公司，从事全面优质的经纪及零售证券、期货、投资理财、财富管理、投资移民等金融产品及服务；全资子公司龙华启富投资有限责任公司，从事投资管理、项目投资、财务顾问、经纪信息咨询等直接投资与管理业务。 公司设有分公司14家（管辖63家证券营业部），直辖营业部15家，2017年3月又获19家营业部的筹建批复，期货营业网点27家。以上网点分布于山西各地市、主要县区及北京、上海、天津、深圳、重庆、西安、宁波、大连、济南、福州等地，形成了以国内主要城市为前沿，重点城市为中心，覆盖山西、面向全国的业务发展框架，为近120万客户提供全面、优质的综合金融专业服务。 近年来，公司先后获得山西省政府颁发的“优秀中介机构”、深交所颁发的“中小企业板优秀保荐机构”、中国证监会颁发的“账户规范先进集体”等荣誉，并连续多年荣获山西省人民政府授予的“支持山西地方经济发展贡献奖”。2012年，公司荣获“第五届中国机构投资者年会暨金蝉奖——最稳健证券公司奖”、“中国最具特色证券经纪商”和“最佳投顾服务品牌”；2013年，公司荣获山西证监局颁发的“投资者回报优秀单位”、“投资者关系管理优秀单位”及“社会责任优秀单位”，在行业内评选中荣获“行业年度贡献奖”、“最佳研究实力奖”、“2013年中国券商‘金方向’奖—最佳创新证券公司”等殊荣；2014年，公司荣获山西省总工会颁发的“山西省金融系统优质服务先进单位”奖，在行业内评选中获得“中国上市公司风险管理金盾奖”、“2014年中国最具成长性证券经纪商”、“中国最佳区域证券经纪商”、“中国最佳融资融券商”；2015年，公司获得山西省金融办、山西证监局颁发的“2015年度新三板优秀主办券商”的称号，在中国最佳财富管理机构评选活动中获得“中国最佳区域证券经纪商”和“中国最佳投资顾问品牌”等荣誉。 未来的山西证券将秉承“诚信、稳健、规范、创新、高效”的经营理念，“以义制利、协作包容、追求卓越”的核心价值观，以“专业服务创造价值”为使命，坚持“让投资更明白”的服务理念，培育务实高效、恪尽职守的工作作风，营造和谐宽松、风清气正的公司氛围，坚定公司发展过程中差异化、专业化、市场化、集约化的战略原则，打造公司与客户共同发展的平台，努力把公司建设成为有特色、有品牌、有竞争力的一流券商。",
              picture: "/profile/upload/content/2017/12/5a2a2c6e20d7d.jpg",
              officialUrl: "http://www.i618.com.cn/",
              homePageUrl: "www.i618.com.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefe9fb0081.jpg",
              companyName: "山西证券股份有限公司",
              sort: 3,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:49:37",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:39",
              remark: null,
              id: 4293,
              menuId: 2186,
              title: "山西金租",
              subtitle: null,
              keywords: "",
              description:
                "山西金融租赁有限公司是1992年由山西省计划委员会、省工商银行和省建设银行合资组建，经中国人民银行批准设立的主营融资租赁业务的非银行金融机构。注册资本5亿元人民币，股东为山西金融投资控股集团有限公司。公司成立二十多年来，秉承“诚信、勤勉、稳健、创新”的经营理念，充分发挥融资租赁这一独特金融工具融资融物、加速技术进步、促进产业升级等显著优势，已在企业技术改造、交通运输、能源环保、工程机械、医疗印刷等领域为...",
              copyFrom: null,
              content:
                "山西金融租赁有限公司是1992年由山西省计划委员会、省工商银行和省建设银行合资组建，经中国人民银行批准设立的主营融资租赁业务的非银行金融机构。注册资本5亿元人民币，股东为山西金融投资控股集团有限公司。 公司成立二十多年来，秉承“诚信、勤勉、稳健、创新”的经营理念，充分发挥融资租赁这一独特金融工具融资融物、加速技术进步、促进产业升级等显著优势，已在企业技术改造、交通运输、能源环保、工程机械、医疗印刷等领域为众多企事业单位提供融资租赁服务，为促进经济发展做出了积极努力。与此同时，公司也在与企业的合作过程中取得了良好的经济效益和社会效益，公司自成立以来保持持续盈利，并精心打造了一个管理高效、服务一流、信誉卓著的金融租赁品牌。",
              picture: "/profile/upload/content/2017/12/5a2a2b7b7fd4d.jpg",
              officialUrl: "http://www.leasing.com.cn/",
              homePageUrl: "www.leasing.com.cn",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefe3452235.jpg",
              companyName: "山西金融租赁有限公司",
              sort: 7,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:47:51",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-03-11 09:22:52",
              remark: null,
              id: 4292,
              menuId: 2186,
              title: "山西再担保",
              subtitle: null,
              keywords: "",
              description:
                "山西省融资再担保集团有限公司是省委、省政府为促进小微企业和“三农”发展而成立的省级政策性担保机构，现为山西金融投资控股集团有限公司全资子公司。公司前身为“山西省中小企业信用担保有限公司”，成立于2000年7月，于2015年11月改制为“山西国信融资再担保有限公司”，2017年6月更名为“山西省融资再担保有限公司”。2018年10月更名为“山西省融资再担保集团有限公司”。截止2018年底，注册资本金188260万元，总资产236700万...",
              copyFrom: null,
              content:
                "山西省融资再担保集团有限公司是省委、省政府为促进小微企业和“三农”发展而成立的省级政策性担保机构，现为山西金融投资控股集团有限公司全资子公司。公司前身为“山西省中小企业信用担保有限公司”，成立于2000年7月，于2015年11月改制为“山西国信融资再担保有限公司”，2017年6月更名为“山西省融资再担保有限公司”。2018年10月更名为“山西省融资再担保集团有限公司”。截止2018年底，注册资本金188260万元，总资产236700万元。 多年来，公司秉持“传导全省产业政策，提升行业担保能力，引导行业规范经营，化解行业担保风险”的经营方针，开展再担保、融资担保、非融资担保、创业贷款担保、委托贷款和投资理财、企业咨询等业务。 成立以来，公司稳步发展，服务实体经济与小微企业能力逐渐凸显，经济效益和社会效益齐头并进，累计为全省9300余户中小微企业和“三农”客户担保近600亿元，带动企业及三农增加销售收入约1000亿元，增加利税约100亿元，解决就业岗位20余万个。担保业务范围覆盖全省11个地级市，与我省8个市级担保机构开展再担保合作，银行授信总额超过100亿元，推动了我省担保体系建设。荣膺“全国十大最具影响力中小企业信用担保机构”、全国“最具影响力再担保机构”、 “全国中小企业融资担保创新奖”。 未来，公司将继续秉承“诚信、廉洁、务实、创新”的企业文化，进一步发挥准公共产品的作用，服务我省供给侧结构性改革和综改区建设，为我省经济转型发展贡献更多力量。",
              picture: "/profile/upload/content/2017/12/5a2a2b8c55e56.jpg",
              officialUrl: "http://www.sxsrzzdb.com/",
              homePageUrl: "www.sxsrzzdb.com",
              homePagePicture:
                "/profile/upload/content/2017/10/59eefde1652b5.jpg",
              companyName: "山西省融资再担保集团有限公司",
              sort: 6,
              isRecommend: null,
              status: 1,
              recruitStatus: null,
              userName: "sxjkgw",
              inputTime: "2017-10-24 16:46:27",
              menuParentId: null,
              searchContent: null,
            },
          ],
          silderList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2023-04-17 15:02:09",
              remark: null,
              id: 40,
              menuId: 2383,
              title: "中国特色社会主义思想主题教育",
              thumb: "/profile/upload/content/2023/05/645a055a8db01.jpg",
              status: 1,
              sort: 21,
              userName: "admin",
              inputTime: "2023-04-17 15:02:09",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2022-10-13 11:27:16",
              remark: null,
              id: 36,
              menuId: 2383,
              title: "二十大",
              thumb: "/profile/upload/content/2022/10/634785718387e.png",
              status: 1,
              sort: 20,
              userName: "admin",
              inputTime: "2022-10-13 11:27:16",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-03-02 18:00:05",
              remark: null,
              id: 28,
              menuId: 2383,
              title: "学党史",
              thumb: "/profile/upload/content/2021/03/603e0c982e68f.jpg",
              status: 1,
              sort: 15,
              userName: "admin",
              inputTime: "2021-03-02 18:00:05",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2019-06-13 14:56:16",
              remark: null,
              id: 11,
              menuId: 2383,
              title: "1",
              thumb: "/profile/upload/content/2019/06/5d02012095095.jpg",
              status: 1,
              sort: 9,
              userName: "admin",
              inputTime: "2019-06-13 14:56:16",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2019-06-13 14:57:03",
              remark: null,
              id: 12,
              menuId: 2383,
              title: "2",
              thumb: "/profile/upload/content/2019/06/5d01f3b9e99ca.jpg",
              status: 1,
              sort: 8,
              userName: "admin",
              inputTime: "2019-06-13 14:57:03",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2019-06-13 14:58:07",
              remark: null,
              id: 13,
              menuId: 2383,
              title: "3",
              thumb: "/profile/upload/content/2019/06/5d01f3fa9a1c0.jpg",
              status: 1,
              sort: 7,
              userName: "admin",
              inputTime: "2019-06-13 14:58:07",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-10-20 16:57:17",
              remark: null,
              id: 3,
              menuId: 2383,
              title: "图片7",
              thumb: "/profile/upload/content/2018/11/5bf37acb74a70.jpg",
              status: 1,
              sort: 6,
              userName: "admin",
              inputTime: "2017-10-20 16:57:17",
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2017-10-20 16:56:58",
              remark: null,
              id: 2,
              menuId: 2383,
              title: "图片6",
              thumb: "/profile/upload/content/2020/06/5ed6164a310ff.jpg",
              status: 1,
              sort: 5,
              userName: "admin",
              inputTime: "2017-10-20 16:56:58",
            },
          ],
          headlineList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-28 09:48:21",
              remark: null,
              id: 5308,
              menuId: 2017,
              title:
                "山西金控集团召开2025年第4次党委理论学习中心组（扩大）学习会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "4月17日，山西金控集团召开2025年第4次党委理论学习中心组（扩大）学习会议。会议学习了3月31日习近平总书记主持召开的中央政治局会议精神，传达学习了国务院办公厅《关于做好金融“五篇大文章”的指导意见》，分专题学习了《习近平文化思想学习纲要》之《像石榴籽一样紧紧抱在一起》《唱响主旋律，弘扬正能量》和违反中央八项规定及其实施细则精神的典型案例等，围绕《习近平关于加强党的作风建设论述摘编》第一至三篇等进行了研讨交流。山西金控集团党委书记、董事长王振宇主持会议，集团党委班子成员、党委理论学习中心组扩大学习成员参加。 王振宇强调，要持续压实巡视整改责任，毫不松懈抓好巡视问题整改“后半篇文章”，以钉钉子精神巩固整改成效。要充分做好中央巡视延伸下沉的思想准备和工作准备，始终保持高度警觉，强化统筹协调，以严慎细实的作风将各项工作抓牢、抓细、抓到位。 王振宇强调，要深刻学习领会《指导意见》精神，深化“五篇大文章”的战略定位，强化内部能力建设，对照文件要求严格对标对表、精准落实到位。要紧跟形势与政策，及时组织研究新出台的统计制度，准确把握统计要求，确保涉及的相关业务全面纳入统计体系，以制度化、规范化举措推动集团高质量发展。 “心往一处想、劲往一处使”，王振宇强调，要深刻把握“铸牢中华民族共同体意识”的精神实质，将全体员工的思想行动凝聚成发展合力，把共同体意识切实转化为集团团结奋进的文化基因。要深入学习信息化条件下舆论主导权相关内容，全面提升舆论引导能力，精准发力，以科学策略与高效行动筑牢意识形态阵地，营造积极健康的舆论环境。 王振宇强调，各级党组织要扎实推进学习教育走深走实，精研细悟典型案例的警示意义，从中深刻汲取教训，以案为鉴、警钟长鸣。要对照规定要求与工作实际，主动查摆问题、精准剖析根源，坚持问题导向抓整改，以刀刃向内的态度落实落细各项纪律要求，建立健全长效机制，持续加固作风建设堤坝，确保中央八项规定精神在集团上下落地生根、见行见效。",
              picture:
                "/profile/upload/image/2025/04/11/3b6e228e-6f42-4ec1-982a-8ca74ed15e76.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 470,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-18 10:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:49:30",
              remark: null,
              id: 5302,
              menuId: 2017,
              title:
                "山西金控集团召开2025年第3次党委理论学习中心组（扩大）学习会议",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "近日，山西金控集团召开2025年第3次党委理论学习中心组（扩大）学习会议，以视频方式与一级子公司中心组连线共学，并首次采用部分议题“子公司轮值领学”创新机制。集团党委书记、董事长王振宇主持会议，集团党委班子成员、党委理论学习中心组扩大学习成员在主会场参会，各公司中心组成员视频参学。 会议集中学习了习近平总书记在贵州和云南考察时发表的重要讲话精神，系统学习了《习近平文化思想学习纲要》之《实现精神上的独立自主》《人民有信仰，国家有力量，民族有希望》、证券行业警示案例等重要内容，并围绕能源革命改革进行了研讨交流。山西证券作为首期轮值子公司，相关班子成员结合证券行业实践，就文化建设专题、警示案例剖析、资本市场服务能源革命等内容进行了深度解读。 王振宇强调，要深刻领会习近平总书记考察贵州、云南重要讲话精神的核心要义，深化对经济工作的规律性认识，以科技创新引领新质生产力发展，夯实实体经济根基，推动数字经济与实体经济深度融合；要立足山西资源禀赋，在服务能源革命、优化营商环境、创新金融供给中担当作为。要坚持深耕山西，以“金融服务店小二”的姿态主动对接战略客户，探索资产证券化创新路径，在盘活资产证券化、提供融智支持等领域深化实践，为地方经济高质量发展贡献金控方案。 王振宇强调，企业文化是集团行稳致远的立身之本，要加快推进企业文化建设，通过全员参与、内外协同，打造兼具传统底蕴与时代精神的价值观体系。要依托“心声论坛”构建互动平台，引导员工形成健康向上的认知体系，实现个人成长与企业发展的良性互促。 王振宇强调，要深刻认识到贯彻落实中央八项规定精神，绝不是一阵风、走过场，而是一场必须打赢的持久战。要从警示教育案例中深刻汲取教训，全面把握风腐同源、互为表里的特征，以案为鉴、警钟长鸣。党员领导干部要带头转作风、强担当，以风清气正的政治生态保障改革发展。 下一步，集团将持续优化中心组学习模式，提升中心组学习整体质效，着力将中心组学习打造为干部素质提升和业务创新发展的重要引擎，为集团高质量发展注入持久动力。",
              picture:
                "/profile/upload/image/2024/12/10/6ec15a0e-c939-486c-a131-87451f981d9a.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 468,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-04-01 09:46:16",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:44:11",
              remark: null,
              id: 5301,
              menuId: 2017,
              title:
                "山西金控集团举办党委理论学习中心组深入贯彻中央八项规定精神学习教育读书班",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "3月27日至28日，山西金控集团举办党委理论学习中心组深入贯彻中央八项规定精神学习教育读书班，集团党委书记、董事长王振宇作开班讲话，集团党委班子成员、党委理论学习中心组扩大学习成员参加学习。 读书班采取领导领学、个人自学、交流研讨等形式，深入学习领会习近平总书记关于加强党的作风建设的重要论述，认真研读中央八项规定及其实施细则精神等，交流研讨深入、联系实际紧密、学用导向鲜明。 王振宇强调，在全党开展深入贯彻中央八项规定精神学习教育，是以习近平同志为核心的党中央作出的重大决策部署。要深入学习和领悟习近平总书记关于党的作风建设的重要论述，准确把握中央八项规定精神的核心和内涵，以更高标准、更严要求把中央八项规定及其实施细则精神融入工作职责中、落到行动上，为集团高质量发展提供坚强作风保障。 一是提高政治站位，深刻认识学习教育的重大意义。将落实中央八项规定及其实施细则精神作为检验政治忠诚的标准，从政治高度审视作风问题，确保党中央及省委决策部署在集团落地。深化对作风建设规律的认识，巩固“推动高质量发展从营造风清气正政治生态抓起”的共识，以过硬作风护航集团改革发展。 二是注重贯通融合，持续加固中央八项规定精神堤坝。将学习中央八项规定精神与学习习近平总书记关于党的建设、金融工作等重要论述及习近平文化思想相结合，原原本本学，领会精神实质，把握核心要义。把学习教育与省委巡视整改、防范金融风险等重点工作结合，作为密切联系群众的实际行动，推动八项规定精神化风成俗。 三是聚焦重点内容，推动学习教育走深走实。把握中央八项规定精神内涵，增强自我约束意识，将学习成果融入业务和管理。把握“四风”特点，正视、发现问题，剖析根源，精准纠治。坚持问题导向，有效运用纪检监察、审计等多方监督力量，整治作风顽疾，解决突出问题。以学习教育为契机，健全作风建设长效机制，提升集团管理水平。借助智慧党建“监督信箱”“心声论坛”等平台，收集群众诉求，以群众满意度检验整改成效。 王振宇要求，一要大兴调研之风，统筹安排调研计划，穿透基层摸实情、听民声、解难题；二要强化数字赋能，完善信息共享平台，有效利用数字化工具，加强沟通交流，从严规范文件报表报送机制，力戒官僚主义；三要严控经费支出，强化津补贴、公务接待等领域专项监督检查，筑牢合规管理防线；四要提升新闻宣传质效，坚持服务战略、服务经营、服务客户、赋能发展；五要厚植清廉根基，将文化建设深度融入中央八项规定精神落实，以文化涵养风清气正的政治生态。 大家一致表示，将以此次学习为起点，持续深化对中央八项规定精神的学习与贯彻，以优良的作风推动集团高质量发展，为服务我省经济社会发展贡献金控力量。",
              picture:
                "/profile/upload/image/2024/12/10/c0e76845-20e4-4f86-bb93-915ec9563fc6.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 467,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-03-28 20:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:38:19",
              remark: null,
              id: 5300,
              menuId: 2017,
              title:
                "以科技创新为笔 以网络安全为基 推动山西金控数字化转型迈出新步伐",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "数字科技部",
              content:
                "在数字化浪潮下，山西金控积极顺应金融行业发展趋势，将金融科技创新视为驱动自身发展的关键引擎，凭借 “技术赋能 + 安全筑基” 双轨并行的创新实践模式，全力探索数字化转型的有效路径。 技术赋能，新知识激发新潜能。截至目前山西金控组织全系统员工开展了十余场DEEPSEEK技术知识培训活动，内容涵盖了大语言模型应用、大模型技术原理、NLP中台构建、提示词工程、AI编程助手应用实践及知识库与RAG技术等多个领域。员工们全方位接触了行业前沿技术，激发创新思维，为集团在数字金融领域的探索提供了坚实的技术支撑。 安全筑基，强法规筑牢强防线。集团精心组织的信息安全培训中，全面覆盖了网络安全法、数据安全法、个人信息保护法、关键信息基础设施安全保护条例、网络数据安全条例等法律法规。通过专家对法规的深入剖析，结合实际案例分享实用防护措施，有效增强员工信息安全意识，为集团构建了安全防线，确保集团在数字化转型的道路上稳健前行。 山西金控集团将进一步探寻数据使用场景，持续提升数据聚合效能，全力推进客户服务综合管理平台与 CRM 系统建设，以数字化转型成果赋能，助力集团迈向高质量发展的新征程。",
              picture:
                "/profile/upload/image/2024/12/10/10e3b093-145e-447a-96f4-12a317ecafd7.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 466,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-03-28 12:00:00",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2025-04-01 09:37:01",
              remark: null,
              id: 5299,
              menuId: 2017,
              title: "山西再担保与晋商银行银担直连系统正式上线",
              subtitle: null,
              keywords: null,
              description: null,
              copyFrom: "党委宣传部",
              content:
                "3月26日，山西省融资再担保集团有限公司与晋商银行股份有限公司共同举办“银担直连业务系统”上线启动会，金控集团党委委员、副总经理刘振龙、晋商银行副行长王义斌分别致辞。山西再担保集团总经理蔡绍青、副总经理杨英文、晋商银行普惠金融部总经理王海洋、副总经理张晶出席活动。 银担直连业务系统的正式上线，是我省金融企业认真践行“金融五篇大文章”，以金融科技赋能高质量发展的应时之举，也是深入推动银担合作优化的有效措施，更标志着银担双方合力落实社会责任、协同促进实体经济发展跑进“新速度”。 启动仪式后，双方将针对原有系统的获客模式、业务审核、数据流转、担保备案等功能进行升级改造，运用多维论证、融合开发、联调联测等方式持续优化直连系统。未来将大幅简化小微、三农主体担保贷款业务办理流程，有效提高银担审批效率和风控能力，持续加强信贷供给精准度。山西再担保将携手晋商银行扎实推进资源共享，提升信息化合作效能，不断夯实业务质量，共同推动我省经济高质量发展。",
              picture:
                "/profile/upload/image/2024/12/10/435d0693-7918-43fb-b195-addac3bdb52c.png",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 465,
              isRecommend: 1,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2025-03-27 19:00:00",
              menuParentId: null,
              searchContent: null,
            },
          ],
          monitorList: [
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-01-14 11:15:32",
              remark: null,
              id: 4191,
              menuId: 2170,
              title: "漫说《中国共产党纪律处分条例》：弄假成真",
              subtitle: "",
              keywords: "",
              description:
                "纪律是我们党的生命线，加强纪律建设是全面从严治党的治本之策。为深入贯彻落实十九届中央纪委四次全会关于加强党纪国法教育的部署要求，强化党规党纪的学习宣传、贯彻执行，使铁的纪律真正转化为党员干部的日常习惯和自觉遵循，中央纪委国家监委网站联合河北省纪委监委，以漫画形式对《中国共产党纪律处分条例》进行解读。",
              copyFrom: "中央纪委国家监委网站",
              content:
                "纪律是我们党的生命线，加强纪律建设是全面从严治党的治本之策。为深入贯彻落实十九届中央纪委四次全会关于加强党纪国法教育的部署要求，强化党规党纪的学习宣传、贯彻执行，使铁的纪律真正转化为党员干部的日常习惯和自觉遵循，中央纪委国家监委网站联合河北省纪委监委，以漫画形式对《中国共产党纪律处分条例》进行解读。",
              picture:
                "https://boot-img.xuexi.cn/image/1004/process/c4fffc4ae1424d2d9778c11d3ac82e3e.jpg",
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "sxjk",
              inputTime: "2021-01-14 11:15:32",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-07-16 10:53:39",
              remark: null,
              id: 4161,
              menuId: 2165,
              title: "中共中央关于加强党的政治建设的意见",
              subtitle: "",
              keywords: "",
              description:
                "（2019年1月31日） 为深入贯彻落实习近平新时代中国特色社会主义思想和党的十九大精神，切实加强党的政治建设，坚持和加强党的全面领导，推进全面从严治党向纵深发展，不断提高党的执政能力和领导水平，确保全党统一意志、统一行动、步调一致向前进，现提出如下意见。　　一、加强党的政治建设的总体要求　　旗帜鲜明讲政治是我们党作为马克思主义政党的根本要求。党的政治建设是党的根本性建设，决定党的建设方向和效果，事关统揽...",
              copyFrom: "",
              content:
                "（2019年1月31日） 为深入贯彻落实习近平新时代中国特色社会主义思想和党的十九大精神，切实加强党的政治建设，坚持和加强党的全面领导，推进全面从严治党向纵深发展，不断提高党的执政能力和领导水平，确保全党统一意志、统一行动、步调一致向前进，现提出如下意见。 　　一、加强党的政治建设的总体要求 　　旗帜鲜明讲政治是我们党作为马克思主义政党的根本要求。党的政治建设是党的根本性建设，决定党的建设方向和效果，事关统揽推进伟大斗争、伟大工程、伟大事业、伟大梦想。 　　在革命、建设、改革各个时期，我们党都高度重视党的政治建设，形成了讲政治的优良传统。党的十八大以来，以习近平同志为核心的党中央把党的政治建设摆在更加突出位置，加大力度抓，形成了鲜明的政治导向，消除了党内严重政治隐患，推动党的政治建设取得重大历史性成就。同时，必须清醒看到，党内存在的政治问题还没有得到根本解决，一些党组织和党员干部忽视政治、淡化政治、不讲政治的问题还比较突出，有的甚至存在偏离中国特色社会主义方向的严重问题。切实有效解决这些问题，必须进一步加强党的政治建设。 　　加强党的政治建设，必须高举中国特色社会主义伟大旗帜，全面贯彻党的十九大精神，坚持以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，坚持党的基本理论、基本路线、基本方略，落实新时代党的建设总要求，增强“四个意识”，坚定“四个自信”，坚决维护习近平总书记党中央的核心、全党的核心地位，坚决维护党中央权威和集中统一领导，把准政治方向，坚持党的政治领导，夯实政治根基，涵养政治生态，防范政治风险，永葆政治本色，提高政治能力，把我们党建设得更加坚强有力，确保我们党始终成为中国特色社会主义事业的坚强领导核心，为实现“两个一百年”奋斗目标和中华民族伟大复兴的中国梦提供坚强政治保证。 　　加强党的政治建设，目的是坚定政治信仰，强化政治领导，提高政治能力，净化政治生态，实现全党团结统一、行动一致。要以党章为根本遵循，把党章明确的党的性质和宗旨、指导思想和奋斗目标、路线和纲领落到实处。要突显党的政治建设的根本性地位，聚焦党的政治属性、政治使命、政治目标、政治追求持续发力。要以党的政治建设为统领，把政治标准和政治要求贯穿党的思想建设、组织建设、作风建设、纪律建设以及制度建设、反腐败斗争始终，以政治上的加强推动全面从严治党向纵深发展，引领带动党的建设质量全面提高。要坚持问题导向，注重“靶向治疗”，针对政治意识不强、政治立场不稳、政治能力不足、政治行为不端等突出问题强弱项补短板。要把党的政治建设融入党和国家重大决策部署的制定和落实全过程，做到党的政治建设与各项业务工作特别是中心工作紧密结合、相互促进。 　　二、坚定政治信仰 　　加强党的政治建设，必须坚持马克思主义指导地位，坚持用习近平新时代中国特色社会主义思想武装全党、教育人民，夯实思想根基，牢记初心使命，凝聚同心共筑中国梦的磅礴力量。 　　（一）坚持用党的科学理论武装头脑 　　马克思主义是我们立党立国的根本指导思想。习近平新时代中国特色社会主义思想是当代中国马克思主义、21世纪马克思主义，是全党全国人民为实现中华民族伟大复兴而奋斗的行动指南，是经过实践检验、富有实践伟力的强大思想武器，必须长期坚持并不断发展。要深入学习习近平新时代中国特色社会主义思想，加强思想政治教育，推动学习教育往深里走、往心里走、往实里走，真正做到学深悟透、融会贯通、真信笃行，巩固全党全国人民团结奋斗的共同思想基础。要坚定理想信念，牢固树立共产主义远大理想和中国特色社会主义共同理想，挺起共产党人的精神脊梁，坚决防止不信马列信鬼神、不信真理信金钱，坚决反对各种歪曲、篡改、否定马克思主义的错误思想。要坚定“四个自信”，坚信中国特色社会主义是科学社会主义理论逻辑和中国社会发展历史逻辑的辩证统一，是当代中国发展进步的根本方向，是全面建成小康社会、全面建成社会主义现代化强国、实现中华民族伟大复兴的必由之路。领导干部要带头学理论、强信念，筑牢信仰之基，补足精神之钙，把稳思想之舵。实施年轻干部理想信念宗旨教育计划，大力培养造就具有坚定共产主义信仰和较高马克思主义理论素养的社会主义建设者和接班人。 　　（二）坚定执行党的政治路线 　　党在社会主义初级阶段的基本路线作为党的政治路线，是党和国家的生命线、人民的幸福线，必须坚决捍卫、坚定执行。越是面临严峻复杂的国际国内形势，越是处于中华民族伟大复兴的关键时期，越要保持清醒头脑和战略定力，全面贯彻执行党的政治路线，把以经济建设为中心同坚持四项基本原则、坚持改革开放两个基本点统一于中国特色社会主义伟大实践，绝不能有丝毫偏离和动摇。坚持党的政治路线，必须全面贯彻实施新时代中国特色社会主义基本方略，统筹推进“五位一体”总体布局和协调推进“四个全面”战略布局，为实现“两个一百年”奋斗目标不懈努力。全党制定执行大政方针，要从党的政治路线出发；部署推进党和国家事业发展重大战略、重大任务、重大工作，要紧紧围绕党的政治路线来进行。各地区各部门确定工作思路、工作部署、政策措施，要自觉同党的政治路线对标对表、及时校准偏差。要坚决同一切违背、歪曲、否定党的政治路线的言行作斗争。 　　（三）坚决站稳政治立场 　　政治立场事关根本。全党必须始终坚定马克思主义立场，坚持党性和人民性相统一，坚决站稳党性立场和人民立场。要坚持以党的旗帜为旗帜、以党的方向为方向、以党的意志为意志，始终做到在党言党、在党忧党、在党为党，任何时候都同党同心同德。要坚持以人民为中心，立党为公、执政为民，践行全心全意为人民服务的根本宗旨，树立真挚的人民情怀，把人民放在心中最高位置，始终相信人民，紧紧依靠人民，把人民对美好生活的向往作为奋斗目标。要把对党负责和对人民负责高度统一起来，想问题、作决策、办事情都从人民利益出发，崇尚实干、勤政为民，把精力和心思用在稳增长、促改革、调结构、惠民生、防风险、保稳定上，着力解决人民群众最关心最直接最现实的利益问题，努力让人民群众有更多获得感、幸福感、安全感。 　　三、坚持党的政治领导 　　党是最高政治领导力量，党的领导是中国特色社会主义最本质的特征，是中国特色社会主义制度的最大优势。加强党的政治建设，必须坚持和加强党的全面领导，完善党的领导体制，改进党的领导方式，承担起执政兴国的政治责任。 　　（四）坚决做到“两个维护” 　　事在四方，要在中央。坚持和加强党的全面领导，最重要的是坚决维护党中央权威和集中统一领导；坚决维护党中央权威和集中统一领导，最关键的是坚决维护习近平总书记党中央的核心、全党的核心地位。要教育引导党员干部从历史和现实、理论和实践、国内和国际的结合上深刻认识、强化认同，不断增强拥护核心、跟随核心、捍卫核心的思想自觉政治自觉行动自觉，始终同以习近平同志为核心的党中央保持高度一致，做到党中央提倡的坚决响应、党中央决定的坚决执行、党中央禁止的坚决不做。要以党章为根本依据，不断完善保障“两个维护”的制度机制，严格执行《关于新形势下党内政治生活的若干准则》、《中国共产党重大事项请示报告条例》、《中共中央政治局关于加强和维护党中央集中统一领导的若干规定》等党内法规，加强对贯彻执行党的路线方针政策和决议情况的督促检查，完善党中央重大决策部署和习近平总书记重要指示批示贯彻落实的督查问责机制。要以正确的认识、正确的行动坚决做到“两个维护”，坚决防止和纠正一切偏离“两个维护”的错误言行，不得搞任何形式的“低级红”、“高级黑”，决不允许对党中央阳奉阴违做两面人、搞两面派、搞“伪忠诚”。 　　（五）完善党的领导体制 　　坚持党总揽全局、协调各方，建立健全坚持和加强党的全面领导的制度体系，为把党的领导落实到改革发展稳定、内政外交国防、治党治国治军各领域各方面各环节提供坚实制度保障。研究制定党领导经济社会各方面重要工作的党内法规。健全党中央集中统一领导重大工作的体制机制。完善地方党委、党组、党的工作机关实施党的领导的体制机制。建立健全国有企业党委（党组）和农村、事业单位、街道社区等的基层党组织发挥领导作用的制度规定。贯彻落实宪法规定，制定和修改有关法律法规要明确规定党领导相关工作的法律地位。将坚持党的全面领导的要求载入人大、政府、法院、检察院的组织法，载入政协、民主党派、工商联、人民团体、国有企业、高等学校、有关社会组织等的章程，健全党对这些组织实施领导的制度规定，确保其始终在党的领导下积极主动、独立负责、协调一致地开展工作。 　　（六）改进党的领导方式 　　着眼于党把方向、谋大局、定政策、促改革，强化战略思维、创新思维、辩证思维、法治思维、底线思维，正确制定和坚决执行党的路线方针政策，不断增强党的政治领导力、思想引领力、群众组织力、社会号召力。要坚持民主集中制这一根本领导制度，善于运用民主的办法汇集意见、科学决策，善于通过协商的方式增进共识、凝聚力量，同时善于集中、敢于担责，防止议而不决、决而不行。要坚持群众路线这一基本领导方法，不断增强群众工作本领，大兴调查研究之风，改进和创新联系群众的途径方法，坚持走好网上群众路线，汇集民智民力，善于通过群众喜闻乐见方式宣传党的理论和路线方针政策，把党的主张变为群众自觉行动。坚决反对“四风”特别是形式主义、官僚主义。要坚持依法执政这一基本领导方式，注重运用法治思维和法治方式治国理政，善于使党的主张通过法定程序成为国家意志、转化为法律法规，自觉把党的领导活动纳入制度轨道。 　　四、提高政治能力 　　加强党的政治建设，关键是要提高各级各类组织和党员干部的政治能力。必须进一步增强党组织政治功能，彰显国家机关政治属性，发挥群团组织政治作用，强化国有企事业单位政治导向，不断提高党员干部特别是领导干部政治本领。 　　（七）增强党组织政治功能 　　党的力量来自组织。政治属性是党组织的根本属性，政治功能是党组织的基本功能，要认真贯彻落实新时代党的组织路线，不断强化各级各类党组织的政治属性和政治功能。党中央是党的最高领导机关，是党的组织体系的大脑和中枢，对党和国家事业发展重大工作实行集中统一领导，涉及全党全国性的重大方针政策问题只能由党中央作出决定和解释。地方党委要在党中央和上级党委领导下，全面领导本地区经济社会发展，全面负责本地区党的建设，坚决纠正党的领导弱化、党的建设缺失、全面从严治党不力问题。党的基层组织要着力提升组织力，突出政治功能、强化政治引领，下大气力解决软弱涣散问题。党支部要担负起直接教育党员、管理党员、监督党员和组织群众、宣传群众、凝聚群众、服务群众的职责，发挥好战斗堡垒作用。党组要在批准其设立的党组织领导下，在本部门本单位发挥好把方向、管大局、保落实的重要作用，确保党中央和上级党组织决策部署在本部门本单位贯彻落实。党的各级纪委要进一步强化党内监督专责机关的职能定位，全面监督执纪问责，坚决维护党章党规党纪的严肃性和权威性。党的工作机关要更好发挥党委参谋助手作用，提高履职尽责的政治性和有效性，力求参当其时、谋当其用，更好服务党委决策、抓好决策落实。党员要强化党的意识和组织观念，自觉做到思想上认同组织、政治上依靠组织、工作上服从组织、感情上信赖组织。所有党组织和全体党员都必须牢固树立一盘棋意识，在党中央集中统一领导下齐心协力、步调一致开展工作，形成党的组织体系整体合力。 　　（八）彰显国家机关政治属性 　　中央和地方各级人大机关、行政机关、政协机关、监察机关、审判机关、检察机关本质上都是政治机关，旗帜鲜明讲政治是应尽之责。要始终坚持在党的领导下依法实施经济社会管理活动，坚决贯彻落实党的基本理论、基本路线、基本方略，积极主动将党的领导主张和重大决策部署转化为法律法规和政策政令，转化为对经济社会管理的部署安排和工作活动，转化为领导体制、工作机制和管理方式方法创新，转化为推动经济社会发展的实际效果。国家机关履行职责、开展工作，要提高政治站位，把准政治方向，注重政治效果，考虑政治影响，坚决防止和纠正把政治与业务割裂开来、对立起来的错误认识和做法，确保政治和业务融为一体、高度统一。 　　（九）发挥群团组织政治作用 　　工会、共青团、妇联等群团组织是党领导下的政治组织，政治性是群团组织的灵魂。各群团组织要认真履行政治职责，充分发挥联系人民群众的桥梁和纽带作用，加大政治动员、政治引领、政治教育工作力度，更好承担起引导群众听党话、跟党走的政治任务，把自己联系的群众最广泛最紧密地团结在党的周围。要坚定不移坚持党的领导，坚定不移走中国特色社会主义群团发展道路，不折不扣落实党中央关于群团改革的决策部署，切实增强群团组织的政治性、先进性、群众性。 　　（十）强化国有企事业单位政治导向 　　国有企业是中国特色社会主义的重要物质基础和政治基础，事业单位承担着满足人民群众日益增长的公益服务需求职责，都是我们党执政兴国的重要依靠力量。国有企事业单位必须始终坚持党的领导，坚决贯彻执行党的路线方针政策，认真落实党中央关于推进国有企事业单位改革发展的决策部署，切实加强本单位党的建设工作，充分发挥党组织重要作用，保证本单位工作坚持正确政治方向、取得良好政治效果。 　　（十一）提高党员干部政治本领 　　党员干部特别是领导干部要加强政治能力训练和政治实践历练，切实提高把握方向、把握大势、把握全局的能力和辨别政治是非、保持政治定力、驾驭政治局面、防范政治风险的能力。要在大是大非面前态度鲜明、立场坚定，始终在政治立场、政治方向、政治原则、政治道路上同以习近平同志为核心的党中央保持高度一致。要善于从政治上研判形势、分析问题，自觉在党和国家工作大局下想问题、做工作，做到一切服从大局、一切服务大局。要强化忧患意识、风险意识，增强政治敏锐性和政治鉴别力，对容易诱发政治问题特别是重大突发事件的敏感因素、苗头性倾向性问题，对意识形态领域各种错误思潮、模糊认识、不良现象，保持高度警惕，做到眼睛亮、见事早、行动快。要提高风险处置能力，及时阻断不同领域风险转换通道，防止非公共性风险扩大为公共性风险、非政治性风险演变为政治风险。要增强斗争精神，强化政治担当，敢于亮剑、善于斗争，发现违反政治纪律、危害政治安全的行为坚决抵制，做勇于斗争的“战士”，不做爱惜羽毛的“绅士”，严防对挑战政治底线的错误言论和不良风气听之任之、逃避责任、失职失察。 　　五、净化政治生态 　　加强党的政治建设，必须把营造风清气正的政治生态作为基础性、经常性工作，浚其源、涵其林，养正气、固根本，锲而不舍、久久为功，实现正气充盈、政治清明。 　　（十二）严肃党内政治生活 　　营造良好政治生态，必须严格执行《关于新形势下党内政治生活的若干准则》，着力提高党内政治生活质量，努力在全党形成又有集中又有民主、又有纪律又有自由、又有统一意志又有个人心情舒畅生动活泼的政治局面。增强党内政治生活的政治性，强化政治教育和政治引领，让党员干部经常接受政治体检，打扫政治灰尘，净化政治灵魂，增强政治免疫力，坚决防止和克服党内政治生活忽视政治、淡化政治、不讲政治的倾向。增强党内政治生活的时代性，主动适应信息时代新形势和党员队伍新变化，积极运用互联网、大数据等新兴技术，创新党组织活动内容方式，推进“智慧党建”，使党内政治生活始终充满活力，坚决防止和克服党内政治生活不讲创新、不讲活力、照搬照套的倾向。增强党内政治生活的原则性，坚持按原则开展党的工作和活动，按原则处理党内各种关系，按原则解决党内矛盾和问题，严格执行党的组织生活制度，认真召开民主生活会和组织生活会，提高“三会一课”质量，落实谈心谈话、民主评议党员和主题党日等制度，坚持和完善重温入党誓词、党员过“政治生日”等政治仪式，使党内生活庄重、严肃、规范，坚决防止和克服党内政治生活不讲原则、平淡化庸俗化随意化的倾向。增强党内政治生活的战斗性，坚持以整风精神开展批评和自我批评，勇于思想交锋、揭短亮丑，旗帜鲜明坚持真理、修正错误，统一意志、增进团结，建立健全民主生活会列席指导、及时叫停、责令重开、整改通报等制度，坚决防止和克服党内政治生活一团和气、评功摆好、明哲保身的倾向。 　　（十三）严明党的政治纪律和政治规矩 　　政治纪律是党最根本、最重要的纪律，是净化政治生态的重要保证。要把坚决做到“两个维护”作为首要政治纪律，在全党持续深入开展忠诚教育，开展“守纪律、讲规矩”模范机关创建和先进个人评选活动，教育督促党员干部始终对党忠诚老实，决不允许在重大政治原则问题上、大是大非问题上同党中央唱反调，搞自由主义。严格执行《中国共产党纪律处分条例》，严肃查处违反政治纪律的行为，通过严明政治纪律带动党的其他纪律严起来。坚持“五个必须”，必须维护党中央权威，决不允许背离党中央要求另搞一套；必须维护党的团结，决不允许在党内培植个人势力；必须遵循组织程序，决不允许擅作主张、我行我素；必须服从组织决定，决不允许搞非组织活动；必须管好领导干部亲属和身边工作人员，决不允许他们擅权干政、谋取私利。严肃查处“七个有之”问题，把政治上蜕变的两面人及时辨别出来、清除出去，坚决防止党内形成利益集团攫取政治权力、改变党的性质，坚决防止山头主义和宗派主义危害党的团结、破坏党的集中统一。 　　（十四）发展积极健康的党内政治文化 　　营造良好政治生态，离不开党内政治文化的浸润滋养。坚持“三严三实”，大力弘扬忠诚老实、公道正派、实事求是、清正廉洁等价值观，充分利用各类爱国主义教育基地和党性教育基地对广大党员干部进行教育和熏陶，增强党员干部的政治定力、纪律定力、道德定力、拒腐定力。大力倡导清清爽爽的同志关系、规规矩矩的上下级关系、干干净净的政商关系，弘扬正气、树立新风。推动中华优秀传统文化创造性转化、创新性发展，培育党员干部政治气节、政治风骨。发扬革命文化，传承红色基因，弘扬革命精神，教育党员干部正确处理公和私、义和利、是和非、正和邪、苦和乐的关系。弘扬社会主义先进文化，推进社会主义核心价值观宣传教育，引导党员干部带头做社会主义核心价值观的坚定信仰者、积极传播者、模范践行者。坚决抵制庸俗腐朽的政治文化，自觉抵制商品交换原则对党内生活的侵蚀，狠刹权权交易、权钱交易、权色交易等不正之风，破除关系学、厚黑学、官场术等封建糟粕，坚决防止和反对个人主义、分散主义、自由主义、本位主义、好人主义，坚决防止和反对宗派主义、圈子文化、码头文化。 　　（十五）突出政治标准选人用人 　　选人用人是政治生态的风向标。要坚持党管干部原则，贯彻新时期好干部标准，始终把政治标准放在第一位，注重选拔任用牢固树立“四个意识”、自觉坚定“四个自信”、坚决做到“两个维护”、全面贯彻执行党的理论和路线方针政策、忠诚干净担当的干部，对政治不合格的干部实行“一票否决”，已经在领导岗位的坚决调整。严格执行《党政领导干部选拔任用工作条例》，在选人用人中进一步突出政治标准，强化政治把关。制定实施《党政领导干部考核工作条例》，建立健全领导干部政治素质识别和评价机制，强化对干部政治忠诚、政治定力、政治担当、政治能力、政治自律等方面的深入考察考核，坚决把政治上的两面人挡在门外。匡正选人用人风气，坚持不懈整治选人用人上的不正之风，对任人唯亲、说情打招呼、跑官要官、买官卖官、拉票贿选等行为发现一起查处一起，对“带病提拔”的干部实行倒查，对政治标准把关不严的严肃处理。严格执行干部选拔任用工作纪实制度，对私自干预下级或者原任职地方和单位选人用人的，记录在案并严肃追究责任。 　　（十六）永葆清正廉洁的政治本色 　　坚决反对腐败，建设廉洁政治，是涵养政治生态的必要条件和重要任务。强化不敢腐的震慑，坚持反腐败无禁区、全覆盖、零容忍，坚持重遏制、强高压、长震慑，运用监督执纪“四种形态”，重点查处党的十八大以来不收敛、不收手，问题线索反映集中、群众反映强烈，政治问题和经济问题交织的腐败案件，严肃查处违反中央八项规定精神的问题，持续保持反腐败高压态势。扎紧不能腐的笼子，健全党和国家监督体系，加强对权力运行的制约和监督，通过改革和制度创新切断利益输送链条。特别要针对管人管钱管物管项目的单位和岗位，查找廉政风险点，通过科学管理、严格监督和发挥巡视利剑作用，切实管住权力，坚决反对特权行为和特权现象，让人民群众真正感受到清正干部、清廉政府、清明政治就在身边。增强不想腐的自觉，领导干部特别是高级干部要带头加强党性修养，知敬畏、存戒惧、守底线，坚决防范被利益集团“围猎”，持之以恒锤炼政德，明大德、守公德、严私德，带头遵守《中国共产党廉洁自律准则》，注重家庭家教家风，自觉做廉洁自律、廉洁用权、廉洁齐家的模范。 　　六、强化组织实施 　　加强党的政治建设是一项重大艰巨的政治任务。各地区各部门要进一步增强推进党的政治建设的自觉性坚定性，把思想和行动统一到党中央部署要求上来，加强组织领导、强化责任担当，确保本意见提出的各项举措落到实处，确保党的政治建设取得成效。 　　（十七）落实领导责任 　　建立健全推进党的政治建设工作责任制，各级党委（党组）要切实负起本地区本部门党的政治建设工作主体责任，将其纳入党委（党组）工作总体布局，摆在首要位置来抓，认真研究部署、大力推进落实。党委（党组）书记要认真履行第一责任人职责，对党的政治建设重要工作亲自部署、重要问题亲自过问、重大事件亲自处置。党委（党组）其他成员要根据职责分工，按照“一岗双责”要求，抓好分管部门和领域党的政治建设工作。各级党的建设工作领导小组要发挥统筹协调的职能作用，各级纪检监察机关和党委有关部门要各司其职、各负其责，履行推进党的政治建设工作相关职责。中央和国家机关要在推进党的政治建设上带好头、作示范，在深入学习贯彻习近平新时代中国特色社会主义思想上作表率，在始终同党中央保持高度一致上作表率，在坚决贯彻落实党中央决策部署上作表率，建设让党中央放心、让人民群众满意的模范机关。 　　（十八）抓住“关键少数” 　　加强党的政治建设，要坚持抓“关键少数”和管“绝大多数”相结合，重点是抓住领导机关和领导干部，发挥其示范引领作用。各级领导干部特别是高级干部要深刻认识自己在加强党的政治建设中的特殊重要性和肩负的重大责任，职位越高越要自觉严格要求自己，注重加强政治历练、积累政治经验、增进政治智慧，做到信念如磐、意志如铁，政治坚定、绝对忠诚，清正廉洁、担当负责，坚决做到“两个维护”，成为坚定的马克思主义者。实施“一把手”政治能力提升计划。 　　（十九）强化制度保障 　　加强党的政治建设，要把建章立制贯穿全过程各方面，建立健全长效机制，形成系统完备、有效管用的政治规范体系，真正实现党的政治建设有章可循、有据可依。坚持集成联动，完善党内法规制度体系有关制度，健全国家法律体系有关规定，在各类章程中明确提出有关要求，做到相辅相成、有机统一。坚持明确标准，既提出政治高线，激励党员干部向往践行，又划出政治底线，防止党员干部逾矩失范。坚持执规必严，加大宣传教育和执行力度，督促党员干部把党的政治规范刻印在心上、落实在行动上，坚决维护制度权威。 　　（二十）加强监督问责 　　各地区各部门要加强对党的政治建设工作的监督检查，将其作为巡视巡察和督查检查的重要内容，深化政治巡视，强化政治监督，着力发现和纠正政治偏差。探索建立本地区本部门政治生态评价体系。把党的政治建设工作情况纳入党委（党组）书记抓党建述职评议和党建考核评价体系，并突出其权重。坚持失责必问、问责必严，对落实党的政治建设责任不到位、推进党的政治建设工作不力以及违反党的政治纪律和政治规矩的行为严肃追责问责。 　　各地区各部门要紧密结合自身实际制定贯彻实施本意见的具体措施。中央军委可以根据本意见提出加强军队党的政治建设的具体意见。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-07-16 10:53:39",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-07-16 10:52:24",
              remark: null,
              id: 4160,
              menuId: 2165,
              title: "关于实行党风廉政建设责任制的规定",
              subtitle: "",
              keywords: "",
              description:
                "（2010年11月10日）第一章　总　则　　第一条　为了加强党风廉政建设，明确领导班子、领导干部在党风廉政建设中的责任，推动科学发展，促进社会和谐，提高党的执政能力，保持和发展党的先进性，根据《中华人民共和国宪法》和《中国共产党章程》，制定本规定。　　第二条　本规定适用于各级党的机关、人大机关、行政机关、政协机关、审判机关、检察机关的领导班子、领导干部。　　人民团体、国有和国有控股企业（含国有和国有控股金...",
              copyFrom: "",
              content:
                "（2010年11月10日） 第一章　总　则 　　第一条　为了加强党风廉政建设，明确领导班子、领导干部在党风廉政建设中的责任，推动科学发展，促进社会和谐，提高党的执政能力，保持和发展党的先进性，根据《中华人民共和国宪法》和《中国共产党章程》，制定本规定。 　　第二条　本规定适用于各级党的机关、人大机关、行政机关、政协机关、审判机关、检察机关的领导班子、领导干部。 　　人民团体、国有和国有控股企业（含国有和国有控股金融企业）、事业单位的领导班子、领导干部参照执行本规定。 　　第三条　实行党风廉政建设责任制，要以邓小平理论和“三个代表”重要思想为指导，深入贯彻落实科学发展观，坚持党要管党、从严治党，坚持标本兼治、综合治理、惩防并举、注重预防，扎实推进惩治和预防腐败体系建设，保证党中央、国务院关于党风廉政建设的决策和部署的贯彻落实。 　　第四条　实行党风廉政建设责任制，要坚持党委统一领导，党政齐抓共管，纪委组织协调，部门各负其责，依靠群众的支持和参与。要把党风廉政建设作为党的建设和政权建设的重要内容，纳入领导班子、领导干部目标管理，与经济建设、政治建设、文化建设、社会建设以及生态文明建设和业务工作紧密结合，一起部署，一起落实，一起检查，一起考核。 　　第五条　实行党风廉政建设责任制，要坚持集体领导与个人分工负责相结合，谁主管、谁负责，一级抓一级、层层抓落实。 第二章　责任内容 　　第六条　领导班子对职责范围内的党风廉政建设负全面领导责任。 　　领导班子主要负责人是职责范围内的党风廉政建设第一责任人，应当重要工作亲自部署、重大问题亲自过问、重点环节亲自协调、重要案件亲自督办。 　　领导班子其他成员根据工作分工，对职责范围内的党风廉政建设负主要领导责任。 　　第七条　领导班子、领导干部在党风廉政建设中承担以下领导责任： 　　（一）贯彻落实党中央、国务院以及上级党委（党组）、政府和纪检监察机关关于党风廉政建设的部署和要求，结合实际研究制定党风廉政建设工作计划、目标要求和具体措施，每年召开专题研究党风廉政建设的党委常委会议（党组会议）和政府廉政建设工作会议，对党风廉政建设工作任务进行责任分解，明确领导班子、领导干部在党风廉政建设中的职责和任务分工，并按照计划推动落实； 　　（二）开展党性党风党纪和廉洁从政教育，组织党员、干部学习党风廉政建设理论和法规制度，加强廉政文化建设； 　　（三）贯彻落实党风廉政法规制度，推进制度创新，深化体制机制改革，从源头上预防和治理腐败； 　　（四）强化权力制约和监督，建立健全决策权、执行权、监督权既相互制约又相互协调的权力结构和运行机制，推进权力运行程序化和公开透明； 　　（五）监督检查本地区、本部门、本系统的党风廉政建设情况和下级领导班子、领导干部廉洁从政情况； 　　（六）严格按照规定选拔任用干部，防止和纠正选人用人上的不正之风； 　　（七）加强作风建设，纠正损害群众利益的不正之风，切实解决党风政风方面存在的突出问题； 　　（八）领导、组织并支持执纪执法机关依纪依法履行职责，及时听取工作汇报，切实解决重大问题。 第三章　检查考核与监督 　　第八条　党委（党组）应当建立党风廉政建设责任制的检查考核制度，建立健全检查考核机制，制定检查考核的评价标准、指标体系，明确检查考核的内容、方法、程序。 　　第九条　党委（党组）应当建立健全党风廉政建设责任制领导小组，负责对下一级领导班子、领导干部党风廉政建设责任制执行情况的检查考核。 　　第十条　检查考核工作每年进行一次。检查考核可以与领导班子、领导干部工作目标考核、年度考核、惩治和预防腐败体系建设检查工作等结合进行，也可以组织专门检查考核。 　　检查考核情况应当及时向同级党委（党组）报告。 　　第十一条　党委（党组）应当将检查考核情况在适当范围内通报。对检查考核中发现的问题，要及时研究解决，督促整改落实。 　　第十二条　党委（党组）应当建立和完善检查考核结果运用制度。检查考核结果作为对领导班子总体评价和领导干部业绩评定、奖励惩处、选拔任用的重要依据。 　　第十三条　纪检监察机关（机构）、组织人事部门协助同级党委（党组）开展对党风廉政建设责任制执行情况的检查考核,或者根据职责开展检查工作。 　　第十四条　党委常委会应当将执行党风廉政建设责任制的情况，作为向同级党的委员会全体会议报告工作的一项重要内容。 　　第十五条　领导干部执行党风廉政建设责任制的情况，应当列为民主生活会和述职述廉的重要内容，并在本单位、本部门进行评议。 　　第十六条　党委（党组）应当将贯彻落实党风廉政建设责任制的情况，每年专题报告上一级党委（党组）和纪委。 　　第十七条　中央和省、自治区、直辖市党委巡视组应当依照巡视工作的有关规定，加强对有关党组织领导班子及其成员执行党风廉政建设责任制情况的巡视监督。 　　第十八条　党委（党组）应当结合本地区、本部门、本系统实际，建立走访座谈、社会问卷调查等党风廉政建设社会评价机制，动员和组织党员、群众有序参与，广泛接受监督。 第四章　责任追究 　　第十九条　领导班子、领导干部违反或者未能正确履行本规定第七条规定的职责，有下列情形之一的，应当追究责任： 　　（一）对党风廉政建设工作领导不力，以致职责范围内明令禁止的不正之风得不到有效治理，造成不良影响的； 　　（二）对上级领导机关交办的党风廉政建设责任范围内的事项不传达贯彻、不安排部署、不督促落实，或者拒不办理的； 　　（三）对本地区、本部门、本系统发现的严重违纪违法行为隐瞒不报、压案不查的； 　　（四）疏于监督管理，致使领导班子成员或者直接管辖的下属发生严重违纪违法问题的； 　　（五）违反规定选拔任用干部，或者用人失察、失误造成恶劣影响的； 　　（六）放任、包庇、纵容下属人员违反财政、金融、税务、审计、统计等法律法规，弄虚作假的； 　　（七）有其他违反党风廉政建设责任制行为的。 　　第二十条　领导班子有本规定第十九条所列情形，情节较轻的，责令作出书面检查；情节较重的，给予通报批评；情节严重的，进行调整处理。 　　第二十一条　领导干部有本规定第十九条所列情形，情节较轻的，给予批评教育、诫勉谈话、责令作出书面检查；情节较重的，给予通报批评；情节严重的，给予党纪政纪处分，或者给予调整职务、责令辞职、免职和降职等组织处理。涉嫌犯罪的，移送司法机关依法处理。 　　以上责任追究方式可以单独使用，也可以合并使用。 　　第二十二条　领导班子、领导干部具有本规定第十九条所列情形，并具有下列情节之一的，应当从重追究责任： 　　（一）对职责范围内发生的问题进行掩盖、袒护的； 　　（二）干扰、阻碍责任追究调查处理的。 　　第二十三条　领导班子、领导干部具有本规定第十九条所列情形，并具有下列情节之一的，可以从轻或者减轻追究责任： 　　（一）对职责范围内发生的问题及时如实报告并主动查处和纠正，有效避免损失或者挽回影响的； 　　（二）认真整改，成效明显的。 　　第二十四条　领导班子、领导干部违反本规定，需要查明事实、追究责任的，由有关机关或者部门按照职责和权限调查处理。其中需要追究党纪政纪责任的，由纪检监察机关按照党纪政纪案件的调查处理程序办理；需要给予组织处理的，由组织人事部门或者由负责调查的纪检监察机关会同组织人事部门，按照有关权限和程序办理。 　　第二十五条　实施责任追究，要实事求是，分清集体责任和个人责任、主要领导责任和重要领导责任。 　　追究集体责任时，领导班子主要负责人和直接主管的领导班子成员承担主要领导责任，参与决策的班子其他成员承担重要领导责任。对错误决策提出明确反对意见而没有被采纳的，不承担领导责任。 　　错误决策由领导干部个人决定或者批准的，追究该领导干部个人的责任。 　　第二十六条　实施责任追究不因领导干部工作岗位或者职务的变动而免予追究。已退休但按照本规定应当追究责任的，仍须进行相应的责任追究。 　　第二十七条　受到责任追究的领导班子、领导干部，取消当年年度考核评优和评选各类先进的资格。 　　单独受到责令辞职、免职处理的领导干部，一年内不得重新担任与其原任职务相当的领导职务；受到降职处理的，两年内不得提升职务。同时受到党纪政纪处分和组织处理的，按影响期较长的执行。 　　第二十八条　各级纪检监察机关应当加强对下级党委（党组）、政府实施责任追究情况的监督检查，发现有应当追究而未追究或者责任追究处理决定不落实等问题的，应当及时督促下级党委（党组）、政府予以纠正。 第五章　附　则 　　第二十九条　各省、自治区、直辖市，中央和国家机关各部委可以根据本规定制定实施办法。 　　第三十条　中央军委可以根据本规定，结合中国人民解放军和中国人民武装警察部队的实际情况，制定具体规定。 　　第三十一条　本规定由中央纪委、监察部负责解释。 　　第三十二条　本规定自发布之日起施行。1998年11月发布的《关于实行党风廉政建设责任制的规定》同时废止。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-07-16 10:52:24",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-07-16 10:51:28",
              remark: null,
              id: 4159,
              menuId: 2165,
              title: "关于领导干部报告个人有关事项的规定",
              subtitle: "",
              keywords: "",
              description:
                "（2010年5月26日）　　第一条　为加强对领导干部的管理和监督，促进领导干部廉洁从政，根据《中国共产党章程》、党内有关规定和国家有关法律法规，制定本规定。　　第二条　本规定所称领导干部包括：　　（一）各级党的机关、人大机关、行政机关、政协机关、审判机关、检察机关、民主党派机关中县处级副职以上（含县处级副职，下同）的干部；　　（二）人民团体、事业单位中相当于县处级副职以上的干部；　　（三）大型、特大型国有...",
              copyFrom: "",
              content:
                '（2010年5月26日） 　　第一条　为加强对领导干部的管理和监督，促进领导干部廉洁从政，根据《中国共产党章程》、党内有关规定和国家有关法律法规，制定本规定。 　　第二条　本规定所称领导干部包括： 　　（一）各级党的机关、人大机关、行政机关、政协机关、审判机关、检察机关、民主党派机关中县处级副职以上（含县处级副职，下同）的干部； 　　（二）人民团体、事业单位中相当于县处级副职以上的干部； 　　（三）大型、特大型国有独资企业、国有控股企业（含国有独资金融企业和国有控股金融企业）的中层以上领导人员和中型国有独资企业、国有控股企业（含国有独资金融企业和国有控股金融企业）的领导班子成员。 　　副调研员以上非领导职务的干部和已退出现职、但尚未办理退（离）休手续的干部报告个人有关事项，适用本规定。 　　第三条　领导干部应当报告下列本人婚姻变化和配偶、子女移居国（境）外、从业等事项： 　　（一）本人的婚姻变化情况； 　　（二）本人持有因私出国（境）证件的情况； 　　（三）本人因私出国（境）的情况； 　　（四）子女与外国人、无国籍人通婚的情况； 　　（五）子女与港澳以及台湾居民通婚的情况； 　　（六）配偶、子女移居国（境）外的情况； 　　（七）配偶、子女从业情况，包括配偶、子女在国（境）外从业的情况和职务情况； 　　（八）配偶、子女被司法机关追究刑事责任的情况。 　　第四条　领导干部应当报告下列收入、房产、投资等事项： 　　（一）本人的工资及各类奖金、津贴、补贴； 　　（二）本人从事讲学、写作、咨询、审稿、书画等劳务所得； 　　（三）本人、配偶、共同生活的子女的房产情况； 　　（四）本人、配偶、共同生活的子女投资或者以其他方式持有有价证券、股票（包括股权激励）、期货、基金、投资型保险以及其他金融理财产品的情况； 　　（五）配偶、共同生活的子女投资非上市公司、企业的情况； 　　（六）配偶、共同生活的子女注册个体工商户、个人独资企业或者合伙企业的情况。 　　第五条　领导干部应当于每年1月31日前集中报告一次上一年度本规定第三条、第四条所列事项。 　　第六条　领导干部发生本规定第三条所列事项的，应当在事后30天内填写《领导干部个人有关事项报告表（一）》，并按照规定报告。因特殊原因不能按时报告的，特殊原因消除后应当及时补报，并说明原因。 　　第七条　新任领导干部应当在符合报告条件后30日内按照本规定报告个人有关事项。 　　领导干部辞去公职的，在提出辞职申请时，应当一并报告个人有关事项。 　　第八条　领导干部报告个人有关事项，按照干部管理权限由相应的组织（人事）部门负责受理： 　　（一）中央管理的领导干部向中共中央组织部报告，报告材料由该领导干部所在单位主要负责人审签后，交所在党委（党组）的组织（人事）部门转交。 　　（二）属于本单位管理的领导干部，向本单位的组织（人事）部门报告；不属于本单位管理的领导干部，向上一级党委（党组）的组织（人事）部门报告，报告材料由该领导干部所在单位主要负责人审签后，交所在党委（党组）的组织（人事）部门转交。 　　领导干部因发生职务变动而导致受理机构发生变化的，原受理机构应当及时将该领导干部的报告材料按照干部管理权限转交新的受理机构。 　　第九条　领导干部在执行本规定过程中，认为有需要请示的事项，可以向受理报告的组织（人事）部门请示。 　　请示事项属于具体执行中的问题，受理报告的组织（人事）部门应当认真研究，及时答复报告人；属于本规定的解释问题，受理报告的组织（人事）部门应当按照规定向中共中央纪律检查委员会、中共中央组织部、监察部请示，并按照中共中央纪律检查委员会、中共中央组织部、监察部的意见答复报告人。报告人应当按照组织答复意见办理。 　　第十条　报告人未按时报告的，有关组织（人事）部门应当督促其报告。 　　第十一条　组织（人事）部门、纪检监察机关（机构）根据工作需要，可以对报告情况进行汇总综合，对存在的普遍问题进行专项治理。 　　第十二条　组织（人事）部门在干部监督工作和干部选拔任用工作中，按照干部管理权限，经本机关、本单位主要负责人批准，可以查阅有关领导干部报告个人有关事项的材料。 　　纪检监察机关（机构）在履行职责时，按照干部管理权限，经本机关主要负责人批准，可以查阅有关领导干部报告个人有关事项的材料。 　　检察机关在查办职务犯罪案件时，经本机关、本单位主要负责人批准，可以查阅案件涉及的领导干部报告个人有关事项的材料。 　　第十三条　纪检监察机关（机构）、组织（人事）部门接到有关举报，或者在干部考核考察、巡视等工作中群众对领导干部涉及个人有关事项的问题反映突出的，按照干部管理权限，经纪检监察机关（机构）、组织（人事）部门主要负责人批准，可以对有关领导干部报告个人有关事项的材料进行调查核实。 　　第十四条　受理报告的组织（人事）部门对报告人的报告材料，应当设专人妥善保管。 　　第十五条　纪检监察机关（机构）和组织（人事）部门要加强对本规定执行情况的监督检查。 　　第十六条　领导干部应当按照本规定如实报告个人有关事项，自觉接受监督。 　　第十七条　领导干部有下列情形之一的，根据情节轻重，给予批评教育、限期改正、责令作出检查、诫勉谈话、通报批评或者调整工作岗位、免职等处理；构成违纪的，依照有关规定给予纪律处分： 　　（一）无正当理由不按时报告的； 　　（二）不如实报告的； 　　（三）隐瞒不报的； 　　（四）不按照组织答复意见办理的。 　　不按照规定报告个人有关事项，同时该事项构成另一违纪行为的，依照有关规定进行合并处理。 　　第十八条　本规定第三条第（六）项所称"移居国（境）外"，是指领导干部的配偶、子女获得外国国籍，或者获得国（境）外永久居留权、长期居留许可。 　　本规定第四条所称"共同生活的子女"，是指领导干部的未成年子女和由其抚养的不能独立生活的成年子女。 　　本规定第四条第（三）项所称"房产"，是指领导干部本人、配偶、共同生活的子女为所有权人或者共有人的房屋。 　　第十九条　中共中央纪律检查委员会、中共中央组织部、监察部可以结合工作实际，制定实施细则。 　　第二十条　中央军委可以根据本规定，结合中国人民解放军和中国人民武装警察部队的实际，制定有关规定。 　　第二十一条　各省、自治区、直辖市党委和政府，需要扩大报告主体范围或者细化执行程序的，可以根据本规定，结合各自工作实际，制定具体实施办法，报中共中央纪律检查委员会、中共中央组织部、监察部备案。 　　第二十二条　本规定由中共中央纪律检查委员会、中共中央组织部、监察部负责解释。 　　第二十三条　本规定自发布之日起施行。1995年发布的《关于党政机关县（处）级以上领导干部收入申报的规定》、2006年发布的《关于党员领导干部报告个人有关事项的规定》同时废止。',
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-07-16 10:51:28",
              menuParentId: null,
              searchContent: null,
            },
            {
              createBy: null,
              createTime: null,
              updateBy: null,
              updateTime: "2021-07-16 10:50:14",
              remark: null,
              id: 4158,
              menuId: 2165,
              title: "国有企业领导人员廉洁从业若干规定",
              subtitle: "",
              keywords: "",
              description:
                "（2009年7月1日）第一章　总　则　　第一条　为规范国有企业领导人员廉洁从业行为，加强国有企业反腐倡廉建设，维护国家和出资人利益，促进国有企业科学发展，依据国家有关法律法规和党内法规，制定本规定。　　第二条　本规定适用于国有独资企业、国有控股企业（含国有独资金融企业和国有控股金融企业）及其分支机构的领导班子成员。　　第三条　国有企业领导人员应当遵守国家法律法规和企业规章制度，依法经营、开拓创新、廉洁从...",
              copyFrom: "",
              content:
                "（2009年7月1日） 第一章　总　则 　　第一条　为规范国有企业领导人员廉洁从业行为，加强国有企业反腐倡廉建设，维护国家和出资人利益，促进国有企业科学发展，依据国家有关法律法规和党内法规，制定本规定。 　　第二条　本规定适用于国有独资企业、国有控股企业（含国有独资金融企业和国有控股金融企业）及其分支机构的领导班子成员。 　　第三条　国有企业领导人员应当遵守国家法律法规和企业规章制度，依法经营、开拓创新、廉洁从业、诚实守信，切实维护国家利益、企业利益和职工合法权益，努力实现国有企业又好又快发展。 第二章　廉洁从业行为规范 　　第四条　国有企业领导人员应当切实维护国家和出资人利益。不得有滥用职权、损害国有资产权益的下列行为： 　　（一）违反决策原则和程序决定企业生产经营的重大决策、重要人事任免、重大项目安排及大额度资金运作事项； 　　（二）违反规定办理企业改制、兼并、重组、破产、资产评估、产权交易等事项； 　　（三）违反规定投资、融资、担保、拆借资金、委托理财、为他人代开信用证、购销商品和服务、招标投标等； 　　（四）未经批准或者经批准后未办理保全国有资产的法律手续，以个人或者其他名义用企业资产在国（境）外注册公司、投资入股、购买金融产品、购置不动产或者进行其他经营活动； 　　（五）授意、指使、强令财会人员进行违反国家财经纪律、企业财务制度的活动； 　　（六）未经履行国有资产出资人职责的机构和人事主管部门批准，决定本级领导人员的薪酬和住房补贴等福利待遇； 　　（七）未经企业领导班子集体研究，决定捐赠、赞助事项，或者虽经企业领导班子集体研究但未经履行国有资产出资人职责的机构批准，决定大额捐赠、赞助事项； 　　（八）其他滥用职权、损害国有资产权益的行为。 　　第五条　国有企业领导人员应当忠实履行职责。不得有利用职权谋取私利以及损害本企业利益的下列行为： 　　（一）个人从事营利性经营活动和有偿中介活动，或者在本企业的同类经营企业、关联企业和与本企业有业务关系的企业投资入股； 　　（二）在职或者离职后接受、索取本企业的关联企业、与本企业有业务关系的企业，以及管理和服务对象提供的物质性利益； 　　（三）以明显低于市场的价格向请托人购买或者以明显高于市场的价格向请托人出售房屋、汽车等物品，以及以其他交易形式非法收受请托人财物； 　　（四）委托他人投资证券、期货或者以其他委托理财名义，未实际出资而获取收益，或者虽然实际出资，但获取收益明显高于出资应得收益； 　　（五）利用企业上市或者上市公司并购、重组、定向增发等过程中的内幕消息、商业秘密以及企业的知识产权、业务渠道等无形资产或者资源，为本人或者配偶、子女及其他特定关系人谋取利益； 　　（六）未经批准兼任本企业所出资企业或者其他企业、事业单位、社会团体、中介机构的领导职务，或者经批准兼职的，擅自领取薪酬及其他收入； 　　（七）将企业经济往来中的折扣费、中介费、佣金、礼金，以及因企业行为受到有关部门和单位奖励的财物等据为己有或者私分； 　　（八）其他利用职权谋取私利以及损害本企业利益的行为。 　　第六条　国有企业领导人员应当正确行使经营管理权，防止可能侵害公共利益、企业利益行为的发生。不得有下列行为： 　　（一）本人的配偶、子女及其他特定关系人，在本企业的关联企业、与本企业有业务关系的企业投资入股； 　　（二）将国有资产委托、租赁、承包给配偶、子女及其他特定关系人经营； 　　（三）利用职权为配偶、子女及其他特定关系人从事营利性经营活动提供便利条件； 　　（四）利用职权相互为对方及其配偶、子女和其他特定关系人从事营利性经营活动提供便利条件； 　　（五）本人的配偶、子女及其他特定关系人投资或者经营的企业与本企业或者有出资关系的企业发生可能侵害公共利益、企业利益的经济业务往来； 　　（六）按照规定应当实行任职回避和公务回避而没有回避； 　　（七）离职或者退休后三年内，在与原任职企业有业务关系的私营企业、外资企业和中介机构担任职务、投资入股，或者在上述企业或者机构从事、代理与原任职企业经营业务相关的经营活动； 　　（八）其他可能侵害公共利益、企业利益的行为。 　　第七条　国有企业领导人员应当勤俭节约，依据有关规定进行职务消费。不得有下列行为： 　　（一）超出报履行国有资产出资人职责的机构备案的预算进行职务消费； 　　（二）将履行工作职责以外的费用列入职务消费； 　　（三）在特定关系人经营的场所进行职务消费； 　　（四）不按照规定公开职务消费情况； 　　（五）用公款旅游或者变相旅游； 　　（六）在企业发生非政策性亏损或者拖欠职工工资期间，购买或者更换小汽车、公务包机、装修办公室、添置高档办公设备等； 　　（七）使用信用卡、签单等形式进行职务消费，不提供原始凭证和相应的情况说明； 　　（八）其他违反规定的职务消费以及奢侈浪费行为。 　　第八条　国有企业领导人员应当加强作风建设，注重自身修养，增强社会责任意识，树立良好的公众形象。不得有下列行为： 　　（一）弄虚作假，骗取荣誉、职务、职称、待遇或者其他利益； 　　（二）大办婚丧喜庆事宜，造成不良影响，或者借机敛财； 　　（三）默许、纵容配偶、子女和身边工作人员利用本人的职权和地位从事可能造成不良影响的活动； 　　（四）用公款支付与公务无关的娱乐活动费用； 　　（五）在有正常办公和居住场所的情况下用公款长期包租宾馆； 　　（六）漠视职工正当要求，侵害职工合法权益； 　　（七）从事有悖社会公德的活动。 第三章　实施与监督 　　第九条　国有企业应当依据本规定制定规章制度或者将本规定的要求纳入公司章程，建立健全监督制约机制，保证本规定的贯彻执行。 　　国有企业党委（党组）书记、董事长、总经理为本企业实施本规定的主要责任人。 　　第十条　国有企业领导人员应当将贯彻落实本规定的情况作为民主生活会对照检查、年度述职述廉和职工代表大会民主评议的重要内容，接受监督和民主评议。 　　第十一条　国有企业应当明确决策原则和程序，在规定期限内将生产经营的重大决策、重要人事任免、重大项目安排及大额度资金运作事项的决策情况报告履行国有资产出资人职责的机构，将涉及职工切身利益的事项向职工代表大会报告。 　　需经职工代表大会讨论通过的事项，应当经职工代表大会讨论通过后实施。 　　第十二条　国有企业应当完善以职工代表大会为基本形式的企业民主管理制度，实行厂务公开制度，并报履行国有资产出资人职责的机构备案。 　　第十三条　国有企业应当按照有关规定建立健全职务消费制度，报履行国有资产出资人职责的机构备案，并将职务消费情况作为厂务公开的内容向职工公开。 　　第十四条　国有企业领导人员应当按年度向履行国有资产出资人职责的机构报告兼职、投资入股、国（境）外存款和购置不动产情况，配偶、子女从业和出国（境）定居及有关情况，以及本人认为应当报告的其他事项，并以适当方式在一定范围内公开。 　　第十五条　国有企业应当结合本规定建立领导人员从业承诺制度，规范领导人员从业行为以及离职和退休后的相关行为。 　　第十六条　履行国有资产出资人职责的机构和人事主管部门应当结合实际，完善国有企业领导人员的薪酬管理制度，规范和完善激励和约束机制。 　　第十七条　纪检监察机关、组织人事部门和履行国有资产出资人职责的机构，应当对国有企业领导人员进行经常性的教育和监督。 　　第十八条　履行国有资产出资人职责的机构和审计部门应当依法开展各项审计监督，严格执行国有企业领导人员任期和离任经济责任审计制度，建立健全纪检监察和审计监督工作的协调运行机制。 　　第十九条　各级纪检监察机关、组织人事部门和履行国有资产出资人职责机构的纪检监察机构，应当对所管辖的国有企业领导人员执行本规定的情况进行监督检查。 　　国有企业的纪检监察机构应当结合年度考核，每年对所管辖的国有企业领导人员执行本规定的情况进行监督检查，并作出评估，向企业党组织和上级纪检监察机构报告。 　　对违反本规定行为的检举和控告，有关机构应当及时受理，并作出处理决定或者提出处理建议。 　　对违反本规定行为的检举和控告符合函询条件的，应当按规定进行函询。 　　对检举、控告违反本规定行为的职工进行打击报复的，应当追究相关责任人的责任。 　　第二十条　各级组织人事部门和履行国有资产出资人职责的机构，应当将廉洁从业情况作为对国有企业领导人员考察、考核的重要内容和任免的重要依据。 　　第二十一条　国有企业的监事会应当依照有关规定加强对国有企业领导人员廉洁从业情况的监督。 　　按照本规定第十一条至第十四条向履行国有资产出资人职责的机构报告、备案的事项，应当同时抄报本企业监事会。 第四章　违反规定行为的处理 　　第二十二条　国有企业领导人员违反本规定第二章所列行为规范的，视情节轻重，由有关机构按照管理权限分别给予警示谈话、调离岗位、降职、免职处理。 　　应当追究纪律责任的，除适用前款规定外，视情节轻重，依照国家有关法律法规给予相应的处分。 　　对于其中的共产党员，视情节轻重，依照《中国共产党纪律处分条例》给予相应的党纪处分。 　　涉嫌犯罪的，依法移送司法机关处理。 　　第二十三条　国有企业领导人员受到警示谈话、调离岗位、降职、免职处理的，应当减发或者全部扣发当年的绩效薪金、奖金。 　　第二十四条　国有企业领导人员违反本规定获取的不正当经济利益，应当责令清退；给国有企业造成经济损失的，应当依据国家或者企业的有关规定承担经济赔偿责任。 　　第二十五条　国有企业领导人员违反本规定受到降职处理的，两年内不得担任与其原任职务相当或者高于其原任职务的职务。 　　受到免职处理的，两年内不得担任国有企业的领导职务；因违反国家法律，造成国有资产重大损失被免职的，五年内不得担任国有企业的领导职务。 　　构成犯罪被判处刑罚的，终身不得担任国有企业的领导职务。 第五章　附　则 　　第二十六条　国有企业领导班子成员以外的对国有资产负有经营管理责任的其他人员、国有企业所属事业单位的领导人员参照本规定执行。 　　国有参股企业（含国有参股金融企业）中对国有资产负有经营管理责任的人员参照本规定执行。 　　第二十七条　本规定所称履行国有资产出资人职责的机构，包括作为国有资产出资人代表的各级国有资产监督管理机构、尚未实行政资分开代行出资人职责的政府主管部门和其他机构以及授权经营的母公司。 　　本规定所称特定关系人，是指与国有企业领导人员有近亲属以及其他共同利益关系的人。 　　第二十八条　国务院国资委，各省、自治区、直辖市，可以根据本规定制定实施办法，并报中央纪委、监察部备案。 　　中国银监会、中国证监会、中国保监会，中央管理的国有独资金融企业和国有控股金融企业，可以结合金融行业的实际，制定本规定的补充规定，并报中央纪委、监察部备案。 　　第二十九条　本规定由中央纪委商中央组织部、监察部解释。 　　第三十条　本规定自发布之日起施行。2004年发布的《国有企业领导人员廉洁从业若干规定（试行）》同时废止。 　　现行的其他有关规定，凡与本规定不一致的，依照本规定执行。",
              picture: null,
              officialUrl: null,
              homePageUrl: null,
              homePagePicture: null,
              companyName: null,
              sort: 0,
              isRecommend: 0,
              status: 1,
              recruitStatus: null,
              userName: "admin",
              inputTime: "2021-07-16 10:50:14",
              menuParentId: null,
              searchContent: null,
            },
          ],
        },
      };
      this.loading = false;
      this.menuList =res.data.menuList

      localStorage.setItem("homepageData", JSON.stringify(res.data));
    },
    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    goIndex() {
      this.$router.push({
        path: `/`,
      });
      this.drawer = false;
      this.drawer_right = false;
    },
  },
  watch: {
    $route: {
      handler: function (to) {
        this.path = to.path;

        if (to.path === "/") {
          this.activeIndex2 = "/";
          this.$forceUpdate();
        } else if (to.path === "/partybuildinggarden") {
          this.activeIndex2 = `/publicpage?from=2&id=0`;
          this.$forceUpdate();
        } else {
          this.activeIndex2 = `/publicpage?from=${to.query.from}&id=${to.query.id}`;
        }

        setTimeout(() => {
          if (to.query.from && this.menuList.length > 0) {
            if (to.query.from == "6") {
              this.title = "联系我们";
              this.rightList = [];
            } else {
              this.title =
                this.menuList[to.query.from].children[to.query.id].menuName;
              this.rightList = this.menuList[to.query.from].children;
            }
          } else {
            this.title = "山西万家寨水控水资源有限公司";
          }
        }, 200);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.header {
  // position: relative;
  background: url("../../assets/images/header_bg.jpg") center center no-repeat;

  .navmenu {
    height: 58px;
    //width: 1420px;
    margin: 0 auto;
    display: flex;

    .logo {
      img {
        margin: 10px 0;
      }
    }
    .menu {
      margin: 0 30px;
      :deep(.el-menu-demo) {
        height: 58px;
        border: none;
        .el-menu-item {
          line-height: 58px;
          height: 58px;
          width: 120px;
          text-align: center;
          box-sizing: border-box;
          font-size: 14px;
          border-bottom: 2px solid rgb(168, 0, 0) !important;
        }
        .el-submenu {
          .el-submenu__title {
            line-height: 58px;
            font-size: 14px;
            box-sizing: border-box;
            height: 58px;
            border-bottom: 2px solid rgb(168, 0, 0) !important;
          }
        }
        .showIcon {
          .el-submenu__title {
            .el-icon-arrow-down {
              display: none;
            }
          }
        }
        .is-active {
          border-bottom: none;
          box-sizing: border-box;

          background: url("../../assets/images/nav_bg.png") no-repeat;
          background-position: 40% 65%;
          .el-submenu__title {
            // background-color: rgb(255,233,197) !important;
            background: url("../../assets/images/nav_bg.png") no-repeat;
            background-position: 40% 65%;
            line-height: 58px;
            height: 58px;
            border-bottom: none;
            box-sizing: border-box;
            font-size: 14px;
          }
        }
      }
    }
  }
  .mobile_header {
    background-color: #fff;
    width: 100%;
    height: 120px;
    text-align: center;
    position: relative;
    line-height: 45px;
    font-size: 18px;
    img {
      margin: 14px auto 0;
      width: 135px;
    }
    .navbar_header {
      width: 100%;
      height: 50px;
      background: url("../../assets/images/header_bg.jpg");
      display: flex;
      justify-content: space-between;
      padding: 0 25px;
      box-sizing: border-box;
      .nav_title {
        color: #fee8c4;
        font-size: 18px;
      }
      .nav_right {
        color: #fee8c4;
        font-size: 30px;
        .el-icon-s-fold {
          font-size: 30px;
        }
        .el-icon-s-unfold {
          font-size: 30px;
        }
      }
    }
  }
  :deep(.el-drawer__wrapper) {
    top: 120px;

    .el-drawer__container {
      .el-drawer {
        background-color: #f7f7f7;

        .el-drawer__body {
          background-color: #f7f7f7;
          padding-left: 15px;
          background: url("../../assets/images/header_bg.jpg");
          height: 400px;
          .menu_name {
            padding: 11px 15px 11px 0;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(255, 255, 255, 0.3);
            color: #000;
            font-size: 16px;
            line-height: 20px;
            border-bottom: 1px solid #c8c7cc;
          }
        }
      }
    }
  }
}
</style>
